export default [
    {
        "type": "router",
        "name": "actions",
        "path": "/actions",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getActions",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "brand-not-found",
                                            "location-not-found",
                                            "location-brand-mismatch"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "activity",
        "path": "/activity",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getActivityLogs",
                                        "method": "GET",
                                        "path": "/logs",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "global",
                        "path": "/global",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getGlobalActivityLogs",
                                "method": "GET",
                                "path": "/logs",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getActivityLogs",
                                        "method": "GET",
                                        "path": "/logs",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "ownershipGroups",
                        "path": "/ownership-groups",
                        "children": [
                            {
                                "type": "router",
                                "name": "ownershipGroup",
                                "path": "/{ownershipGroupId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getActivityLogs",
                                        "method": "GET",
                                        "path": "/logs",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "agents",
        "path": "/agents",
        "children": [
            {
                "type": "router",
                "name": "owner",
                "path": "/owner",
                "children": [
                    {
                        "type": "router",
                        "name": "v1",
                        "path": "/v1",
                        "children": [
                            {
                                "type": "router",
                                "name": "chat",
                                "path": "/chat",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "clientError",
                                        "method": "POST",
                                        "path": "/{chatId}/client-error",
                                        "errors": [
                                            "brand-id-missing",
                                            "unauthorized"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "create",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "direct-agent-chat-not-found",
                                            "brand-id-missing",
                                            "missing-user"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "delete",
                                        "method": "DELETE",
                                        "path": "/{chatId}",
                                        "errors": [
                                            "direct-agent-chat-not-found",
                                            "brand-id-missing",
                                            "missing-user"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "get",
                                        "method": "GET",
                                        "path": "/{chatId}",
                                        "errors": [
                                            "direct-agent-chat-not-found",
                                            "brand-id-missing",
                                            "missing-user"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getAll",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "direct-agent-chat-not-found",
                                            "brand-id-missing",
                                            "missing-user"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getFeedback",
                                        "method": "GET",
                                        "path": "/{chatId}/feedback",
                                        "errors": [
                                            "brand-id-missing",
                                            "chat-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getScreenshot",
                                        "method": "GET",
                                        "path": "/screenshots/{assetId}",
                                        "errors": [
                                            "brand-id-missing",
                                            "missing-user"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "postFeedback",
                                        "method": "POST",
                                        "path": "/{chatId}/feedback",
                                        "errors": [
                                            "brand-id-missing",
                                            "chat-not-found",
                                            "conflicting-submission",
                                            "invalid-message"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "sendMessage",
                                        "method": "POST",
                                        "path": "/{chatId}/message",
                                        "errors": [
                                            "direct-agent-chat-not-found",
                                            "brand-id-missing",
                                            "unauthorized",
                                            "feature-disabled",
                                            "already-working",
                                            "awaiting-tool-approval",
                                            "invalid-tool-approval"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "update",
                                        "method": "PATCH",
                                        "path": "/{chatId}",
                                        "errors": [
                                            "direct-agent-chat-not-found",
                                            "brand-id-missing",
                                            "missing-user"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "suggestions",
                                "method": "GET",
                                "path": "/suggestions",
                                "errors": []
                            }
                        ]
                    }
                ],
                "subGroup": "owner-agent"
            }
        ]
    },
    {
        "type": "router",
        "name": "aiPhoneDemo",
        "path": "/ai-phone-demo",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "sessions",
                        "path": "/sessions",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createSession",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "invalid-visitor-phone",
                                    "session-not-found",
                                    "demo-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getSessionState",
                                "method": "POST",
                                "path": "/state",
                                "errors": [
                                    "invalid-visitor-phone",
                                    "session-not-found",
                                    "demo-unavailable"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "appleOnboarding",
        "path": "/apple-onboarding",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "mobileApps",
                                        "path": "/mobile-apps",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "mobileApp",
                                                "path": "/{mobileAppId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "completeStep",
                                                        "method": "POST",
                                                        "path": "/",
                                                        "errors": [
                                                            "mobile-app-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "confirmComplianceAction",
                                                        "method": "POST",
                                                        "path": "/confirm-compliance-action",
                                                        "errors": [
                                                            "mobile-app-not-found",
                                                            "compliance-confirm-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getOnboardingState",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "mobile-app-not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "appStoreMonitoring",
        "path": "/app-store-monitoring",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getLatestSnapshots",
                        "method": "GET",
                        "path": "/snapshots/latest",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getReviewStats",
                        "method": "GET",
                        "path": "/reviews/stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "listReviews",
                        "method": "GET",
                        "path": "/reviews",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "listSnapshots",
                        "method": "GET",
                        "path": "/snapshots",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "atlas",
        "path": "/atlas",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "orders",
                        "path": "/orders",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getAtlasOrder",
                                "method": "GET",
                                "path": "/{orderId}",
                                "errors": [
                                    "order-not-found"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "attribution",
        "path": "/attribution",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "clearAttributionOverrides",
                                        "method": "POST",
                                        "path": "/clear-attribution-overrides",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "auth",
        "path": "/auth",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "enyo",
                        "path": "/enyo",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "exchangeDemoSession",
                                "method": "POST",
                                "path": "/exchange-demo-session",
                                "errors": [
                                    "invalid-token",
                                    "not-ready"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "exchangeToken",
                                "method": "POST",
                                "path": "/exchange-token",
                                "errors": [
                                    "invalid-token",
                                    "report-not-ready",
                                    "report-failed",
                                    "store-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "hermes",
                        "path": "/hermes",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "logout",
                                "method": "POST",
                                "path": "/logout",
                                "errors": [
                                    "invalid-audience"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "hestia",
                        "path": "/hestia",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "completeCredentialSetup",
                                "method": "POST",
                                "path": "/complete-credential-setup",
                                "errors": [
                                    "invalid-token",
                                    "ineligible",
                                    "email-in-use",
                                    "service-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getBrazeToken",
                                "method": "GET",
                                "path": "/braze-token",
                                "errors": [
                                    "braze-disabled"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "login",
                                "method": "POST",
                                "path": "/login",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "logout",
                                "method": "POST",
                                "path": "/logout",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "refreshSession",
                                "method": "POST",
                                "path": "/refresh",
                                "errors": [
                                    "invalid-refresh-token",
                                    "auth-service-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resendOtp",
                                "method": "POST",
                                "path": "/resend-otp",
                                "errors": [
                                    "invalid-session",
                                    "user-not-found",
                                    "invalid-method",
                                    "user-missing-phone",
                                    "user-missing-email",
                                    "auth-service-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resendVerification",
                                "method": "POST",
                                "path": "/resend-verification",
                                "errors": [
                                    "invalid-token",
                                    "user-not-found",
                                    "missing-contact",
                                    "missing-email",
                                    "missing-phone"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resetPassword",
                                "method": "POST",
                                "path": "/reset-password",
                                "errors": [
                                    "invalid-otp"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setInitialPassword",
                                "method": "POST",
                                "path": "/set-initial-password",
                                "errors": [
                                    "password-already-set",
                                    "email-required",
                                    "email-in-use"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startCredentialSetup",
                                "method": "POST",
                                "path": "/start-credential-setup",
                                "errors": [
                                    "service-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startPhoneVerification",
                                "method": "POST",
                                "path": "/start-phone-verification",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "users",
                                "path": "/users",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "user",
                                        "path": "/{userId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "sendLink",
                                                "method": "POST",
                                                "path": "/send-link",
                                                "errors": [
                                                    "user-not-found",
                                                    "missing-email",
                                                    "missing-phone",
                                                    "missing-contact"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyCredentialSetup",
                                "method": "POST",
                                "path": "/verify-credential-setup",
                                "errors": [
                                    "invalid-otp",
                                    "service-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyOtp",
                                "method": "POST",
                                "path": "/verify-otp",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "mercury",
                        "path": "/mercury",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getSession",
                                "method": "POST",
                                "path": "/session",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "login",
                                "method": "POST",
                                "path": "/login",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "logout",
                                "method": "POST",
                                "path": "/logout",
                                "errors": [
                                    "invalid-audience"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "register",
                                "method": "POST",
                                "path": "/register",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "validate",
                                "method": "POST",
                                "path": "/validate",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "verify",
                                "method": "POST",
                                "path": "/verify",
                                "errors": [
                                    "missing-origin"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyProfileComplete",
                                "method": "GET",
                                "path": "/verify-profile-complete",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "stepUp",
                        "path": "/step-up-session",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createStepUpSession",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "not-a-user",
                                    "user-not-found",
                                    "no-contact-info",
                                    "service-error",
                                    "rate-limited"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "session",
                                "path": "/{sessionId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "resendStepUpOtp",
                                        "method": "POST",
                                        "path": "/resend-otp",
                                        "errors": [
                                            "session-not-found",
                                            "cannot-resend",
                                            "service-error",
                                            "rate-limited"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "verifyOtp",
                                        "method": "POST",
                                        "path": "/verify-otp",
                                        "errors": [
                                            "invalid-otp",
                                            "service-error",
                                            "rate-limited"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "dionysus",
                        "path": "/dionysus",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "anonymousLogin",
                                "method": "POST",
                                "path": "/anonymous-login",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "refreshSession",
                                "method": "POST",
                                "path": "/refresh",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "register",
                                "method": "POST",
                                "path": "/register",
                                "errors": [
                                    "invalid-session"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "requestOtp",
                                "method": "POST",
                                "path": "/request-otp",
                                "errors": [
                                    "invalid-phone",
                                    "guest-session-required"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyOtp",
                                "method": "POST",
                                "path": "/verify-otp",
                                "errors": [
                                    "invalid-otp"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "eris",
                        "path": "/eris",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "logout",
                                "method": "POST",
                                "path": "/logout",
                                "errors": [
                                    "invalid-audience"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resendOtp",
                                "method": "POST",
                                "path": "/resend-otp",
                                "errors": [
                                    "invalid-session"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startOtpVerification",
                                "method": "POST",
                                "path": "/start-otp-verification",
                                "errors": [
                                    "no-user-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyOtp",
                                "method": "POST",
                                "path": "/verify-otp",
                                "errors": [
                                    "invalid-session",
                                    "no-growth-brands"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getRolesAndScopes",
                        "method": "GET",
                        "path": "/roles-and-scopes",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "hermes",
                        "path": "/hermes",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "completeCredentialSetup",
                                "method": "POST",
                                "path": "/complete-credential-setup",
                                "errors": [
                                    "invalid-token",
                                    "ineligible",
                                    "email-in-use",
                                    "invalid-origin",
                                    "service-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getBrazeToken",
                                "method": "GET",
                                "path": "/braze-token",
                                "errors": [
                                    "must-be-user",
                                    "braze-disabled"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getIntercomToken",
                                "method": "GET",
                                "path": "/intercom-token",
                                "errors": [
                                    "must-be-user"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "login",
                                "method": "POST",
                                "path": "/login",
                                "errors": [
                                    "invalid-credentials",
                                    "service-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "logout",
                                "method": "POST",
                                "path": "/logout",
                                "errors": [
                                    "invalid-audience"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resendOtp",
                                "method": "POST",
                                "path": "/resend-otp",
                                "errors": [
                                    "invalid-session",
                                    "invalid-origin",
                                    "user-not-found",
                                    "user-missing-phone",
                                    "user-missing-email",
                                    "invalid-method",
                                    "service-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resetPassword",
                                "method": "POST",
                                "path": "/reset-password",
                                "errors": [
                                    "invalid-otp",
                                    "invalid-origin",
                                    "success-but-no-brand-access",
                                    "surface-not-allowed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startCredentialSetup",
                                "method": "POST",
                                "path": "/start-credential-setup",
                                "errors": [
                                    "service-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startPasswordReset",
                                "method": "POST",
                                "path": "/start-password-reset",
                                "errors": [
                                    "user-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyCredentialSetup",
                                "method": "POST",
                                "path": "/verify-credential-setup",
                                "errors": [
                                    "invalid-otp",
                                    "service-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyOtp",
                                "method": "POST",
                                "path": "/verify-otp",
                                "errors": [
                                    "invalid-otp",
                                    "invalid-auth-headers",
                                    "service-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyPasswordResetToken",
                                "method": "GET",
                                "path": "/verify-password-reset",
                                "errors": [
                                    "invalid-otp",
                                    "invalid-auth-headers"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "kitchen",
                        "path": "/kitchen",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "authenticate",
                                "method": "POST",
                                "path": "/authenticate",
                                "errors": [
                                    "invalid-auth-header",
                                    "invalid-location-code"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "authorize",
                                "method": "POST",
                                "path": "/authorize",
                                "errors": [
                                    "invalid-token",
                                    "invalid-device",
                                    "device-type-exists-at-station"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "authorizeStation",
                                "method": "POST",
                                "path": "/authorize-station",
                                "errors": [
                                    "invalid-token",
                                    "invalid-station",
                                    "unauthorized-location"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "provisionDevice",
                                "method": "POST",
                                "path": "/provision-device",
                                "errors": [
                                    "device-registration-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resetCode",
                                "method": "POST",
                                "path": "/reset-code",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "authV0",
        "path": "/auth",
        "children": [
            {
                "type": "endpoint",
                "name": "getSession",
                "method": "POST",
                "path": "/session",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "login",
                "method": "POST",
                "path": "/login",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "multiFactorAuth",
                "method": "POST",
                "path": "/multi-factor-auth",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "refresh",
                "method": "POST",
                "path": "/refresh",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "register",
                "method": "POST",
                "path": "/register",
                "errors": [
                    "email-in-use"
                ]
            },
            {
                "type": "endpoint",
                "name": "verify",
                "method": "POST",
                "path": "/verify",
                "errors": [
                    "invalid-audience",
                    "invalid-payload",
                    "invalid-auth-headers"
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "ava",
        "path": "/ava",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getContextFromPhoneNumber",
                        "method": "GET",
                        "path": "/context-from-phone",
                        "errors": [
                            "user-not-found",
                            "not-brand-user",
                            "brand-count-exceeds-context-limit"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "billing",
        "path": "/billing",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "paymentMethods",
                                        "path": "/payment-methods",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "addPaymentMethod",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPaymentMethods",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getToken",
                                                "method": "GET",
                                                "path": "/token",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "removePaymentMethod",
                                                "method": "DELETE",
                                                "path": "/{paymentMethodId}",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "collections",
                                        "path": "/collections",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "invoices",
                                                "path": "/invoices",
                                                "children": [
                                                    {
                                                        "type": "router",
                                                        "name": "invoice",
                                                        "path": "/{invoiceId}",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "removeFromCollections",
                                                                "method": "DELETE",
                                                                "path": "/",
                                                                "errors": [
                                                                    "invoice-not-found",
                                                                    "invoice-collected"
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "update",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updatePaymentMethod",
                                        "method": "PATCH",
                                        "path": "/payment-method",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateStripeSubscription",
                                        "method": "PATCH",
                                        "path": "/stripe-subscription",
                                        "errors": [
                                            "stripe-customer-mismatch",
                                            "invalid-subscription-product",
                                            "invalid-subscription-price",
                                            "location-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "subscriptions",
                        "path": "/subscriptions",
                        "children": [
                            {
                                "type": "router",
                                "name": "trialCancellationCandidates",
                                "path": "/trial-cancellation-candidates",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getTrialCancellationCandidates",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "paymentMethods",
                                        "path": "/payment-methods",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "create",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "payment-method-not-found",
                                                    "unauthorized-access",
                                                    "invalid-payment-method",
                                                    "card-declined",
                                                    "invalid-cvc",
                                                    "expired-card",
                                                    "payment-not-captured"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getCreationToken",
                                                "method": "GET",
                                                "path": "/token",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "paymentMethod",
                                                "path": "/{paymentMethodId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deletePaymentMethod",
                                                        "method": "DELETE",
                                                        "path": "/",
                                                        "errors": [
                                                            "payment-method-not-found",
                                                            "unauthorized-access"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "update",
                                                        "method": "PUT",
                                                        "path": "/",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "subscriptions",
                                        "path": "/subscriptions",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getActivePlans",
                                                "method": "GET",
                                                "path": "/active-plans",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPastDueSubscriptions",
                                                "method": "GET",
                                                "path": "/past-due",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSubscriptions",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "users",
                                        "path": "/users",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getBillingUsers",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "batchLaunch",
                                "method": "POST",
                                "path": "/batch-launch",
                                "errors": [
                                    "draft-subscription-not-found",
                                    "draft-subscription-invalid-payment-method",
                                    "draft-subscription-invalid-plan",
                                    "draft-subscription-cross-brand",
                                    "subscription-already-exists",
                                    "payment-method-not-found",
                                    "unauthorized-access",
                                    "invalid-payment-method",
                                    "card-declined",
                                    "invalid-cvc",
                                    "expired-card",
                                    "payment-not-captured"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "draftSubscription",
                                        "path": "/draft-subscription",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "launch",
                                                "method": "POST",
                                                "path": "/launch",
                                                "errors": [
                                                    "draft-subscription-not-found",
                                                    "draft-subscription-invalid-payment-method",
                                                    "draft-subscription-invalid-plan",
                                                    "draft-subscription-cross-brand",
                                                    "subscription-already-exists",
                                                    "payment-method-not-found",
                                                    "unauthorized-access",
                                                    "invalid-payment-method",
                                                    "card-declined",
                                                    "invalid-cvc",
                                                    "expired-card",
                                                    "payment-not-captured"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "setPaymentMethod",
                                                "method": "PUT",
                                                "path": "/payment-method",
                                                "errors": [
                                                    "draft-subscription-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "setSelectedOffer",
                                                "method": "PUT",
                                                "path": "/offer",
                                                "errors": [
                                                    "draft-subscription-not-found"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "subscription",
                                        "path": "/subscription",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "cancel",
                                                "method": "POST",
                                                "path": "/cancel",
                                                "errors": [
                                                    "subscription-not-found",
                                                    "payment-method-update-blocked",
                                                    "no-change-required",
                                                    "subscription-changed",
                                                    "payment-method-not-found",
                                                    "unauthorized-access",
                                                    "invalid-payment-method",
                                                    "card-declined",
                                                    "invalid-cvc",
                                                    "expired-card",
                                                    "payment-not-captured"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSubscriptionInfo",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "pause",
                                                "method": "POST",
                                                "path": "/pause",
                                                "errors": [
                                                    "subscription-not-found",
                                                    "payment-method-update-blocked",
                                                    "no-change-required",
                                                    "subscription-changed",
                                                    "payment-method-not-found",
                                                    "unauthorized-access",
                                                    "invalid-payment-method",
                                                    "card-declined",
                                                    "invalid-cvc",
                                                    "expired-card",
                                                    "payment-not-captured"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "setSelectedOffer",
                                                "method": "PUT",
                                                "path": "/offer",
                                                "errors": [
                                                    "subscription-not-found",
                                                    "payment-method-update-blocked",
                                                    "no-change-required",
                                                    "subscription-changed",
                                                    "payment-method-not-found",
                                                    "unauthorized-access",
                                                    "invalid-payment-method",
                                                    "card-declined",
                                                    "invalid-cvc",
                                                    "expired-card",
                                                    "payment-not-captured"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "unpause",
                                                "method": "POST",
                                                "path": "/unpause",
                                                "errors": [
                                                    "subscription-not-found",
                                                    "payment-method-update-blocked",
                                                    "no-change-required",
                                                    "subscription-changed",
                                                    "payment-method-not-found",
                                                    "unauthorized-access",
                                                    "invalid-payment-method",
                                                    "card-declined",
                                                    "invalid-cvc",
                                                    "expired-card",
                                                    "payment-not-captured"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "billingOld",
        "path": "/billing",
        "children": [
            {
                "type": "router",
                "name": "invoice",
                "path": "/invoices",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/{invoiceId}",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getInvoice",
                        "method": "GET",
                        "path": "/{invoiceId}",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getInvoices",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "list",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "refund",
                        "method": "POST",
                        "path": "/refund",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "brands",
        "path": "/brands",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brand",
                        "path": "/{brandId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "updateBrandFeatureToggles",
                                "method": "PUT",
                                "path": "/feature-toggles",
                                "errors": [
                                    "brand-not-found",
                                    "gift-cards-not-included-in-plan"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "virtualCard",
                                "path": "/virtual-card",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "closeCard",
                                        "method": "POST",
                                        "path": "/close",
                                        "errors": [
                                            "card-not-found",
                                            "card-update-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createCard",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "card-already-exists",
                                            "card-creation-failed",
                                            "brand-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCard",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCardDetails",
                                        "method": "GET",
                                        "path": "/details",
                                        "errors": [
                                            "card-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCards",
                                        "method": "GET",
                                        "path": "/all",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getTransactions",
                                        "method": "GET",
                                        "path": "/transactions",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "pauseCard",
                                        "method": "POST",
                                        "path": "/pause",
                                        "errors": [
                                            "card-not-found",
                                            "card-update-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "resumeCard",
                                        "method": "POST",
                                        "path": "/resume",
                                        "errors": [
                                            "card-not-found",
                                            "card-update-failed"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "brandStatus",
        "path": "/brand-status",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getDomainStatus",
                                        "method": "GET",
                                        "path": "/domain",
                                        "errors": [
                                            "workflow-not-applicable"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "workflows",
                                        "path": "/workflows",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "workflow",
                                                "path": "/{workflowName}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getWorkflowBreakdown",
                                                        "method": "GET",
                                                        "path": "/breakdown",
                                                        "errors": [
                                                            "workflow-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "refreshWorkflowBreakdown",
                                                        "method": "POST",
                                                        "path": "/refresh",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "gbpSupport",
                                        "path": "/gbp-support",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getGbpSupportDetails",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "location-not-found",
                                                    "not-correctness-managed"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "runGbpSupportAction",
                                                "method": "POST",
                                                "path": "/actions",
                                                "errors": [
                                                    "action-not-available",
                                                    "disconnect-failed",
                                                    "location-not-found",
                                                    "not-correctness-managed",
                                                    "release-failed"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getLocationStatus",
                                        "method": "GET",
                                        "path": "/status",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "listings",
                                        "path": "/listings",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "confirmPowerListingManualReview",
                                                "method": "POST",
                                                "path": "/power-listing/manual-review",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "earlyPowerListingCheck",
                                                "method": "POST",
                                                "path": "/early-power-listing-check",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "refresh",
                                                "method": "POST",
                                                "path": "/refresh",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "revealBusinessInfoEin",
                                        "method": "GET",
                                        "path": "/business-info/ein-reveal",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "workflows",
                        "path": "/workflows",
                        "children": [
                            {
                                "type": "router",
                                "name": "workflow",
                                "path": "/{workflowName}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "refreshWorkflow",
                                        "method": "POST",
                                        "path": "/refresh",
                                        "errors": [
                                            "workflow-not-found",
                                            "workflow-not-refreshable",
                                            "workflow-not-applicable"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "sendNudge",
                                        "method": "POST",
                                        "path": "/nudge",
                                        "errors": [
                                            "workflow-not-nudgeable",
                                            "no-users-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "brandsV0",
        "path": "/brands",
        "children": [
            {
                "type": "router",
                "name": "brand",
                "path": "/{brandId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "approveBrandSalesTaxSuggestions",
                        "method": "POST",
                        "path": "/sales-tax-suggestions/approve",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "billing",
                        "path": "/billing",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addPaymentMethod",
                                "method": "POST",
                                "path": "/payment-method",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getPaymentMethods",
                                "method": "GET",
                                "path": "/payment-methods",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "removePaymentMethod",
                                "method": "DELETE",
                                "path": "/payment-method",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getBrand",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getBrandLocationStats",
                        "method": "GET",
                        "path": "/stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getBrandSalesTaxSuggestions",
                        "method": "GET",
                        "path": "/sales-tax-suggestions",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getBrandTaxRegistration",
                        "method": "GET",
                        "path": "/tax-registration",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCustomers",
                        "method": "GET",
                        "path": "/customers",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDomain",
                        "method": "GET",
                        "path": "/domain",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMenuSyncs",
                        "method": "GET",
                        "path": "/menu-sync",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMobileApp",
                        "method": "GET",
                        "path": "/mobile-app",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMobileAppAdmin",
                        "method": "GET",
                        "path": "/mobile-app/admin",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMobileAppStatus",
                        "method": "GET",
                        "path": "/mobile-app/status",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getOnlineHealthScore",
                        "method": "GET",
                        "path": "/online-health",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "loyalty",
                        "path": "/loyalty",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getInsights",
                                "method": "GET",
                                "path": "/insights",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getOverview",
                                "method": "GET",
                                "path": "/overview",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "importLoyaltyPoints",
                                "method": "POST",
                                "path": "/import",
                                "errors": [
                                    "too-many-customers"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "mobileApp",
                        "path": "/mobile-app",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getAppStoreReviewStats",
                                "method": "GET",
                                "path": "/app-store/reviews/stats",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getAppStoreSnapshots",
                                "method": "GET",
                                "path": "/app-store/snapshots/latest",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getScreenshots",
                                "method": "GET",
                                "path": "/screenshots",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listAppStoreReviews",
                                "method": "GET",
                                "path": "/app-store/reviews",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setLinks",
                        "method": "PUT",
                        "path": "/links",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "smsMarketing",
                        "path": "/sms-marketing",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "importSmsSubscribers",
                                "method": "POST",
                                "path": "/subscribers",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "resetTwilioBrand",
                                "method": "DELETE",
                                "path": "/twilio",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "theme",
                        "path": "/theme",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "deleteCustomFont",
                                "method": "DELETE",
                                "path": "/custom-font",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getBrandTheme",
                                "method": "GET",
                                "path": "/brand",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getMergedTheme",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "overrides",
                                "path": "/overrides",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "updateBrightnessPalette",
                                        "method": "PATCH",
                                        "path": "/palette",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateOverrides",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "triggerCustomFont",
                                "method": "POST",
                                "path": "/custom-font",
                                "errors": [
                                    "agreement-required"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateBrand",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "website-managed-branding"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateBrandTaxRegistration",
                        "method": "POST",
                        "path": "/tax-registration",
                        "errors": []
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "getBrands",
                "method": "GET",
                "path": "/",
                "errors": [
                    "unscoped-brand-pagination-forbidden"
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "browser",
        "path": "/browser",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1/app-store-maintenance",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "appStoreMaintenanceWorkflowStatus",
                        "method": "POST",
                        "path": "/status",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "runAppStoreMaintenance",
                        "method": "POST",
                        "path": "/run",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "capabilities",
        "path": "/capabilities",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandCapabilities",
                                        "method": "GET",
                                        "path": "/capabilities",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getLocationCapabilities",
                                        "method": "GET",
                                        "path": "/capabilities",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "careers",
        "path": "/careers",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "applications",
                        "path": "/applications",
                        "children": [
                            {
                                "type": "router",
                                "name": "application",
                                "path": "/{applicationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteApplication",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getApplications",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "submitApplication",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "jobs",
                        "path": "/jobs",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createJob",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getJobs",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "job",
                                "path": "/{jobId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteJob",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getJob",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateJob",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "exportApplications",
                                        "method": "GET",
                                        "path": "/export-applications",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "carts",
        "path": "/carts",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "cart",
                        "path": "/{cartId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "updateAmounts",
                                "method": "PATCH",
                                "path": "/amounts",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "demo-account-checkout-blocked"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v3",
                "path": "/v3",
                "children": [
                    {
                        "type": "router",
                        "name": "cart",
                        "path": "/{cartId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addDelivery",
                                "method": "POST",
                                "path": "/delivery",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "addGiftCard",
                                "method": "POST",
                                "path": "/gift-card",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "calculateLocationOptions",
                                "method": "PATCH",
                                "path": "/location-options",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "confirmFulfillmentDetails",
                                "method": "PATCH",
                                "path": "/fulfillment-details",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "experimentalApplyAutomaticFulfillment",
                                "method": "POST",
                                "path": "/experimental-fulfillment",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getAvailableTimes",
                                "method": "GET",
                                "path": "/available-times",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getCart",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getCheckoutStream",
                                "method": "GET",
                                "path": "/checkout-stream",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPosDeliveryQuote",
                                "method": "POST",
                                "path": "/pos-quote",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "demo-account-checkout-blocked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getUpsellRecommendations",
                                "method": "GET",
                                "path": "/recommendations",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "group",
                                "path": "/group",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createSession",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "endSession",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getMyParticipant",
                                        "method": "GET",
                                        "path": "/me",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSession",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getView",
                                        "method": "GET",
                                        "path": "/view",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "leave",
                                        "method": "POST",
                                        "path": "/leave",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "prepareCheckout",
                                        "method": "POST",
                                        "path": "/prepare-checkout",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setSubmitted",
                                        "method": "POST",
                                        "path": "/submit",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSession",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "no-guest-identity",
                                            "group-ordering-unavailable",
                                            "group-session-not-found",
                                            "group-session-corrupted",
                                            "group-session-not-joinable",
                                            "group-session-not-accepting-changes",
                                            "not-cart-owner",
                                            "group-cart-already-ordered",
                                            "not-session-host",
                                            "not-session-participant",
                                            "host-cannot-leave",
                                            "host-cannot-submit",
                                            "invalid-session-transition",
                                            "group-fulfillment-not-orderable",
                                            "deadline-in-past",
                                            "deadline-too-far-out",
                                            "group-session-spend-cap-exceeded",
                                            "group-session-over-cap-cannot-submit"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "removeCoupon",
                                "method": "DELETE",
                                "path": "/coupon",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "removeCustomer",
                                "method": "DELETE",
                                "path": "/customer",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "removeGiftCard",
                                "method": "DELETE",
                                "path": "/gift-card",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "requestLoyaltyRedemptionCode",
                                "method": "POST",
                                "path": "/loyalty-redemption/request",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "saveCartToOrder",
                                "method": "POST",
                                "path": "/save-to-order",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setChannel",
                                "method": "PUT",
                                "path": "/channel",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setComment",
                                "method": "PUT",
                                "path": "/comment",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setCoupon",
                                "method": "PUT",
                                "path": "/coupon",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setCustomer",
                                "method": "PUT",
                                "path": "/customer",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setPaymentMethod",
                                "method": "PUT",
                                "path": "/payment-method",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setPickupTime",
                                "method": "PUT",
                                "path": "/pickup",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setStore",
                                "method": "PUT",
                                "path": "/store",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setUtmAttribution",
                                "method": "PUT",
                                "path": "/utm",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "submitCart",
                                "method": "POST",
                                "path": "/submit",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateAmounts",
                                "method": "PATCH",
                                "path": "/amounts",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateCustomItems",
                                "method": "POST",
                                "path": "/custom-items",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateItems",
                                "method": "POST",
                                "path": "/items",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateRedemptions",
                                "method": "POST",
                                "path": "/redemptions",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "validateFulfillmentDetails",
                                "method": "POST",
                                "path": "/fulfillment-details/validate",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyLocationDeliverability",
                                "method": "PATCH",
                                "path": "/verify-location-deliverability",
                                "errors": [
                                    "cart-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "verifyLoyaltyRedemptionCode",
                                "method": "POST",
                                "path": "/loyalty-redemption/verify",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "createCart",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "alcohol-delivery-not-permitted",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "delivery-tip-too-large",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "order-item-ids-not-unique",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "coupon-invalid-voip-phone-number",
                            "gift-card-charge",
                            "gift-card-not-found",
                            "pickup-ready-too-early",
                            "pay-later-not-supported",
                            "invalid-customer-phone",
                            "customer-name-invalid",
                            "demo-account-checkout-blocked",
                            "address-geocoding-failed",
                            "order-too-large",
                            "item-instructions-not-allowed",
                            "group-item-not-owned",
                            "group-item-stale",
                            "group-spend-cap-exceeded",
                            "group-cart-level-host-only",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "group-session-locked"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "group",
                        "path": "/group",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "join",
                                "method": "POST",
                                "path": "/join",
                                "errors": [
                                    "no-guest-identity",
                                    "group-ordering-unavailable",
                                    "group-session-not-found",
                                    "group-session-corrupted",
                                    "group-session-not-joinable",
                                    "group-session-not-accepting-changes",
                                    "not-cart-owner",
                                    "group-cart-already-ordered",
                                    "not-session-host",
                                    "not-session-participant",
                                    "host-cannot-leave",
                                    "host-cannot-submit",
                                    "invalid-session-transition",
                                    "group-fulfillment-not-orderable",
                                    "deadline-in-past",
                                    "deadline-too-far-out",
                                    "group-session-spend-cap-exceeded",
                                    "group-session-over-cap-cannot-submit"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "preview",
                                "method": "GET",
                                "path": "/preview/{shareToken}",
                                "errors": [
                                    "no-guest-identity",
                                    "group-ordering-unavailable",
                                    "group-session-not-found",
                                    "group-session-corrupted",
                                    "group-session-not-joinable",
                                    "group-session-not-accepting-changes",
                                    "not-cart-owner",
                                    "group-cart-already-ordered",
                                    "not-session-host",
                                    "not-session-participant",
                                    "host-cannot-leave",
                                    "host-cannot-submit",
                                    "invalid-session-transition",
                                    "group-fulfillment-not-orderable",
                                    "deadline-in-past",
                                    "deadline-too-far-out",
                                    "group-session-spend-cap-exceeded",
                                    "group-session-over-cap-cannot-submit"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "location",
                        "path": "/location/{locationId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getOrCreateCart",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v4",
                "path": "/v4",
                "children": [
                    {
                        "type": "router",
                        "name": "cart",
                        "path": "/{cartId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getAvailableTimes",
                                "method": "GET",
                                "path": "/available-times",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "removeTaxExemption",
                                "method": "DELETE",
                                "path": "/tax-exemption",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setTaxExemption",
                                "method": "PUT",
                                "path": "/tax-exemption",
                                "errors": [
                                    "cart-order-mismatch",
                                    "delivery-address-not-serviceable",
                                    "alcohol-delivery-not-permitted",
                                    "delivery-configuration-error",
                                    "delivery-temporarily-unavailable",
                                    "delivery-tip-too-large",
                                    "min-subtotal",
                                    "unavailable-items",
                                    "time-unavailable",
                                    "payment-verification-required",
                                    "modifier-quantity",
                                    "coupon-too-early",
                                    "coupon-too-late",
                                    "coupon-unavailable",
                                    "checkout-unavailable",
                                    "coupon-not-found",
                                    "coupon-conflict",
                                    "coupon-missing-redeemable-items",
                                    "coupon-first-time-only",
                                    "coupon-login-required",
                                    "coupon-missing-required-items",
                                    "coupon-min-total",
                                    "order-exists",
                                    "order-item-ids-not-unique",
                                    "paid-order-exists",
                                    "category-unavailable",
                                    "invalid-audience",
                                    "cart-not-found",
                                    "coupon-invalid-channel",
                                    "coupon-invalid-order-type",
                                    "coupon-invalid-voip-phone-number",
                                    "gift-card-charge",
                                    "gift-card-not-found",
                                    "pickup-ready-too-early",
                                    "pay-later-not-supported",
                                    "invalid-customer-phone",
                                    "customer-name-invalid",
                                    "demo-account-checkout-blocked",
                                    "address-geocoding-failed",
                                    "order-too-large",
                                    "item-instructions-not-allowed",
                                    "group-item-not-owned",
                                    "group-item-stale",
                                    "group-spend-cap-exceeded",
                                    "group-cart-level-host-only",
                                    "group-fulfillment-host-only",
                                    "group-order-host-only-checkout",
                                    "group-session-locked"
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "subGroup": "carts"
    },
    {
        "type": "router",
        "name": "cartsV0",
        "path": "/carts",
        "children": [
            {
                "type": "router",
                "name": "cart",
                "path": "/{cartId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "addDelivery",
                        "method": "POST",
                        "path": "/delivery",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "addGiftCard",
                        "method": "POST",
                        "path": "/gift-card",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getAvailableTimes",
                        "method": "GET",
                        "path": "/available-times",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getCart",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getCheckoutStream",
                        "method": "GET",
                        "path": "/checkout-stream",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getUpsellRecommendations",
                        "method": "GET",
                        "path": "/recommendations",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "removeCoupon",
                        "method": "DELETE",
                        "path": "/coupon",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "removeGiftCard",
                        "method": "DELETE",
                        "path": "/gift-card",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setCoupon",
                        "method": "PUT",
                        "path": "/coupon",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setCustomer",
                        "method": "PUT",
                        "path": "/customer",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setPickupTime",
                        "method": "PUT",
                        "path": "/pickup",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setStore",
                        "method": "PUT",
                        "path": "/store",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setUtmAttribution",
                        "method": "PUT",
                        "path": "/utm",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "submitCart",
                        "method": "POST",
                        "path": "/submit",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateAmounts",
                        "method": "PATCH",
                        "path": "/amounts",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateItems",
                        "method": "POST",
                        "path": "/items",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateRedemptions",
                        "method": "POST",
                        "path": "/redemptions",
                        "errors": [
                            "cart-order-mismatch",
                            "delivery-address-not-serviceable",
                            "delivery-configuration-error",
                            "delivery-temporarily-unavailable",
                            "min-subtotal",
                            "unavailable-items",
                            "time-unavailable",
                            "payment-verification-required",
                            "modifier-quantity",
                            "coupon-too-early",
                            "coupon-too-late",
                            "coupon-unavailable",
                            "checkout-unavailable",
                            "coupon-not-found",
                            "coupon-conflict",
                            "coupon-missing-redeemable-items",
                            "coupon-first-time-only",
                            "coupon-login-required",
                            "coupon-missing-required-items",
                            "coupon-min-total",
                            "order-exists",
                            "paid-order-exists",
                            "category-unavailable",
                            "invalid-audience",
                            "cart-not-found",
                            "coupon-invalid-channel",
                            "coupon-invalid-order-type",
                            "group-fulfillment-host-only",
                            "group-order-host-only-checkout",
                            "demo-account-checkout-blocked"
                        ]
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "createCart",
                "method": "POST",
                "path": "/",
                "errors": [
                    "cart-order-mismatch",
                    "delivery-address-not-serviceable",
                    "delivery-configuration-error",
                    "delivery-temporarily-unavailable",
                    "min-subtotal",
                    "unavailable-items",
                    "time-unavailable",
                    "payment-verification-required",
                    "modifier-quantity",
                    "coupon-too-early",
                    "coupon-too-late",
                    "coupon-unavailable",
                    "checkout-unavailable",
                    "coupon-not-found",
                    "coupon-conflict",
                    "coupon-missing-redeemable-items",
                    "coupon-first-time-only",
                    "coupon-login-required",
                    "coupon-missing-required-items",
                    "coupon-min-total",
                    "order-exists",
                    "paid-order-exists",
                    "category-unavailable",
                    "invalid-audience",
                    "cart-not-found",
                    "coupon-invalid-channel",
                    "coupon-invalid-order-type",
                    "group-fulfillment-host-only",
                    "group-order-host-only-checkout",
                    "demo-account-checkout-blocked"
                ]
            }
        ],
        "subGroup": "carts"
    },
    {
        "type": "router",
        "name": "cashDrawer",
        "path": "/cash-drawer",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "reports",
                        "path": "/reports",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "history",
                                "method": "GET",
                                "path": "/history",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "sessions",
                        "path": "/sessions",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "active",
                                "method": "GET",
                                "path": "/active",
                                "errors": [
                                    "session-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "bulkCreateEvents",
                                "method": "POST",
                                "path": "/events",
                                "errors": [
                                    "session-not-found",
                                    "invalid-operation"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "create",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "session-not-found",
                                    "session-already-open"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getAllSessions",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "historicalImport",
                                "method": "POST",
                                "path": "/historical-import",
                                "errors": [
                                    "invalid-historical-import",
                                    "event-id-collision",
                                    "historical-import-forbidden"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "session",
                                "path": "/{sessionId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "get",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "session-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "categories",
        "path": "/categories",
        "children": [
            {
                "type": "router",
                "name": "category",
                "path": "/{menuItemId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "delete",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteImpact",
                        "method": "GET",
                        "path": "/delete-impact",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getItems",
                        "method": "GET",
                        "path": "/items",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedItems",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedMenus",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifiers",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifierSets",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getUpsellCategories",
                        "method": "GET",
                        "path": "/upsell-categories",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "setAvailability",
                        "method": "PATCH",
                        "path": "/availability",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "update",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "traversal-cycle",
                            "traversal-depth"
                        ]
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "create",
                "method": "POST",
                "path": "/",
                "errors": [
                    "traversal-cycle",
                    "traversal-depth"
                ]
            },
            {
                "type": "endpoint",
                "name": "get",
                "method": "GET",
                "path": "/",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "coupons",
        "path": "/coupons",
        "children": [
            {
                "type": "router",
                "name": "coupon",
                "path": "/{menuItemId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "delete",
                        "method": "DELETE",
                        "path": "/",
                        "errors": [
                            "cannot-delete-managed-coupon-family"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteImpact",
                        "method": "GET",
                        "path": "/delete-impact",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getExcludedCategories",
                        "method": "GET",
                        "path": "/excluded-categories",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getExcludedItems",
                        "method": "GET",
                        "path": "/excluded-items",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPurchaseableCategories",
                        "method": "GET",
                        "path": "/purchaseable-categories",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPurchaseableItems",
                        "method": "GET",
                        "path": "/purchaseable-items",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRedeemableCategories",
                        "method": "GET",
                        "path": "/redeemable-categories",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRedeemableItems",
                        "method": "GET",
                        "path": "/redeemable-items",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "setAvailability",
                        "method": "PATCH",
                        "path": "/availability",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "update",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "traversal-cycle",
                            "traversal-depth"
                        ]
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "create",
                "method": "POST",
                "path": "/",
                "errors": [
                    "traversal-cycle",
                    "traversal-depth"
                ]
            },
            {
                "type": "endpoint",
                "name": "get",
                "method": "GET",
                "path": "/",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "crm",
        "path": "/crm",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "assignments",
                        "path": "/assignments",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createAssignment",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "endAssignment",
                                "method": "DELETE",
                                "path": "/{assignmentId}",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listAssignments",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "invalid"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "listAssignees",
                                        "method": "GET",
                                        "path": "/assignees",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "salesforceLinks",
                                        "method": "GET",
                                        "path": "/salesforce-links",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "users",
                                        "path": "/users",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "user",
                                                "path": "/{userId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "listLocationAssignments",
                                                        "method": "GET",
                                                        "path": "/assignments",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "businessUnits",
                        "path": "/business-units",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addBusinessUnitMember",
                                "method": "POST",
                                "path": "/{businessUnitId}/members",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createBusinessUnit",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "conflict"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listBusinessUnitMembers",
                                "method": "GET",
                                "path": "/{businessUnitId}/members",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listBusinessUnits",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updateBusinessUnit",
                                "method": "PATCH",
                                "path": "/{businessUnitId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateBusinessUnitMember",
                                "method": "PATCH",
                                "path": "/{businessUnitId}/members/{memberId}",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "cases",
                        "path": "/cases",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addCaseNote",
                                "method": "POST",
                                "path": "/{caseId}/notes",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "cancelCase",
                                "method": "POST",
                                "path": "/{caseId}/cancel",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "claimCase",
                                "method": "POST",
                                "path": "/{caseId}/claim",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid",
                                    "claim-conflict"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "completeCase",
                                "method": "POST",
                                "path": "/{caseId}/complete",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createCase",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "deleteCaseNote",
                                "method": "DELETE",
                                "path": "/{caseId}/notes/{noteId}",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "escalateCase",
                                "method": "POST",
                                "path": "/{caseId}/escalate",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getCase",
                                "method": "GET",
                                "path": "/{caseId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "holdCase",
                                "method": "POST",
                                "path": "/{caseId}/hold",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listCaseActivity",
                                "method": "GET",
                                "path": "/{caseId}/activity",
                                "errors": [
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listCases",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "logCaseActivity",
                                "method": "POST",
                                "path": "/{caseId}/activities",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "reintakeCase",
                                "method": "POST",
                                "path": "/{caseId}/reintake",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resumeCase",
                                "method": "POST",
                                "path": "/{caseId}/resume",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setCaseStatus",
                                "method": "PATCH",
                                "path": "/{caseId}/status",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "transferCase",
                                "method": "POST",
                                "path": "/{caseId}/transfer",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "unclaimCase",
                                "method": "POST",
                                "path": "/{caseId}/unclaim",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateCaseLaunchDetails",
                                "method": "PATCH",
                                "path": "/{caseId}/launch-details",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateCaseNote",
                                "method": "PATCH",
                                "path": "/{caseId}/notes/{noteId}",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "contacts",
                        "path": "/contacts",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addContactAffiliation",
                                "method": "POST",
                                "path": "/{contactId}/affiliations",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "party-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createContact",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "conflict",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "endContactAffiliation",
                                "method": "DELETE",
                                "path": "/{contactId}/affiliations/{affiliationId}",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getContact",
                                "method": "GET",
                                "path": "/{contactId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listContacts",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateContact",
                                "method": "PATCH",
                                "path": "/{contactId}",
                                "errors": [
                                    "conflict",
                                    "invalid",
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "leads",
                        "path": "/leads",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addLeadContact",
                                "method": "POST",
                                "path": "/{leadId}/contacts",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "contact-not-found"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "admin",
                                "path": "/admin",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "contacts",
                                        "path": "/contacts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getGraph",
                                                "method": "GET",
                                                "path": "/{contactId}/graph",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "paginate",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "groups",
                                        "path": "/groups",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "paginate",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "growth",
                                        "path": "/growth",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "paginate",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "submissions",
                                        "path": "/submissions",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getTrace",
                                                "method": "GET",
                                                "path": "/{submissionId}/trace",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "paginate",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "claimLead",
                                "method": "POST",
                                "path": "/{leadId}/claim",
                                "errors": [
                                    "not-found",
                                    "claim-conflict",
                                    "lead-not-open"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "convertLead",
                                "method": "POST",
                                "path": "/{leadId}/convert",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "not-convertible"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "endLeadContact",
                                "method": "DELETE",
                                "path": "/{leadId}/contacts/{contactId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getLead",
                                "method": "GET",
                                "path": "/{leadId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listLeads",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "qualify",
                                "method": "POST",
                                "path": "/qualify",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "qualifyCosell",
                                "method": "POST",
                                "path": "/qualify/cosell",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "qualifyExternal",
                                "method": "POST",
                                "path": "/qualify/external",
                                "errors": [
                                    "invalid-signature",
                                    "missing-identity"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "qualifyUemPartner",
                                "method": "POST",
                                "path": "/qualify/uem-partner",
                                "errors": [
                                    "invalid-signature"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setLeadStatus",
                                "method": "PATCH",
                                "path": "/{leadId}/status",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "submit",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "unclaimLead",
                                "method": "POST",
                                "path": "/{leadId}/unclaim",
                                "errors": [
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "listAssignees",
                                        "method": "GET",
                                        "path": "/assignees",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "opportunities",
                        "path": "/opportunities",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addOpportunityLocation",
                                "method": "POST",
                                "path": "/{opportunityId}/locations",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "closeOpportunity",
                                "method": "POST",
                                "path": "/{opportunityId}/close",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createOpportunity",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "duplicate-open"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "endOpportunityAssignment",
                                "method": "POST",
                                "path": "/{opportunityId}/assignments/end",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getOpportunity",
                                "method": "GET",
                                "path": "/{opportunityId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "linkOpportunityQuote",
                                "method": "POST",
                                "path": "/{opportunityId}/quotes",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listOpportunities",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listOpportunityActivity",
                                "method": "GET",
                                "path": "/{opportunityId}/activity",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listOpportunityReviews",
                                "method": "GET",
                                "path": "/reviews",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "patchOpportunity",
                                "method": "PATCH",
                                "path": "/{opportunityId}",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "putOpportunityAssignment",
                                "method": "PUT",
                                "path": "/{opportunityId}/assignments/{crmFunction}",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "recordOpportunityDemoHeld",
                                "method": "POST",
                                "path": "/{opportunityId}/demo-held",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "removeOpportunityLocation",
                                "method": "DELETE",
                                "path": "/{opportunityId}/locations/{locationId}",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "reopenOpportunity",
                                "method": "POST",
                                "path": "/{opportunityId}/reopen",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resolveOpportunityAccountScope",
                                "method": "PATCH",
                                "path": "/{opportunityId}/account-scope",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resolveOpportunityReview",
                                "method": "PATCH",
                                "path": "/reviews/{workItemId}",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setOpportunityMilestone",
                                "method": "POST",
                                "path": "/{opportunityId}/milestone",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "outboundLeadBatches",
                        "path": "/outbound-lead-batches",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createOutboundLeadBatch",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "invalid-signature",
                                    "feature-disabled",
                                    "idempotency-conflict",
                                    "temporal-unavailable"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "partnerReps",
                        "path": "/partner-reps",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "assignPartnerRepStore",
                                "method": "POST",
                                "path": "/{repId}/assignments",
                                "errors": [
                                    "rep-not-found",
                                    "location-not-found",
                                    "location-has-no-uber-store-id",
                                    "location-uber-store-id-mismatch",
                                    "store-already-linked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createPartnerRep",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "rep-exists",
                                    "invalid-rep-email",
                                    "manager-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "deleteUberBookingRoute",
                                "method": "DELETE",
                                "path": "/uber-booking-routes/{routeId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "endPartnerRepAssignment",
                                "method": "DELETE",
                                "path": "/{repId}/assignments/{assignmentId}",
                                "errors": [
                                    "rep-not-found",
                                    "assignment-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPartnerRep",
                                "method": "GET",
                                "path": "/{repId}",
                                "errors": [
                                    "rep-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listUberBookingRoutes",
                                "method": "GET",
                                "path": "/uber-booking-routes",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "paginatePartnerRepLeads",
                                "method": "GET",
                                "path": "/{repId}/leads",
                                "errors": [
                                    "rep-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "paginatePartnerReps",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "paginatePartnerRepStores",
                                "method": "GET",
                                "path": "/{repId}/stores",
                                "errors": [
                                    "rep-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "provisionPartnerRep",
                                "method": "POST",
                                "path": "/{repId}/provision",
                                "errors": [
                                    "rep-not-found",
                                    "invalid-rep-email"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "saveUberBookingRoute",
                                "method": "PUT",
                                "path": "/uber-booking-routes",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "sendPartnerRepPasswordReset",
                                "method": "POST",
                                "path": "/{repId}/password-reset",
                                "errors": [
                                    "rep-not-found",
                                    "rep-not-provisioned"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updatePartnerRep",
                                "method": "PATCH",
                                "path": "/{repId}",
                                "errors": [
                                    "rep-not-found",
                                    "manager-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "partnerStores",
                        "path": "/partner-stores",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createPartnerStore",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "rep-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPartnerStore",
                                "method": "GET",
                                "path": "/{storeId}",
                                "errors": [
                                    "store-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "routing",
                        "path": "/routing",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "previewNextLead",
                                "method": "GET",
                                "path": "/next-lead",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "routingConfig",
                        "path": "/routing-config",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createRoutingPool",
                                "method": "POST",
                                "path": "/pools",
                                "errors": [
                                    "conflict",
                                    "unknown-fallback"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createRoutingTag",
                                "method": "POST",
                                "path": "/tags",
                                "errors": [
                                    "conflict"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listRepCapabilityAssignments",
                                "method": "GET",
                                "path": "/rep-capabilities",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listRoutingPools",
                                "method": "GET",
                                "path": "/pools",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listRoutingTags",
                                "method": "GET",
                                "path": "/tags",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "replaceRepCapabilityAssignments",
                                "method": "PUT",
                                "path": "/rep-capabilities/{userId}",
                                "errors": [
                                    "unknown-reference"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setPoolRequirements",
                                "method": "PUT",
                                "path": "/pools/{poolId}/requirements",
                                "errors": [
                                    "not-found",
                                    "unknown-tag"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateRoutingPool",
                                "method": "PATCH",
                                "path": "/pools/{poolId}",
                                "errors": [
                                    "not-found",
                                    "unknown-fallback"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "tickets",
                        "path": "/tickets",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "applyTicketFact",
                                "method": "POST",
                                "path": "/facts",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "blockTicket",
                                "method": "POST",
                                "path": "/{ticketId}/block",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "cancelTicket",
                                "method": "POST",
                                "path": "/{ticketId}/cancel",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "claimTicket",
                                "method": "POST",
                                "path": "/{ticketId}/claim",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "completeTicket",
                                "method": "POST",
                                "path": "/{ticketId}/complete",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createTicket",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getTicket",
                                "method": "GET",
                                "path": "/{ticketId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listTickets",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listTicketTypes",
                                "method": "GET",
                                "path": "/types",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "reassignTicket",
                                "method": "POST",
                                "path": "/{ticketId}/reassign",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "reopenTicket",
                                "method": "POST",
                                "path": "/{ticketId}/reopen",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "unblockTicket",
                                "method": "POST",
                                "path": "/{ticketId}/unblock",
                                "errors": [
                                    "conflict",
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateTicketMetadata",
                                "method": "PATCH",
                                "path": "/{ticketId}/metadata",
                                "errors": [
                                    "conflict",
                                    "not-found",
                                    "invalid"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "uber",
                        "path": "/uber",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getLeaderboard",
                                "method": "GET",
                                "path": "/leaderboard",
                                "errors": [
                                    "no-user-session",
                                    "forbidden-role",
                                    "not-a-partner-rep",
                                    "not-a-partner-manager",
                                    "dashboard-disabled"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getMyBook",
                                "method": "GET",
                                "path": "/me/book",
                                "errors": [
                                    "no-user-session",
                                    "forbidden-role",
                                    "not-a-partner-rep",
                                    "not-a-partner-manager",
                                    "dashboard-disabled"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getTeam",
                                "method": "GET",
                                "path": "/team",
                                "errors": [
                                    "no-user-session",
                                    "forbidden-role",
                                    "not-a-partner-rep",
                                    "not-a-partner-manager",
                                    "dashboard-disabled"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getTeamRepBook",
                                "method": "GET",
                                "path": "/team/{repId}/book",
                                "errors": [
                                    "no-user-session",
                                    "forbidden-role",
                                    "not-a-partner-rep",
                                    "not-a-partner-manager",
                                    "dashboard-disabled",
                                    "rep-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "users",
                        "path": "/users",
                        "children": [
                            {
                                "type": "router",
                                "name": "user",
                                "path": "/{userId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "assignToBrand",
                                        "method": "POST",
                                        "path": "/assignments",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "assignToLocation",
                                        "method": "POST",
                                        "path": "/locations",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "brands",
                                        "path": "/brands",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "brand",
                                                "path": "/{brandId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "unassignFromBrand",
                                                        "method": "DELETE",
                                                        "path": "/assignment",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listBrandAssignments",
                                        "method": "GET",
                                        "path": "/brands",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listLocations",
                                        "method": "GET",
                                        "path": "/locations",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateAssignment",
                                        "method": "PATCH",
                                        "path": "/assignments",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "customer",
        "path": "/customer",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "customers",
                                        "path": "/customers",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "loyalty",
                                        "path": "/loyalty",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "hang",
                                                "path": "/hang",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getOnboardingStatus",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "router",
                                                        "name": "imports",
                                                        "path": "/imports",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "cancelHangLoyaltyImport",
                                                                "method": "POST",
                                                                "path": "/{jobId}/cancel",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getHangLoyaltyImportJob",
                                                                "method": "GET",
                                                                "path": "/{jobId}",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getHangLoyaltyImportValidationErrors",
                                                                "method": "GET",
                                                                "path": "/{jobId}/validation-errors",
                                                                "errors": [],
                                                                "responseType": "arraybuffer"
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "listHangLoyaltyImports",
                                                                "method": "GET",
                                                                "path": "/",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "startHangLoyaltyImport",
                                                                "method": "POST",
                                                                "path": "/",
                                                                "errors": [
                                                                    "not-onboarded",
                                                                    "offboarded",
                                                                    "not-provisioned",
                                                                    "claim-flag-off",
                                                                    "import-disabled",
                                                                    "already-running"
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "offboard",
                                                        "method": "POST",
                                                        "path": "/offboard",
                                                        "errors": [
                                                            "not-onboarded",
                                                            "not-live"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "onboard",
                                                        "method": "POST",
                                                        "path": "/onboard",
                                                        "errors": [
                                                            "brand-not-found",
                                                            "loyalty-disabled",
                                                            "already-onboarding",
                                                            "pos-account-mismatch",
                                                            "offboarded",
                                                            "workflow-start-failed"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "setPointsReadSource",
                                                        "method": "POST",
                                                        "path": "/points-read-source",
                                                        "errors": [
                                                            "not-onboarded",
                                                            "not-live",
                                                            "backfill-incomplete",
                                                            "writes-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "setPosSteps",
                                                        "method": "POST",
                                                        "path": "/pos-steps",
                                                        "errors": [
                                                            "not-onboarded",
                                                            "offboarded",
                                                            "import-not-attested"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "setRedemptionSettings",
                                                        "method": "POST",
                                                        "path": "/redemption-settings",
                                                        "errors": [
                                                            "not-onboarded",
                                                            "offboarded"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "customers",
                        "path": "/customers",
                        "children": [
                            {
                                "type": "router",
                                "name": "customer",
                                "path": "/{customerId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "addresses",
                                        "path": "/addresses",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "create",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "destroy",
                                                "method": "DELETE",
                                                "path": "/{addressId}",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "setDefault",
                                                "method": "PUT",
                                                "path": "/set-default",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "PUT",
                                                "path": "/{addressId}",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "brands",
                                        "path": "/brands",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "brand",
                                                "path": "/{brandId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getBrandCustomer",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "router",
                                                        "name": "mercury",
                                                        "path": "/mercury",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "populateCustomerState",
                                                                "method": "GET",
                                                                "path": "/",
                                                                "errors": [
                                                                    "not-found"
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "orders",
                                        "path": "/orders",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getBrandCustomersAcrossBrands",
                                "method": "GET",
                                "path": "/brand-customers",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getLocationCustomersAcrossLocations",
                                "method": "GET",
                                "path": "/location-customers",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "customerImportAsync",
                                        "path": "/customer-import-async",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "cancelImport",
                                                "method": "POST",
                                                "path": "/{jobId}/cancel",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getImportJobStatus",
                                                "method": "GET",
                                                "path": "/{jobId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getInProgressImport",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "startAsyncImport",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "importCustomers",
                                        "method": "POST",
                                        "path": "/customer-import",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "customers",
        "path": "/customers",
        "children": [
            {
                "type": "endpoint",
                "name": "createCustomer",
                "method": "POST",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "customer",
                "path": "/{customerId}",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "awardBrandLoyaltyPoints",
                                        "method": "POST",
                                        "path": "/award-points",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandLoyaltyPoints",
                                        "method": "GET",
                                        "path": "/points",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCustomerAwards",
                                        "method": "GET",
                                        "path": "/awards",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCustomerRedemptions",
                                        "method": "GET",
                                        "path": "/redemptions",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getFCMToken",
                                        "method": "GET",
                                        "path": "/fcm-token",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSubscriptions",
                                        "method": "GET",
                                        "path": "/subscriptions",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "implicitOptIn",
                                        "method": "PUT",
                                        "path": "/implicit-opt-in",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listUnsubscribe",
                                        "method": "POST",
                                        "path": "/unsubscribe",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "redeemBrandLoyaltyPoints",
                                        "method": "POST",
                                        "path": "/redeem-points",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "removeFCMToken",
                                        "method": "DELETE",
                                        "path": "/fcm-token",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setFCMToken",
                                        "method": "POST",
                                        "path": "/fcm-token",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setSource",
                                        "method": "POST",
                                        "path": "/source",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setSubscriptions",
                                        "method": "PUT",
                                        "path": "/subscriptions",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "unsubscribe",
                                        "method": "GET",
                                        "path": "/unsubscribe",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteCustomer",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCustomer",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCustomerLikes",
                        "method": "GET",
                        "path": "/likes",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPaymentMethods",
                        "method": "GET",
                        "path": "/payment-methods",
                        "errors": [
                            "payment-processor-account-not-found",
                            "payment-processing-restricted",
                            "payment-processor-error"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "connect",
                                        "method": "POST",
                                        "path": "/connect",
                                        "errors": [
                                            "unauthorized"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCoupons",
                                        "method": "GET",
                                        "path": "/coupons",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPastOrderItems",
                                        "method": "GET",
                                        "path": "/past-order-items",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPaymentMethods",
                                        "method": "GET",
                                        "path": "/payment-methods",
                                        "errors": [
                                            "payment-processor-account-not-found",
                                            "payment-processing-restricted",
                                            "payment-processor-error"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getReferral",
                                        "method": "GET",
                                        "path": "/referral",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "putPaymentMethods",
                                        "method": "PUT",
                                        "path": "/payment-methods",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "putPaymentMethods",
                        "method": "PUT",
                        "path": "/payment-methods",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updateCustomer",
                        "method": "PATCH",
                        "path": "/",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "dashboard",
        "path": "/dashboard",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "campaigns",
                                        "path": "/campaigns",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "checkOTCSmsLimits",
                                                "method": "GET",
                                                "path": "/otc-sms-limits",
                                                "errors": [
                                                    "could-not-check-sms-limits",
                                                    "invalid-location",
                                                    "location-brand-mismatch"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "careers",
                                        "path": "/careers",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getApplications",
                                                "method": "GET",
                                                "path": "/applications",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getJobs",
                                                "method": "GET",
                                                "path": "/jobs",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "forms",
                                        "path": "/forms",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getFormData",
                                                "method": "GET",
                                                "path": "/{formId}",
                                                "errors": [
                                                    "theme-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getForms",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "oneschema",
                                        "path": "/oneschema",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "generateOneSchemaToken",
                                                "method": "GET",
                                                "path": "/token",
                                                "errors": [
                                                    "configuration-error",
                                                    "token-creation-failed"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getUploadedFileAnalysis",
                                                "method": "POST",
                                                "path": "/uploaded-file-analysis",
                                                "errors": [
                                                    "embed-not-found",
                                                    "embed-ownership-forbidden",
                                                    "api-forbidden",
                                                    "configuration-error",
                                                    "csv-analysis-failed",
                                                    "invalid-file-url"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "website",
                                        "path": "/website",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getNavItems",
                                                "method": "GET",
                                                "path": "/nav-items",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "pages",
                                                "path": "/pages",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getPageData",
                                                        "method": "GET",
                                                        "path": "/{pageId}",
                                                        "errors": [
                                                            "theme-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getPageDataByPath",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "page-not-found",
                                                            "theme-not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "bugReport",
                        "method": "POST",
                        "path": "/bug-report",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "campaigns",
                        "path": "/campaigns",
                        "children": [
                            {
                                "type": "router",
                                "name": "campaign",
                                "path": "/{campaignId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getSortedBlocks",
                                        "method": "GET",
                                        "path": "/blocks",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "viewStats",
                                        "method": "GET",
                                        "path": "/view-stats",
                                        "errors": [
                                            "invalid-campaign",
                                            "no-locations"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "careers",
                        "path": "/careers",
                        "children": [
                            {
                                "type": "router",
                                "name": "applications",
                                "path": "/applications",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getApplication",
                                        "method": "GET",
                                        "path": "/{applicationId}",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "woflow",
                                        "path": "/woflow",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createWoflowMenuSync",
                                                "method": "POST",
                                                "path": "/menu-sync",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "generateWoflowToken",
                                                "method": "GET",
                                                "path": "/token",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "menu",
                        "path": "/menu",
                        "children": [
                            {
                                "type": "router",
                                "name": "categories",
                                "path": "/categories",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "bulkDelete",
                                        "method": "POST",
                                        "path": "/bulk-delete",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandCategory",
                                        "method": "GET",
                                        "path": "/{brandResourceId}/location/{locationId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCategory",
                                        "method": "GET",
                                        "path": "/{resourceId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "coupons",
                                "path": "/coupons",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandCoupon",
                                        "method": "GET",
                                        "path": "/{brandResourceId}/location/{locationId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCoupon",
                                        "method": "GET",
                                        "path": "/{resourceId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "items",
                                "path": "/items",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "bulkDelete",
                                        "method": "POST",
                                        "path": "/bulk-delete",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandItem",
                                        "method": "GET",
                                        "path": "/{brandResourceId}/location/{locationId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getItem",
                                        "method": "GET",
                                        "path": "/{resourceId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getItems",
                                        "method": "POST",
                                        "path": "/batch",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "menus",
                                "path": "/menus",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandMenu",
                                        "method": "GET",
                                        "path": "/{brandResourceId}/location/{locationId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getMenu",
                                        "method": "GET",
                                        "path": "/{resourceId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "modifiers",
                                "path": "/modifiers",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "bulkDelete",
                                        "method": "POST",
                                        "path": "/bulk-delete",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandModifier",
                                        "method": "GET",
                                        "path": "/{brandResourceId}/location/{locationId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getModifier",
                                        "method": "GET",
                                        "path": "/{resourceId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "modifierSets",
                                "path": "/modifier-sets",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "bulkDelete",
                                        "method": "POST",
                                        "path": "/bulk-delete",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandModifierSet",
                                        "method": "GET",
                                        "path": "/{brandResourceId}/location/{locationId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getModifierSet",
                                        "method": "GET",
                                        "path": "/{resourceId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "presentational",
                                "path": "/presentational",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "undoItemDeduplication",
                                        "method": "POST",
                                        "path": "/undo-item-deduplication",
                                        "errors": [
                                            "items-not-found"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "scoutMenuReconciliation",
                                "path": "/scout-menu-reconciliation",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "byMenuId",
                                        "path": "/{menuId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "startScoutMenuReconciliation",
                                                "method": "POST",
                                                "path": "/start",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getScoutMenuReconciliationReport",
                                        "method": "GET",
                                        "path": "/brand/{brandId}/{id}/report",
                                        "errors": [
                                            "reconciliation-not-found",
                                            "report-not-ready",
                                            "report-missing",
                                            "reconciliation-failed",
                                            "report-retrieval-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listEligibleMenus",
                                        "method": "GET",
                                        "path": "/eligible-menus/brand/{brandId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listScoutMenuReconciliations",
                                        "method": "GET",
                                        "path": "/brand/{brandId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "snapshots",
                                "path": "/snapshots",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "bySnapshotId",
                                        "path": "/{snapshotId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "executeRestore",
                                                "method": "POST",
                                                "path": "/restore",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "generatePlan",
                                                "method": "POST",
                                                "path": "/plan",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "restore",
                                        "path": "/restore",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "byWorkflowId",
                                                "path": "/{workflowId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getRestoreStatus",
                                                        "method": "GET",
                                                        "path": "/status",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "virtual",
                                "path": "/virtual",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "undoAddition",
                                        "method": "POST",
                                        "path": "/undo-addition",
                                        "errors": [
                                            "modifier-set-not-found",
                                            "invalid-modifier-set"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "undoConsolidation",
                                        "method": "POST",
                                        "path": "/undo-consolidation",
                                        "errors": [
                                            "item-not-found",
                                            "invalid-item",
                                            "modifier-set-not-found",
                                            "source-items-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "undoSplit",
                                        "method": "POST",
                                        "path": "/undo-split",
                                        "errors": [
                                            "modifier-set-not-found",
                                            "invalid-modifier-set"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "mfaDiagnostics",
                        "path": "/mfa-diagnostics",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getMfaDiagnostics",
                                "method": "GET",
                                "path": "/diagnostics",
                                "errors": [
                                    "user-not-found",
                                    "no-search-criteria"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "revealOtpCode",
                                "method": "POST",
                                "path": "/reveal-otp-code",
                                "errors": [
                                    "token-not-found",
                                    "user-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "submitQuestion",
                        "method": "POST",
                        "path": "/submit-question",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createLocationAndSubscription",
                                        "method": "POST",
                                        "path": "/locations",
                                        "errors": [
                                            "payment-failed",
                                            "payment-processing-error",
                                            "invalid-coupon-code",
                                            "location-country-mismatch",
                                            "invalid-address",
                                            "unsupported-region"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "home",
                                        "path": "/home",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getGuestData",
                                                "method": "GET",
                                                "path": "/get-guest-data",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getOrderData",
                                                "method": "GET",
                                                "path": "/get-order-data",
                                                "errors": [
                                                    "brand-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSalesData",
                                                "method": "GET",
                                                "path": "/get-sales-data",
                                                "errors": [
                                                    "brand-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSEOData",
                                                "method": "GET",
                                                "path": "/get-seo-data",
                                                "errors": [
                                                    "brand-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getWebsiteData",
                                                "method": "GET",
                                                "path": "/get-website-data",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "submitQuickbooksInterest",
                        "method": "POST",
                        "path": "/submit-quickbooks-interest",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "v3",
                "path": "/v3",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "core",
                                        "method": "GET",
                                        "path": "/core",
                                        "errors": [
                                            "brand-not-found",
                                            "no-user-session-active",
                                            "theme-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "delivery",
        "path": "/delivery",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "carts",
                        "path": "/carts",
                        "children": [
                            {
                                "type": "router",
                                "name": "cart",
                                "path": "/{cartId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getDeliveryInfo",
                                        "method": "GET",
                                        "path": "/delivery-info",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getDeliverableForAddress",
                                "method": "GET",
                                "path": "/deliverable",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getLocationOptionsForAddress",
                                "method": "POST",
                                "path": "/location-options",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getStatuses",
                                "method": "GET",
                                "path": "/statuses",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getDeliveryMap",
                                        "method": "GET",
                                        "path": "/delivery-map",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getDeliverySettings",
                                        "method": "GET",
                                        "path": "/settings",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPosDeliveryQuote",
                                        "method": "POST",
                                        "path": "/pos-quote",
                                        "errors": [
                                            "cart-order-mismatch",
                                            "delivery-address-not-serviceable",
                                            "alcohol-delivery-not-permitted",
                                            "delivery-configuration-error",
                                            "delivery-temporarily-unavailable",
                                            "delivery-tip-too-large",
                                            "min-subtotal",
                                            "unavailable-items",
                                            "time-unavailable",
                                            "payment-verification-required",
                                            "modifier-quantity",
                                            "coupon-too-early",
                                            "coupon-too-late",
                                            "coupon-unavailable",
                                            "checkout-unavailable",
                                            "coupon-not-found",
                                            "coupon-conflict",
                                            "coupon-missing-redeemable-items",
                                            "coupon-first-time-only",
                                            "coupon-login-required",
                                            "coupon-missing-required-items",
                                            "coupon-min-total",
                                            "order-exists",
                                            "order-item-ids-not-unique",
                                            "paid-order-exists",
                                            "category-unavailable",
                                            "invalid-audience",
                                            "cart-not-found",
                                            "coupon-invalid-channel",
                                            "coupon-invalid-order-type",
                                            "coupon-invalid-voip-phone-number",
                                            "gift-card-charge",
                                            "gift-card-not-found",
                                            "pickup-ready-too-early",
                                            "pay-later-not-supported",
                                            "invalid-customer-phone",
                                            "customer-name-invalid",
                                            "demo-account-checkout-blocked",
                                            "address-geocoding-failed",
                                            "order-too-large",
                                            "item-instructions-not-allowed",
                                            "group-item-not-owned",
                                            "group-item-stale",
                                            "group-spend-cap-exceeded",
                                            "group-cart-level-host-only",
                                            "group-fulfillment-host-only",
                                            "group-order-host-only-checkout",
                                            "group-session-locked"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateDeliverySettings",
                                        "method": "PATCH",
                                        "path": "/settings",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "devices",
        "path": "/devices",
        "children": [
            {
                "type": "endpoint",
                "name": "createDevice",
                "method": "POST",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "device",
                "path": "/{deviceId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getDevice",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDeviceCode",
                        "method": "GET",
                        "path": "/code",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "resetDeviceCode",
                        "method": "PATCH",
                        "path": "/code",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updateDevice",
                        "method": "PATCH",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "getDevices",
                "method": "GET",
                "path": "/",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "domain",
        "path": "/domains",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "completeSetup",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "domain-in-use",
                                            "dns-records-not-updated"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "connectDnsDomain",
                                        "method": "POST",
                                        "path": "/connect-dns",
                                        "errors": [
                                            "domain-in-use",
                                            "transfer-already-owner-hosted",
                                            "create-domain-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "connectDomain",
                                        "method": "POST",
                                        "path": "/connect",
                                        "errors": [
                                            "domain-in-use",
                                            "transfer-already-owner-hosted",
                                            "provision-failed",
                                            "verification-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getDomain",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPrepareDomainStatus",
                                        "method": "GET",
                                        "path": "/prepare/{jobId}",
                                        "errors": [
                                            "job-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getWebsiteDomain",
                                        "method": "GET",
                                        "path": "/website",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "parseZoneFile",
                                        "method": "POST",
                                        "path": "/parse-zone-file",
                                        "errors": [
                                            "empty-content",
                                            "no-records-parsed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "prepareDomainAsync",
                                        "method": "POST",
                                        "path": "/prepare-async",
                                        "errors": [
                                            "domain-in-use",
                                            "transfer-already-owner-hosted"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setupZone",
                                        "method": "POST",
                                        "path": "/setup-zone",
                                        "errors": [
                                            "domain-in-use",
                                            "transfer-already-owner-hosted",
                                            "provision-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "startSetup",
                                        "method": "POST",
                                        "path": "/setup",
                                        "errors": [
                                            "domain-in-use"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "startVerification",
                                        "method": "POST",
                                        "path": "/start-verification",
                                        "errors": [
                                            "domain-not-found",
                                            "verification-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "verify",
                                        "method": "POST",
                                        "path": "/verify",
                                        "errors": [
                                            "owner-domain-not-found",
                                            "dns-lookup-failed",
                                            "hostnames-lookup-failed"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "domains",
                        "path": "/domains",
                        "children": [
                            {
                                "type": "router",
                                "name": "domain",
                                "path": "/{domainId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "customRecords",
                                        "path": "/custom-records",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createCustomRecord",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "cname-exclusivity",
                                                    "exact-duplicate",
                                                    "spf-exclusivity"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "deleteCustomRecord",
                                                "method": "DELETE",
                                                "path": "/{recordId}",
                                                "errors": [
                                                    "record-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getCustomRecord",
                                                "method": "GET",
                                                "path": "/{recordId}",
                                                "errors": [
                                                    "record-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listCustomRecords",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateCustomRecord",
                                                "method": "PATCH",
                                                "path": "/{recordId}",
                                                "errors": [
                                                    "cname-exclusivity",
                                                    "exact-duplicate",
                                                    "spf-exclusivity",
                                                    "record-not-found"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getAuditLogs",
                                        "method": "GET",
                                        "path": "/audit-logs",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getDomain",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getNameserverStatus",
                                        "method": "GET",
                                        "path": "/nameserver-status",
                                        "errors": [
                                            "domain-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getOriginalScrape",
                                        "method": "GET",
                                        "path": "/original-scrape",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSyncHistory",
                                        "method": "GET",
                                        "path": "/sync-history",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getZone",
                                        "method": "GET",
                                        "path": "/zone",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "notes",
                                        "path": "/notes",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getNotes",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateNotes",
                                                "method": "PUT",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "refreshStatus",
                                        "method": "POST",
                                        "path": "/refresh-status",
                                        "errors": [
                                            "domain-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "regenerateCloudflareHostnames",
                                        "method": "POST",
                                        "path": "/regenerate-cloudflare-hostnames",
                                        "errors": [
                                            "domain-not-found",
                                            "regenerate-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "requestVerification",
                                        "method": "POST",
                                        "path": "/verify",
                                        "errors": [
                                            "domain-in-use",
                                            "domain-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "resync",
                                        "method": "POST",
                                        "path": "/resync",
                                        "errors": [
                                            "domain-not-found",
                                            "not-owner-hosted"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "reverifyCloudflareHostname",
                                        "method": "POST",
                                        "path": "/reverify-cloudflare",
                                        "errors": [
                                            "domain-not-found",
                                            "hostname-not-found",
                                            "reverify-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "runScrape",
                                        "method": "POST",
                                        "path": "/scrape",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setPrimary",
                                        "method": "PATCH",
                                        "path": "/set-primary",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateDnsSettings",
                                        "method": "PATCH",
                                        "path": "/dns-settings",
                                        "errors": [
                                            "domain-not-found",
                                            "invalid-template"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "fqdn",
                                "path": "/fqdn/{fqdn}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getZone",
                                        "method": "GET",
                                        "path": "/zone",
                                        "errors": [
                                            "domain-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "findBrandByDomain",
                        "method": "GET",
                        "path": "/find-brand-by-domain",
                        "errors": [
                            "not-found",
                            "invalid-brand-slug",
                            "no-brand-slug",
                            "invalid-params"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "findDomainByBrand",
                        "method": "GET",
                        "path": "/find-domain-by-brand",
                        "errors": [
                            "not-found",
                            "invalid-params"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getTemplates",
                        "method": "GET",
                        "path": "/templates",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "employment",
        "path": "/employment",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "jobs",
                                        "path": "/jobs",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createJob",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "job-title-conflict",
                                                    "invalid-title",
                                                    "invalid-default-hourly-pay",
                                                    "invalid-location-ids",
                                                    "invalid-permission-group-slugs",
                                                    "too-many-users",
                                                    "role-creation-failed",
                                                    "role-update-failed",
                                                    "role-assignment-failed",
                                                    "invalid-location-configuration",
                                                    "user-already-assigned",
                                                    "user-not-assigned",
                                                    "unauthorized"
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "job",
                                                "path": "/{jobId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteJob",
                                                        "method": "DELETE",
                                                        "path": "/",
                                                        "errors": [
                                                            "job-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getJob",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "job-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateJob",
                                                        "method": "PATCH",
                                                        "path": "/",
                                                        "errors": [
                                                            "job-not-found",
                                                            "job-title-conflict",
                                                            "invalid-title",
                                                            "invalid-default-hourly-pay",
                                                            "invalid-location-ids",
                                                            "too-many-users",
                                                            "role-update-failed",
                                                            "role-assignment-failed",
                                                            "invalid-location-configuration",
                                                            "user-already-assigned",
                                                            "user-not-assigned",
                                                            "unauthorized"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listJobs",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "events",
        "path": "/events",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "createEvent",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "event",
                        "path": "/{eventId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "deleteEvent",
                                "method": "DELETE",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getEvent",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getEventOccurrence",
                                "method": "GET",
                                "path": "/occurrence",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updateEvent",
                                "method": "PATCH",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getEvents",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "event",
                        "path": "/{eventId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getEventOccurrence",
                                "method": "GET",
                                "path": "/occurrence",
                                "errors": [
                                    "event-not-found",
                                    "no-future-occurrence"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v3",
                "path": "/v3",
                "children": [
                    {
                        "type": "router",
                        "name": "event",
                        "path": "/{eventId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getEventOccurrence",
                                "method": "GET",
                                "path": "/occurrence",
                                "errors": [
                                    "event-not-found",
                                    "no-future-occurrence"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "forms",
        "path": "/forms",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "forms",
                        "path": "/forms",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createForm",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "form",
                                "path": "/{formId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteForm",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "exportSubmissions",
                                        "method": "POST",
                                        "path": "/export-submissions",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPopulatedForm",
                                        "method": "GET",
                                        "path": "/populated",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "submit",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateForm",
                                        "method": "PUT",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "sections",
                        "path": "/sections",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createSection",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "section",
                                "path": "/{sectionId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteSection",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setSelectOptions",
                                        "method": "PUT",
                                        "path": "/options",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSection",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "submissions",
                        "path": "/submissions",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getSubmissions",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "submission",
                                "path": "/{submissionId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "setReadStatus",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "funnel",
        "path": "/funnel",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "banners",
                        "path": "/banners",
                        "children": [
                            {
                                "type": "router",
                                "name": "banner",
                                "path": "/{bannerId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteBanner",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBanner",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateBanner",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createBanner",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "path-conflict",
                                    "page-invalid",
                                    "section-invalid",
                                    "banner-invalid",
                                    "page-not-found",
                                    "type-mismatch",
                                    "nearby-area-redirect",
                                    "keyword-redirect"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getBanners",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "path-conflict",
                                    "page-invalid",
                                    "section-invalid",
                                    "banner-invalid",
                                    "page-not-found",
                                    "type-mismatch",
                                    "nearby-area-redirect",
                                    "keyword-redirect"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "generated",
                                        "path": "/generated",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "renderGeneratedPage",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "path-conflict",
                                                    "page-invalid",
                                                    "section-invalid",
                                                    "banner-invalid",
                                                    "page-not-found",
                                                    "type-mismatch",
                                                    "nearby-area-redirect",
                                                    "keyword-redirect",
                                                    "not-found",
                                                    "bad-request"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getFunnel",
                                        "method": "GET",
                                        "path": "/funnel",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getKioskHero",
                                        "method": "GET",
                                        "path": "/kiosk-hero",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPageByPath",
                                        "method": "GET",
                                        "path": "/page",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getTerminalHero",
                                        "method": "GET",
                                        "path": "/terminal-hero",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "navItems",
                                        "path": "/nav-items",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "addNavItem",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "deleteNavItem",
                                                "method": "DELETE",
                                                "path": "/{index}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "reorderNavItems",
                                                "method": "PATCH",
                                                "path": "/order",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "renderCustomPage",
                                        "method": "GET",
                                        "path": "/custom/{slug}",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "renderReservedPage",
                                        "method": "GET",
                                        "path": "/reserved/{page}",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateFunnel",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "pages",
                        "path": "/pages",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createPage",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "path-conflict",
                                    "page-invalid",
                                    "section-invalid",
                                    "banner-invalid",
                                    "page-not-found",
                                    "type-mismatch",
                                    "nearby-area-redirect",
                                    "keyword-redirect"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPages",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "path-conflict",
                                    "page-invalid",
                                    "section-invalid",
                                    "banner-invalid",
                                    "page-not-found",
                                    "type-mismatch",
                                    "nearby-area-redirect",
                                    "keyword-redirect"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "page",
                                "path": "/{pageId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deletePage",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPage",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSections",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updatePage",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "sections",
                        "path": "/sections",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createSection",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "path-conflict",
                                    "page-invalid",
                                    "section-invalid",
                                    "banner-invalid",
                                    "page-not-found",
                                    "type-mismatch",
                                    "nearby-area-redirect",
                                    "keyword-redirect"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getSections",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "path-conflict",
                                    "page-invalid",
                                    "section-invalid",
                                    "banner-invalid",
                                    "page-not-found",
                                    "type-mismatch",
                                    "nearby-area-redirect",
                                    "keyword-redirect"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "section",
                                "path": "/{sectionId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteSection",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "renderSection",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSection",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "path-conflict",
                                            "page-invalid",
                                            "section-invalid",
                                            "banner-invalid",
                                            "page-not-found",
                                            "type-mismatch",
                                            "nearby-area-redirect",
                                            "keyword-redirect"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "context",
                                        "path": "/context",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "context",
                                                "method": "GET",
                                                "path": "/{context}",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "debug",
                                        "path": "/debug",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "debug",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandAnalytics",
                                        "method": "GET",
                                        "path": "/analytics",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandMenuSettings",
                                        "method": "GET",
                                        "path": "/menu-settings",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "llmsTxt",
                                        "method": "GET",
                                        "path": "/llms-txt",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "pages",
                                        "path": "/pages",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "page",
                                                "path": "/{path}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getPageData",
                                                        "method": "GET",
                                                        "path": "/data",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "removeBrandHeroVideo",
                                        "method": "DELETE",
                                        "path": "/brand-hero-video",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "sitemap",
                                        "method": "GET",
                                        "path": "/sitemap",
                                        "errors": [
                                            "domain-not-configured"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateBrandAnalytics",
                                        "method": "POST",
                                        "path": "/analytics",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateBrandMenuSettings",
                                        "method": "POST",
                                        "path": "/menu-settings",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "pages",
                        "path": "/pages",
                        "children": [
                            {
                                "type": "router",
                                "name": "page",
                                "path": "/{pageUrl}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getPageBrandId",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "subGroup": "website-bff"
    },
    {
        "type": "endpoint",
        "name": "getGrowthScore",
        "method": "GET",
        "path": "/growth-score",
        "errors": []
    },
    {
        "type": "endpoint",
        "name": "getServerInfo",
        "method": "GET",
        "path": "/",
        "errors": []
    },
    {
        "type": "router",
        "name": "giftCards",
        "path": "/gift-cards",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "adjust",
                        "path": "/adjust",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "adjustGiftCardBalance",
                                "method": "POST",
                                "path": "/{giftCardId}",
                                "errors": [
                                    "user-required",
                                    "balance-mismatch",
                                    "invalid-new-balance",
                                    "unknown-error"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "auditGiftCards",
                        "method": "POST",
                        "path": "/audit",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "card",
                        "path": "/{cardNumber}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getAllCardDetails",
                                "method": "GET",
                                "path": "/all-card-details",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getCardBalanceForHolder",
                                "method": "GET",
                                "path": "/balance-holder",
                                "errors": [
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "charge",
                        "path": "/charge",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "chargeGiftCard",
                                "method": "POST",
                                "path": "/{giftCardId}",
                                "errors": [
                                    "invalid-amount",
                                    "insufficient-balance",
                                    "unknown-error"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "estimateGiftCardPrice",
                        "method": "POST",
                        "path": "/estimate-price",
                        "errors": [
                            "no-location",
                            "gift-cards-not-included-in-plan"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "importGiftCards",
                        "method": "POST",
                        "path": "/import",
                        "errors": [
                            "gift-cards-not-included-in-plan"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "loadGiftCard",
                        "method": "POST",
                        "path": "/load",
                        "errors": [
                            "station-not-found",
                            "brand-mismatch",
                            "unauthorized",
                            "card-not-found",
                            "invalid-amount",
                            "processing-error",
                            "unknown-error"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "paginateGiftCards",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "purchaseGiftCard",
                        "method": "POST",
                        "path": "/purchase",
                        "errors": [
                            "processing-error",
                            "location-not-found",
                            "gift-cards-not-included-in-plan",
                            "unknown-error"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "card",
                        "path": "/{giftCardId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getAllCardDetails",
                                "method": "GET",
                                "path": "/all-card-details",
                                "errors": [
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "charge",
                        "path": "/charge",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "chargeGiftCard",
                                "method": "POST",
                                "path": "/{giftCardId}",
                                "errors": [
                                    "insufficient-balance",
                                    "idempotency-conflict",
                                    "unknown-error"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "refund",
                        "path": "/refund",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "refundGiftCard",
                                "method": "POST",
                                "path": "/{giftCardId}",
                                "errors": [
                                    "exceeds-refundable-amount",
                                    "charge-not-found",
                                    "idempotency-conflict",
                                    "unknown-error"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "google",
        "path": "/google",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "grants",
                                        "path": "/grants",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createGrant",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "authorization-expired",
                                                    "gbp-grant-not-found",
                                                    "gbp-location-not-found",
                                                    "gbp-invitation-not-found",
                                                    "gbp-missing-or-inactive",
                                                    "gbp-needs-verification",
                                                    "gbp-suspended",
                                                    "gbp-permission-denied",
                                                    "gbp-ownership-conflict",
                                                    "gbp-already-claimed-by-owner-location",
                                                    "gbp-accepted-invite-requires-support",
                                                    "gbp-abandon-preempted-by-terminal-failure",
                                                    "gbp-invite-already-live",
                                                    "gbp-support-revert-not-applicable",
                                                    "service-grant-invalid-account",
                                                    "service-grant-not-found",
                                                    "service-grant-expired"
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "grant",
                                                "path": "/{grantId}",
                                                "children": [
                                                    {
                                                        "type": "router",
                                                        "name": "gbpAccounts",
                                                        "path": "/gbp-accounts",
                                                        "children": [
                                                            {
                                                                "type": "router",
                                                                "name": "gbpAccount",
                                                                "path": "/{gbpAccountId}",
                                                                "children": [
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "pick",
                                                                        "method": "POST",
                                                                        "path": "/pick",
                                                                        "errors": [
                                                                            "invalid-auth-code",
                                                                            "missing-scope",
                                                                            "authorization-expired",
                                                                            "gbp-grant-not-found",
                                                                            "gbp-location-not-found",
                                                                            "gbp-invitation-not-found",
                                                                            "gbp-missing-or-inactive",
                                                                            "gbp-needs-verification",
                                                                            "gbp-suspended",
                                                                            "gbp-permission-denied",
                                                                            "gbp-ownership-conflict",
                                                                            "gbp-already-claimed-by-owner-location",
                                                                            "gbp-accepted-invite-requires-support",
                                                                            "gbp-abandon-preempted-by-terminal-failure",
                                                                            "gbp-invite-already-live",
                                                                            "gbp-support-revert-not-applicable",
                                                                            "service-grant-invalid-account",
                                                                            "service-grant-not-found",
                                                                            "service-grant-expired"
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "listGBPLocationsByGrant",
                                                        "method": "GET",
                                                        "path": "/locations",
                                                        "errors": [
                                                            "invalid-auth-code",
                                                            "missing-scope",
                                                            "authorization-expired",
                                                            "gbp-grant-not-found",
                                                            "gbp-location-not-found",
                                                            "gbp-invitation-not-found",
                                                            "gbp-missing-or-inactive",
                                                            "gbp-needs-verification",
                                                            "gbp-suspended",
                                                            "gbp-permission-denied",
                                                            "gbp-ownership-conflict",
                                                            "gbp-already-claimed-by-owner-location",
                                                            "gbp-accepted-invite-requires-support",
                                                            "gbp-abandon-preempted-by-terminal-failure",
                                                            "gbp-invite-already-live",
                                                            "gbp-support-revert-not-applicable",
                                                            "service-grant-invalid-account",
                                                            "service-grant-not-found",
                                                            "service-grant-expired"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listGrants",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "authorization-expired",
                                                    "gbp-grant-not-found",
                                                    "gbp-location-not-found",
                                                    "gbp-invitation-not-found",
                                                    "gbp-missing-or-inactive",
                                                    "gbp-needs-verification",
                                                    "gbp-suspended",
                                                    "gbp-permission-denied",
                                                    "gbp-ownership-conflict",
                                                    "gbp-already-claimed-by-owner-location",
                                                    "gbp-accepted-invite-requires-support",
                                                    "gbp-abandon-preempted-by-terminal-failure",
                                                    "gbp-invite-already-live",
                                                    "gbp-support-revert-not-applicable",
                                                    "service-grant-invalid-account",
                                                    "service-grant-not-found",
                                                    "service-grant-expired"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "locations",
                                        "path": "/{locationId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "abandonPendingGBPInvitation",
                                                "method": "POST",
                                                "path": "/pending-gbp-invitation/abandon",
                                                "errors": [
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "authorization-expired",
                                                    "gbp-grant-not-found",
                                                    "gbp-location-not-found",
                                                    "gbp-invitation-not-found",
                                                    "gbp-missing-or-inactive",
                                                    "gbp-needs-verification",
                                                    "gbp-suspended",
                                                    "gbp-permission-denied",
                                                    "gbp-ownership-conflict",
                                                    "gbp-already-claimed-by-owner-location",
                                                    "gbp-accepted-invite-requires-support",
                                                    "gbp-abandon-preempted-by-terminal-failure",
                                                    "gbp-invite-already-live",
                                                    "gbp-support-revert-not-applicable",
                                                    "service-grant-invalid-account",
                                                    "service-grant-not-found",
                                                    "service-grant-expired"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "acceptInvitation",
                                                "method": "PUT",
                                                "path": "/accept-invitation",
                                                "errors": [
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "authorization-expired",
                                                    "gbp-grant-not-found",
                                                    "gbp-location-not-found",
                                                    "gbp-invitation-not-found",
                                                    "gbp-missing-or-inactive",
                                                    "gbp-needs-verification",
                                                    "gbp-suspended",
                                                    "gbp-permission-denied",
                                                    "gbp-ownership-conflict",
                                                    "gbp-already-claimed-by-owner-location",
                                                    "gbp-accepted-invite-requires-support",
                                                    "gbp-abandon-preempted-by-terminal-failure",
                                                    "gbp-invite-already-live",
                                                    "gbp-support-revert-not-applicable",
                                                    "service-grant-invalid-account",
                                                    "service-grant-not-found",
                                                    "service-grant-expired"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getGbpConnectionState",
                                                "method": "GET",
                                                "path": "/gbp-connection-state",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getGBPLocation",
                                                "method": "GET",
                                                "path": "/gbp",
                                                "errors": [
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "authorization-expired",
                                                    "gbp-grant-not-found",
                                                    "gbp-location-not-found",
                                                    "gbp-invitation-not-found",
                                                    "gbp-missing-or-inactive",
                                                    "gbp-needs-verification",
                                                    "gbp-suspended",
                                                    "gbp-permission-denied",
                                                    "gbp-ownership-conflict",
                                                    "gbp-already-claimed-by-owner-location",
                                                    "gbp-accepted-invite-requires-support",
                                                    "gbp-abandon-preempted-by-terminal-failure",
                                                    "gbp-invite-already-live",
                                                    "gbp-support-revert-not-applicable",
                                                    "service-grant-invalid-account",
                                                    "service-grant-not-found",
                                                    "service-grant-expired"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getInvitation",
                                                "method": "GET",
                                                "path": "/invitation",
                                                "errors": [
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "authorization-expired",
                                                    "gbp-grant-not-found",
                                                    "gbp-location-not-found",
                                                    "gbp-invitation-not-found",
                                                    "gbp-missing-or-inactive",
                                                    "gbp-needs-verification",
                                                    "gbp-suspended",
                                                    "gbp-permission-denied",
                                                    "gbp-ownership-conflict",
                                                    "gbp-already-claimed-by-owner-location",
                                                    "gbp-accepted-invite-requires-support",
                                                    "gbp-abandon-preempted-by-terminal-failure",
                                                    "gbp-invite-already-live",
                                                    "gbp-support-revert-not-applicable",
                                                    "service-grant-invalid-account",
                                                    "service-grant-not-found",
                                                    "service-grant-expired"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPendingGBPInvitation",
                                                "method": "GET",
                                                "path": "/pending-gbp-invitation",
                                                "errors": [
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "authorization-expired",
                                                    "gbp-grant-not-found",
                                                    "gbp-location-not-found",
                                                    "gbp-invitation-not-found",
                                                    "gbp-missing-or-inactive",
                                                    "gbp-needs-verification",
                                                    "gbp-suspended",
                                                    "gbp-permission-denied",
                                                    "gbp-ownership-conflict",
                                                    "gbp-already-claimed-by-owner-location",
                                                    "gbp-accepted-invite-requires-support",
                                                    "gbp-abandon-preempted-by-terminal-failure",
                                                    "gbp-invite-already-live",
                                                    "gbp-support-revert-not-applicable",
                                                    "service-grant-invalid-account",
                                                    "service-grant-not-found",
                                                    "service-grant-expired"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "grants",
                        "path": "/grants",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createServiceGrant",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "invalid-auth-code",
                                    "missing-scope",
                                    "authorization-expired",
                                    "gbp-grant-not-found",
                                    "gbp-location-not-found",
                                    "gbp-invitation-not-found",
                                    "gbp-missing-or-inactive",
                                    "gbp-needs-verification",
                                    "gbp-suspended",
                                    "gbp-permission-denied",
                                    "gbp-ownership-conflict",
                                    "gbp-already-claimed-by-owner-location",
                                    "gbp-accepted-invite-requires-support",
                                    "gbp-abandon-preempted-by-terminal-failure",
                                    "gbp-invite-already-live",
                                    "gbp-support-revert-not-applicable",
                                    "service-grant-invalid-account",
                                    "service-grant-not-found",
                                    "service-grant-expired"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "oauth",
                        "path": "/oauth",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "mobile",
                                "method": "GET",
                                "path": "/mobile",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "web",
                                "method": "GET",
                                "path": "/web",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "workspace",
                        "path": "/workspace",
                        "children": [
                            {
                                "type": "router",
                                "name": "calendar",
                                "path": "/calendar",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "availability",
                                        "method": "POST",
                                        "path": "/free-busy",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "cancelEvent",
                                        "method": "DELETE",
                                        "path": "/calendars/{calendarId}/events/{eventId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createEvent",
                                        "method": "POST",
                                        "path": "/calendars/{calendarId}/events",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getEvent",
                                        "method": "GET",
                                        "path": "/calendars/{calendarId}/events/{eventId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listCalendars",
                                        "method": "GET",
                                        "path": "/calendars",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "respond",
                                        "method": "POST",
                                        "path": "/calendars/{calendarId}/events/{eventId}/response",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "searchEvents",
                                        "method": "GET",
                                        "path": "/calendars/{calendarId}/events",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateEvent",
                                        "method": "PATCH",
                                        "path": "/calendars/{calendarId}/events/{eventId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "complete",
                                "method": "POST",
                                "path": "/oauth/complete",
                                "errors": [
                                    "oauth-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "disconnect",
                                "method": "DELETE",
                                "path": "/connection",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "gmailPubSub",
                                "method": "POST",
                                "path": "/pubsub/gmail",
                                "errors": [
                                    "unauthorized"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "mail",
                                "path": "/mail",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteDraft",
                                        "method": "DELETE",
                                        "path": "/drafts/{draftId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "readAttachment",
                                        "method": "GET",
                                        "path": "/messages/{messageId}/attachments/{attachmentId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "readMessage",
                                        "method": "GET",
                                        "path": "/messages/{messageId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "readThread",
                                        "method": "GET",
                                        "path": "/threads/{threadId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "reviewedDraft",
                                        "method": "POST",
                                        "path": "/reviewed-draft",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "saveDraft",
                                        "method": "PUT",
                                        "path": "/drafts",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "search",
                                        "method": "GET",
                                        "path": "/messages",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "send",
                                        "method": "POST",
                                        "path": "/send",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "meetPubSub",
                                "method": "POST",
                                "path": "/pubsub/meet",
                                "errors": [
                                    "unauthorized"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "searchPeople",
                                "method": "POST",
                                "path": "/people/search",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "start",
                                "method": "POST",
                                "path": "/oauth/start",
                                "errors": [
                                    "not-configured",
                                    "owner-account-required"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "status",
                                "method": "GET",
                                "path": "/connection",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "grader",
        "path": "/grader",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getReport",
                                        "method": "GET",
                                        "path": "/report",
                                        "errors": [
                                            "report-not-found",
                                            "stale-report-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "uber",
                        "path": "/uber",
                        "children": [
                            {
                                "type": "router",
                                "name": "account",
                                "path": "/account",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "brandMatch",
                                        "method": "POST",
                                        "path": "/brand-match",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "complete",
                                        "method": "POST",
                                        "path": "/complete",
                                        "errors": [
                                            "brand-mismatch",
                                            "brand-already-claimed",
                                            "email-in-use",
                                            "name-required"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "exchangeHandoff",
                                        "method": "POST",
                                        "path": "/exchange-handoff",
                                        "errors": [
                                            "invalid-code"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "start",
                                        "method": "POST",
                                        "path": "/start",
                                        "errors": [
                                            "brand-mismatch"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "verify",
                                        "method": "POST",
                                        "path": "/verify",
                                        "errors": [
                                            "brand-mismatch"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createReports",
                                "method": "POST",
                                "path": "/reports",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getCohortState",
                                "method": "GET",
                                "path": "/cohort-state",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "reconcileCohortState",
                                "method": "POST",
                                "path": "/cohort-state/reconcile",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "stores",
                                "path": "/stores",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createToken",
                                        "method": "POST",
                                        "path": "/token",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getStatus",
                                        "method": "POST",
                                        "path": "/status",
                                        "errors": [
                                            "token-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSummary",
                                        "method": "POST",
                                        "path": "/summary",
                                        "errors": [
                                            "token-not-found",
                                            "summary-not-found"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "store",
                                        "path": "/{uberStoreId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createBookingReferralIntent",
                                                "method": "POST",
                                                "path": "/booking-referral-intent",
                                                "errors": [
                                                    "report-not-ready"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createLaunchHandoff",
                                                "method": "POST",
                                                "path": "/launch-handoff",
                                                "errors": [
                                                    "report-not-ready"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createToken",
                                                "method": "POST",
                                                "path": "/token",
                                                "errors": [
                                                    "store-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getOnboardingSummary",
                                                "method": "GET",
                                                "path": "/onboarding-summary",
                                                "errors": [
                                                    "onboarding-summary-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPurchaseSummary",
                                                "method": "GET",
                                                "path": "/purchase-summary",
                                                "errors": [
                                                    "purchase-summary-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getReport",
                                                "method": "GET",
                                                "path": "/report",
                                                "errors": [
                                                    "report-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getStatus",
                                                "method": "GET",
                                                "path": "/status",
                                                "errors": [
                                                    "store-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSummary",
                                                "method": "GET",
                                                "path": "/summary",
                                                "errors": [
                                                    "summary-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "purchase",
                                                "method": "POST",
                                                "path": "/purchase",
                                                "errors": [
                                                    "purchase-store-not-found",
                                                    "uber-purchase-already-completed"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "subGroup": "grader"
    },
    {
        "type": "router",
        "name": "growth",
        "path": "/growth",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "assets",
                                        "path": "/assets",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "patchBrandAssets",
                                                "method": "PATCH",
                                                "path": "/",
                                                "errors": [
                                                    "website-sync-failed"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "captureLead",
                                        "method": "POST",
                                        "path": "/lead-capture",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSocialGenerationContext",
                                        "method": "GET",
                                        "path": "/social-generation-context",
                                        "errors": [
                                            "context-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "pipelines",
                        "path": "/pipelines",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "comparisonEvidence",
                                "method": "POST",
                                "path": "/comparison-evidence",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "createBrandFromPlaceId",
                                "method": "POST",
                                "path": "/brand-from-place-id",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "createWebsite",
                                "method": "POST",
                                "path": "/website",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "pipeline",
                                "path": "/{pipelineExecutionId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getPipelineExecution",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "pipeline-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getTemporalState",
                                        "method": "GET",
                                        "path": "/temporal-state",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "webhooks",
                        "path": "/webhooks",
                        "children": [
                            {
                                "type": "router",
                                "name": "default",
                                "path": "/default",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "booking",
                                        "method": "POST",
                                        "path": "/booking",
                                        "errors": [
                                            "not-enabled",
                                            "unauthorized",
                                            "bad-meeting-id"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createAppHandoff",
                                        "method": "POST",
                                        "path": "/app-handoff",
                                        "errors": [
                                            "handoff-unavailable"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getMenuGraderReport",
                                        "method": "GET",
                                        "path": "/menu-grader-report",
                                        "errors": [
                                            "report-not-found",
                                            "stale-report-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getOgData",
                                        "method": "GET",
                                        "path": "/og-data",
                                        "errors": [
                                            "brand-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getReport",
                                        "method": "GET",
                                        "path": "/report",
                                        "errors": [
                                            "report-not-found",
                                            "stale-report-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getUberBookingRouting",
                                        "method": "GET",
                                        "path": "/uber-booking-routing",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "jobs",
                                        "path": "/jobs/{jobId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getArtifacts",
                                                "method": "GET",
                                                "path": "/artifacts",
                                                "errors": [
                                                    "job-not-in-brand"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "importMenu",
                                                "method": "POST",
                                                "path": "/import-menu",
                                                "errors": [
                                                    "location-not-in-brand",
                                                    "job-not-in-brand"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "lead",
                                        "path": "/lead",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "captureDetails",
                                                "method": "POST",
                                                "path": "/capture-details",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createSessionFromLead",
                                                "method": "POST",
                                                "path": "/create-session",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "finalizeLead",
                                                "method": "POST",
                                                "path": "/finalize-lead",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getLead",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "initializeLead",
                                                "method": "POST",
                                                "path": "/initialize-lead",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "qualification",
                                                "method": "POST",
                                                "path": "/qualification",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resendVerification",
                                                "method": "POST",
                                                "path": "/resend-verification",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "verifyPhone",
                                                "method": "POST",
                                                "path": "/verify",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listJobs",
                                        "method": "GET",
                                        "path": "/jobs",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "notifyBooking",
                                        "method": "POST",
                                        "path": "/notify-demo-booked",
                                        "errors": [
                                            "brand-not-found",
                                            "booking-not-recorded"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "notifyReportView",
                                        "method": "POST",
                                        "path": "/notify-report-view",
                                        "errors": [
                                            "report-not-found",
                                            "stale-report-not-found"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "searchmap",
                                        "path": "/searchmap",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "addKeywordsToScanGroup",
                                                "method": "POST",
                                                "path": "/scan-groups/{groupId}/keywords",
                                                "errors": [
                                                    "invalid-searchmap-scan",
                                                    "searchmap-scan-group-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "archiveScanGroup",
                                                "method": "DELETE",
                                                "path": "/scan-groups/{groupId}",
                                                "errors": [
                                                    "searchmap-scan-group-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "autocomplete",
                                                "method": "POST",
                                                "path": "/autocomplete",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getBootstrap",
                                                "method": "GET",
                                                "path": "/bootstrap",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getScan",
                                                "method": "GET",
                                                "path": "/scans/{scanId}",
                                                "errors": [
                                                    "searchmap-scan-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getScanAreas",
                                                "method": "GET",
                                                "path": "/scans/{scanId}/areas",
                                                "errors": [
                                                    "searchmap-scan-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listScanGroupScans",
                                                "method": "GET",
                                                "path": "/scan-groups/{groupId}/scans",
                                                "errors": [
                                                    "searchmap-scan-group-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listScans",
                                                "method": "GET",
                                                "path": "/scans",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "removeScanFromGroup",
                                                "method": "DELETE",
                                                "path": "/scans/{scanId}",
                                                "errors": [
                                                    "searchmap-scan-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "startScans",
                                                "method": "POST",
                                                "path": "/scans",
                                                "errors": [
                                                    "invalid-searchmap-scan"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "suggestKeywords",
                                                "method": "POST",
                                                "path": "/suggest-keywords",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "startJob",
                                        "method": "POST",
                                        "path": "/jobs",
                                        "errors": [
                                            "no-place-id"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "grader",
                        "path": "/grader",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createBatch",
                                "method": "POST",
                                "path": "/batch",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "createBrandFromPlaceId",
                                "method": "POST",
                                "path": "/brand-from-place-id",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "ensureGraderReportPipeline",
                                "method": "POST",
                                "path": "/ensure-grader-report-pipeline",
                                "errors": [
                                    "scout-research-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getBatchStatus",
                                "method": "GET",
                                "path": "/batch/{jobId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getCompetitors",
                                "method": "GET",
                                "path": "/competitors",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getUberStoreIdentity",
                                "method": "GET",
                                "path": "/uber-store-identity",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "linkBrand",
                                "method": "POST",
                                "path": "/link-brand",
                                "errors": [
                                    "store-place-mismatch",
                                    "ambiguous-place"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startMenuGraderApply",
                                "method": "POST",
                                "path": "/menu-grader-apply",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "startResearchLite",
                                "method": "POST",
                                "path": "/research-lite",
                                "errors": [
                                    "no-grader-pipeline"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "heroVideo",
                        "path": "/hero-video",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createDirectDownloadUrl",
                                "method": "POST",
                                "path": "/direct-download-url",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "image",
                        "path": "/image",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/brands/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createGalleryImage",
                                        "method": "POST",
                                        "path": "/create-image",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createGalleryImageFromSrc",
                                        "method": "POST",
                                        "path": "/create-image-from-src",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getImage",
                                "method": "GET",
                                "path": "/{imageId}",
                                "errors": [
                                    "image-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "leadVerificationCode",
                        "path": "/lead-verification-code",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getLeadVerificationCode",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "packetBuilder",
                        "path": "/packet-builder",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "autocompletePlaces",
                                "method": "POST",
                                "path": "/places/autocomplete",
                                "errors": [
                                    "packet-builder-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPlace",
                                "method": "GET",
                                "path": "/places/{placeId}",
                                "errors": [
                                    "packet-builder-unavailable",
                                    "place-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "sommelier",
                        "path": "/sommelier",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "startMenuImport",
                                "method": "POST",
                                "path": "/start-menu-import",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "websiteBuilder",
                        "path": "/website/build",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/brand/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "billing",
                                        "path": "/billing",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "cancelSubscription",
                                                "method": "POST",
                                                "path": "/cancel-subscription",
                                                "errors": [
                                                    "brand-not-found",
                                                    "no-website-subscription",
                                                    "brand-does-not-have-website-subscription"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "startSubscription",
                                                "method": "POST",
                                                "path": "/start-subscription",
                                                "errors": [
                                                    "brand-not-found",
                                                    "no-website-subscription",
                                                    "brand-already-has-subscription",
                                                    "brand-must-have-exactly-one-location",
                                                    "payment-failed",
                                                    "payment-processing-error",
                                                    "invalid-coupon-code",
                                                    "canada-website-paid-trial-disabled",
                                                    "canada-standard-subscription-disabled",
                                                    "billing-address-update-failed"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "content",
                                        "path": "/content",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "public",
                                                "path": "/public",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "get",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "update",
                                                        "method": "PUT",
                                                        "path": "/",
                                                        "errors": []
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "PUT",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "discardDrafts",
                                        "method": "POST",
                                        "path": "/discard-drafts",
                                        "errors": [
                                            "publish-in-progress"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "featuredMenuItems",
                                        "path": "/featuredMenuItems/{featuredMenuItemId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "updateFeaturedMenuItem",
                                                "method": "PUT",
                                                "path": "/update",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSuggestions",
                                        "method": "GET",
                                        "path": "/suggestions",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "hero",
                                        "path": "/hero",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "failHeroVideo",
                                                "method": "POST",
                                                "path": "/video-status/{mediaId}/failed",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "generateHero",
                                                "method": "POST",
                                                "path": "/generate",
                                                "errors": [
                                                    "generation-failed",
                                                    "invalid-reference-image-count"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getHeroVideoPublicationStatus",
                                                "method": "GET",
                                                "path": "/video-status/{mediaId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getHeroVideoStatus",
                                                "method": "GET",
                                                "path": "/video-status",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getMediaCandidates",
                                                "method": "GET",
                                                "path": "/candidates",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getReferencePhotos",
                                                "method": "GET",
                                                "path": "/reference-photos",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "requestHeroVideoUpload",
                                                "method": "POST",
                                                "path": "/request-video-upload",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "savePreparedHeroVideo",
                                                "method": "POST",
                                                "path": "/save-prepared-video",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "uploadHeroImage",
                                                "method": "POST",
                                                "path": "/upload-image",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "uploadHeroVideo",
                                                "method": "POST",
                                                "path": "/upload-video",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "uploadReferencePhoto",
                                                "method": "POST",
                                                "path": "/upload-generation-reference",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "publish",
                                        "method": "POST",
                                        "path": "/publish",
                                        "errors": [
                                            "publish-in-progress"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "publishedWebsiteBaseUrl",
                                        "method": "GET",
                                        "path": "/published-website-base-url",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "recordFunnelActivity",
                                        "method": "POST",
                                        "path": "/funnel-activity",
                                        "errors": [
                                            "invalid-pipeline-metadata"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "video",
                                        "path": "/video",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getVideoStatus",
                                                "method": "GET",
                                                "path": "/{mediaId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "startVideoConversion",
                                                "method": "POST",
                                                "path": "/{mediaId}/conversion",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "uploadVideo",
                                                "method": "POST",
                                                "path": "/upload",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "subGroup": "grader"
    },
    {
        "type": "router",
        "name": "guestPhotos",
        "path": "/guestPhotos",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "guestPhotos",
                        "path": "/guestPhotos",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "eligibility",
                                "method": "GET",
                                "path": "/eligibility",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "submit",
                                "method": "POST",
                                "path": "/submit",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "uploadUrl",
                                "method": "POST",
                                "path": "/upload-url",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "reviewer",
                        "path": "/reviewer",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "decide",
                                "method": "POST",
                                "path": "/{submissionId}/decide",
                                "errors": [
                                    "submission-not-found",
                                    "item-already-accepted"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "detail",
                                "method": "GET",
                                "path": "/{submissionId}",
                                "errors": [
                                    "submission-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "promote",
                                "method": "POST",
                                "path": "/{submissionId}/promote",
                                "errors": [
                                    "submission-not-found",
                                    "not-accepted",
                                    "slot-filled",
                                    "selected-image-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "promoteAll",
                                "method": "POST",
                                "path": "/promote-all",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "queue",
                                "method": "GET",
                                "path": "/queue",
                                "errors": [
                                    "invalid-cursor"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "regenerate",
                                "method": "POST",
                                "path": "/{submissionId}/regenerate",
                                "errors": [
                                    "submission-not-found",
                                    "not-accepted",
                                    "missing-context",
                                    "already-running"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "unstage",
                                "method": "POST",
                                "path": "/{submissionId}/unstage",
                                "errors": [
                                    "submission-not-found",
                                    "not-accepted"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "endpoint",
        "name": "health",
        "method": "GET",
        "path": "/health",
        "errors": [],
        "subGroup": "*"
    },
    {
        "type": "router",
        "name": "hercules",
        "path": "/hercules",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "applePlatform",
                        "path": "/apple-platform",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "batchReport",
                                "method": "GET",
                                "path": "/batch/{batchId}/report",
                                "errors": [
                                    "batch-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "batchStatus",
                                "method": "GET",
                                "path": "/batch/{batchId}",
                                "errors": [
                                    "batch-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "cancelBatch",
                                "method": "POST",
                                "path": "/batch/{batchId}/cancel",
                                "errors": [
                                    "batch-not-found",
                                    "batch-terminal"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "submitBatch",
                                "method": "POST",
                                "path": "/batch",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "cdn",
                        "path": "/cdn",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "takeDownImage",
                                "method": "POST",
                                "path": "/image-takedown",
                                "errors": [
                                    "image-not-found",
                                    "invalid-image-url"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "comms",
                        "path": "/comms",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "annotateContact",
                                "method": "PATCH",
                                "path": "/contacts/{contactId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createBrandContact",
                                "method": "POST",
                                "path": "/brands/{brandId}/contacts",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "createRecallBot",
                                "method": "POST",
                                "path": "/brands/{brandId}/recall/bots",
                                "errors": [
                                    "brand-not-found",
                                    "source-unavailable",
                                    "source-invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getAttachmentDownload",
                                "method": "GET",
                                "path": "/entries/{entryId}/attachments/{attachmentId}/download",
                                "errors": [
                                    "not-found",
                                    "unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getBrandConversation",
                                "method": "GET",
                                "path": "/brands/{brandId}/conversations/{conversationId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getConnectedAccount",
                                "method": "GET",
                                "path": "/connected-accounts/{connectionId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getGlobalConversation",
                                "method": "GET",
                                "path": "/conversations/{conversationId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getGlobalConversationContent",
                                "method": "GET",
                                "path": "/conversations/{conversationId}/content",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getGlobalConversationOverview",
                                "method": "GET",
                                "path": "/conversations/{conversationId}/overview",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getIngestOverview",
                                "method": "GET",
                                "path": "/ingest/overview",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getLatestMomentumBrandIngest",
                                "method": "GET",
                                "path": "/brands/{brandId}/ingest/momentum",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getLatestSalesforceBrandIngest",
                                "method": "GET",
                                "path": "/brands/{brandId}/ingest/salesforce",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getManagerActivity",
                                "method": "GET",
                                "path": "/people/{personId}/reports/activity",
                                "errors": [
                                    "identity-lookup-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPersonMetrics",
                                "method": "GET",
                                "path": "/people/{personId}/metrics",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getRecordingPlayback",
                                "method": "GET",
                                "path": "/recordings/{recordingId}/playback",
                                "errors": [
                                    "not-found",
                                    "unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "ingestRecallBot",
                                "method": "POST",
                                "path": "/recall/bots/{botId}/ingest",
                                "errors": [
                                    "brand-not-found",
                                    "source-unavailable",
                                    "source-invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "ingestRecording",
                                "method": "POST",
                                "path": "/entries/{entryId}/recording",
                                "errors": [
                                    "not-found",
                                    "no-recording"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listBrandContacts",
                                "method": "GET",
                                "path": "/brands/{brandId}/contacts",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listBrandTimeline",
                                "method": "GET",
                                "path": "/brands/{brandId}/timeline",
                                "errors": [
                                    "invalid-cursor"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listConnectedAccounts",
                                "method": "GET",
                                "path": "/connected-accounts",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listFeatureFlags",
                                "method": "GET",
                                "path": "/feature-flags",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listGlobalTimeline",
                                "method": "GET",
                                "path": "/timeline",
                                "errors": [
                                    "invalid-cursor"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listIngestRuns",
                                "method": "GET",
                                "path": "/ingest/runs",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listPersonActivity",
                                "method": "GET",
                                "path": "/people/activity",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listPersonTimeline",
                                "method": "GET",
                                "path": "/people/{personId}/timeline",
                                "errors": [
                                    "invalid-cursor"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "lookupContacts",
                                "method": "GET",
                                "path": "/contacts/lookup",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "recheckConnectedAccount",
                                "method": "POST",
                                "path": "/connected-accounts/{connectionId}/recheck",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "refreshBrandContacts",
                                "method": "POST",
                                "path": "/brands/{brandId}/contacts/refresh",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "regenerateConversationSummary",
                                "method": "POST",
                                "path": "/brands/{brandId}/conversation-summaries/{conversationId}",
                                "errors": [
                                    "not-found",
                                    "queue-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startMomentumBrandIngest",
                                "method": "POST",
                                "path": "/brands/{brandId}/ingest/momentum",
                                "errors": [
                                    "brand-not-found",
                                    "queue-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startSalesforceBrandIngest",
                                "method": "POST",
                                "path": "/brands/{brandId}/ingest/salesforce",
                                "errors": [
                                    "brand-not-found",
                                    "queue-unavailable"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "csmAccounts",
                        "path": "/csm-accounts",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listCsmAccounts",
                                "method": "GET",
                                "path": "/users/{userId}",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "deeplinks",
                        "path": "/deeplinks",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "probeEntitlements",
                                "method": "GET",
                                "path": "/entitlements",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "dishPageTaxonomy",
                        "path": "/dish-page-taxonomy",
                        "children": [
                            {
                                "type": "router",
                                "name": "draft",
                                "path": "/draft",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createDishPageTaxonomyDraft",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "publishDishPageTaxonomyDraft",
                                        "method": "POST",
                                        "path": "/publish",
                                        "errors": [
                                            "taxonomy-draft-changed",
                                            "invalid-taxonomy"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "replaceDishPageTaxonomyDraft",
                                        "method": "PUT",
                                        "path": "/",
                                        "errors": [
                                            "taxonomy-draft-changed",
                                            "invalid-taxonomy"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getDishPageTaxonomy",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "domainQuality",
                        "path": "/domain-quality",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "assignTeam",
                                "method": "PATCH",
                                "path": "/assignment",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createMcpCredential",
                                "method": "POST",
                                "path": "/mcp-credentials",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "evaluate",
                                "method": "POST",
                                "path": "/evaluations",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getChat",
                                "method": "GET",
                                "path": "/chats/{chatId}",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getHealth",
                                "method": "GET",
                                "path": "/health",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getIssueChats",
                                "method": "GET",
                                "path": "/issue-chats",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getRubric",
                                "method": "GET",
                                "path": "/rubric",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getWorkspace",
                                "method": "GET",
                                "path": "/workspace",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listChats",
                                "method": "GET",
                                "path": "/chats",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listMcpCredentials",
                                "method": "GET",
                                "path": "/mcp-credentials",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listRuns",
                                "method": "GET",
                                "path": "/runs",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "publishRubric",
                                "method": "POST",
                                "path": "/rubric/publish",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "restoreRubric",
                                "method": "POST",
                                "path": "/rubric/restore",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "revokeMcpCredential",
                                "method": "DELETE",
                                "path": "/mcp-credentials/{credentialId}",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "rotateMcpCredential",
                                "method": "POST",
                                "path": "/mcp-credentials/{credentialId}/rotate",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "saveRubric",
                                "method": "PATCH",
                                "path": "/rubric",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "saveTeam",
                                "method": "POST",
                                "path": "/teams",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "scan",
                                "method": "POST",
                                "path": "/scans",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "stop",
                                "method": "POST",
                                "path": "/runs/{runId}/stop",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateSettings",
                                "method": "PATCH",
                                "path": "/settings",
                                "errors": [
                                    "invalid",
                                    "conflict",
                                    "not-found",
                                    "not-ready",
                                    "pricing-model-mismatch"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "funnelToWebsiteMigration",
                        "path": "/funnel-to-website-migration",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getFunnelToWebsiteBulkMigrationProgress",
                                "method": "GET",
                                "path": "/bulk-migrations/progress",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getFunnelToWebsiteMigration",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listFunnelToWebsiteMigrationBrandIds",
                                "method": "GET",
                                "path": "/brand-ids",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listFunnelToWebsiteMigrationBrands",
                                "method": "GET",
                                "path": "/brands",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "startFunnelToWebsiteBrandMigration",
                                "method": "POST",
                                "path": "/brand-migrations",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "startFunnelToWebsiteBulkMigration",
                                "method": "POST",
                                "path": "/bulk-migrations",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "startFunnelToWebsiteMigrationScan",
                                "method": "POST",
                                "path": "/scans",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "grader",
                        "path": "/grader",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "startDemo",
                                "method": "POST",
                                "path": "/start-demo",
                                "errors": [
                                    "forbidden-role"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "guestAppLaunchTodos",
                        "path": "/guest-app-launch-todos",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getIosVersionOverview",
                                "method": "GET",
                                "path": "/ios-version-overview",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "hodos",
                        "path": "/hodos",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createHodosRedirect",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "duplicate-slug"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listHodosRedirects",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "redirect",
                                "path": "/{slug}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteHodosRedirect",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": [
                                            "hodos-redirect-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateHodosRedirect",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "duplicate-slug",
                                            "hodos-redirect-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "identity",
                        "path": "/identity",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createProfileAvatarUpload",
                                "method": "POST",
                                "path": "/public-profile/avatar-upload",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getDirectReports",
                                "method": "GET",
                                "path": "/people/{personId}/reports",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getIdentity",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getIdentityByPersonId",
                                "method": "GET",
                                "path": "/people/{personId}",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPublicProfile",
                                "method": "GET",
                                "path": "/public-profile",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listDirectory",
                                "method": "GET",
                                "path": "/directory",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "quoNumbers",
                                "path": "/quo-numbers",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "listQuoPhoneNumberMappings",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "syncQuoPhoneNumberMappings",
                                        "method": "POST",
                                        "path": "/sync",
                                        "errors": [
                                            "sync-unavailable"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateQuoPhoneNumberMapping",
                                        "method": "PATCH",
                                        "path": "/phone-numbers/{mappingId}",
                                        "errors": [
                                            "mapping-not-found",
                                            "suggestion-unavailable",
                                            "owner-not-found",
                                            "identity-unavailable"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "savePublicProfile",
                                "method": "POST",
                                "path": "/public-profile",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable",
                                    "profile-change-refused"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "searchDirectory",
                                "method": "GET",
                                "path": "/directory/search",
                                "errors": [
                                    "no-user-session",
                                    "identity-lookup-unavailable"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "instantLaunchPipeline",
                        "path": "/instant-launch-pipeline",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listInstantLaunchPipeline",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "setLaunchSpecialist",
                                "method": "PATCH",
                                "path": "/{brandId}/launch-specialist",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "setNotes",
                                "method": "PATCH",
                                "path": "/{brandId}/notes/{locationId}",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "launchAgent",
                        "path": "/launch-agent",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getBrandState",
                                "method": "GET",
                                "path": "/brands/{brandId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getRun",
                                "method": "GET",
                                "path": "/brands/{brandId}/runs/{runId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listAllRuns",
                                "method": "GET",
                                "path": "/runs",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listBrandSummaries",
                                "method": "GET",
                                "path": "/summaries",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listRunEvents",
                                "method": "GET",
                                "path": "/brands/{brandId}/runs/{runId}/events",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listRuns",
                                "method": "GET",
                                "path": "/brands/{brandId}/runs",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "requestRun",
                                "method": "POST",
                                "path": "/brands/{brandId}/runs",
                                "errors": [
                                    "monitoring-disabled"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setMonitoring",
                                "method": "PUT",
                                "path": "/brands/{brandId}",
                                "errors": [
                                    "active-run"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "launchBoard",
                        "path": "/launch-board",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getLaunchBoardCase",
                                "method": "GET",
                                "path": "/cases/{caseId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listUnassignedLaunchCases",
                                "method": "GET",
                                "path": "/unassigned",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "launchDetail",
                        "path": "/launch-detail",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getBrandSalesforceCommunications",
                                "method": "GET",
                                "path": "/brands/{brandId}/salesforce/communications",
                                "errors": [
                                    "not-found",
                                    "salesforce-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getBrandSalesforceDetail",
                                "method": "GET",
                                "path": "/brands/{brandId}/salesforce",
                                "errors": [
                                    "not-found",
                                    "salesforce-unavailable"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "launchPipeline",
                        "path": "/launch-pipeline",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getLaunchPipeline",
                                "method": "GET",
                                "path": "/users/{userId}",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "opportunityView",
                        "path": "/opportunity-view",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getOpportunity",
                                "method": "GET",
                                "path": "/opportunities/{opportunityId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listOpportunities",
                                "method": "GET",
                                "path": "/opportunities",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listOpportunityAssignees",
                                "method": "GET",
                                "path": "/opportunity-assignees",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "outboundLeadBatches",
                        "path": "/outbound-lead-batches",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createOutboundLeadTestBatch",
                                "method": "POST",
                                "path": "/test-batches",
                                "errors": [
                                    "feature-disabled",
                                    "idempotency-conflict",
                                    "temporal-unavailable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getOutboundLeadBatch",
                                "method": "GET",
                                "path": "/batches/{batchId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listOutboundLeadBatches",
                                "method": "GET",
                                "path": "/batches",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "packetBuilder",
                        "path": "/packet-builder",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createDownload",
                                "method": "GET",
                                "path": "/packets/{packetId}/download",
                                "errors": [
                                    "invalid-cursor",
                                    "upload-not-found",
                                    "upload-expired",
                                    "upload-consumed",
                                    "invalid-upload",
                                    "pipeline-not-found",
                                    "pipeline-not-ready",
                                    "pipeline-mismatch",
                                    "report-not-ready",
                                    "invalid-parent",
                                    "packet-not-found",
                                    "packet-file-missing"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createPacket",
                                "method": "POST",
                                "path": "/packets",
                                "errors": [
                                    "invalid-cursor",
                                    "upload-not-found",
                                    "upload-expired",
                                    "upload-consumed",
                                    "invalid-upload",
                                    "pipeline-not-found",
                                    "pipeline-not-ready",
                                    "pipeline-mismatch",
                                    "report-not-ready",
                                    "invalid-parent",
                                    "packet-not-found",
                                    "packet-file-missing"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createUpload",
                                "method": "POST",
                                "path": "/uploads",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listPackets",
                                "method": "GET",
                                "path": "/packets",
                                "errors": [
                                    "invalid-cursor",
                                    "upload-not-found",
                                    "upload-expired",
                                    "upload-consumed",
                                    "invalid-upload",
                                    "pipeline-not-found",
                                    "pipeline-not-ready",
                                    "pipeline-mismatch",
                                    "report-not-ready",
                                    "invalid-parent",
                                    "packet-not-found",
                                    "packet-file-missing"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "plgOutreach",
                        "path": "/plg-outreach",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listPlgOutreachLeads",
                                "method": "GET",
                                "path": "/leads",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updatePlgOutreachLeadActivity",
                                "method": "PATCH",
                                "path": "/leads/{leadId}",
                                "errors": [
                                    "empty-update",
                                    "lead-not-found",
                                    "activity-not-recorded"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "plgScoutCoverage",
                        "path": "/plg-scout-coverage",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getGrowthRequest",
                                "method": "GET",
                                "path": "/growth/requests/{requestId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "list",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "previewGrowth",
                                "method": "POST",
                                "path": "/growth/preview",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "refresh",
                                "method": "POST",
                                "path": "/refresh",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "requestGrowth",
                                "method": "POST",
                                "path": "/growth/requests",
                                "errors": [
                                    "trigger-disabled"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "quoMessaging",
                        "path": "/quo-messaging",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listConversations",
                                "method": "GET",
                                "path": "/conversations",
                                "errors": [
                                    "line-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listLines",
                                "method": "GET",
                                "path": "/lines",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listMessages",
                                "method": "GET",
                                "path": "/lines/{phoneNumberId}/messages",
                                "errors": [
                                    "line-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "sendMessage",
                                "method": "POST",
                                "path": "/messages",
                                "errors": [
                                    "line-not-found",
                                    "line-number-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setPrimaryLine",
                                "method": "PATCH",
                                "path": "/lines/{phoneNumberId}/primary",
                                "errors": [
                                    "line-not-found",
                                    "line-number-mismatch"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "settings",
                        "path": "/settings",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getSettings",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "no-user-session"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateSettings",
                                "method": "PATCH",
                                "path": "/",
                                "errors": [
                                    "no-user-session"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "smsRegistration",
                        "path": "/sms-registration",
                        "children": [
                            {
                                "type": "router",
                                "name": "brands",
                                "path": "/brands",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getBrand",
                                        "method": "GET",
                                        "path": "/{brandId}",
                                        "errors": [
                                            "brand-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getTmobileCap",
                                        "method": "GET",
                                        "path": "/{brandId}/tmobile-cap",
                                        "errors": [
                                            "brand-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getWorkflow",
                                        "method": "GET",
                                        "path": "/{brandId}/workflow",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listBrands",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "resetTwilio",
                                        "method": "DELETE",
                                        "path": "/{brandId}/twilio",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "restartWorkflow",
                                        "method": "POST",
                                        "path": "/{brandId}/workflow/restart",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getDeliveryHealth",
                                "method": "GET",
                                "path": "/delivery-health",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getIssueBreakdown",
                                "method": "GET",
                                "path": "/issue-breakdown",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getRegistrationBacklogSeries",
                                "method": "GET",
                                "path": "/registration-backlog",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getSummary",
                                "method": "GET",
                                "path": "/summary",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "subscriptionManagement",
                        "path": "/subscription-management",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "cancel",
                                "method": "POST",
                                "path": "/locations/{locationId}/cancel",
                                "errors": [
                                    "not-plg-subscription",
                                    "subscription-changed",
                                    "last-payment-changed",
                                    "last-payment-not-refundable",
                                    "refund-pending",
                                    "refund-failed",
                                    "shared-payment-not-refundable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPreview",
                                "method": "GET",
                                "path": "/locations/{locationId}",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "userNotifications",
                        "path": "/user-notifications",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getCatalog",
                                "method": "GET",
                                "path": "/catalog",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "preview",
                                "method": "POST",
                                "path": "/preview",
                                "errors": [
                                    "unknown-notification-type",
                                    "sample-location-brand-mismatch"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "testSend",
                                "method": "POST",
                                "path": "/test-send",
                                "errors": [
                                    "unknown-notification-type"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "xdrView",
                        "path": "/xdr-view",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getXdrLeadRouting",
                                "method": "GET",
                                "path": "/leads/{leadId}/routing",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listXdrLeads",
                                "method": "GET",
                                "path": "/leads",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "yextGbpIssuePolicies",
                        "path": "/yext-gbp-issue-policies",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listYextGbpIssuePolicies",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "policy",
                                "path": "/{code}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "classifyYextGbpIssuePolicy",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "confirmation-mismatch",
                                            "policy-not-found",
                                            "reason-required"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "hermes",
        "path": "/hermes",
        "children": [
            {
                "type": "router",
                "name": "analytics",
                "path": "/analytics",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getCategoryStats",
                        "method": "GET",
                        "path": "/category-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getComparativeOrderStats",
                        "method": "GET",
                        "path": "/comparative-orders-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCouponStats",
                        "method": "GET",
                        "path": "/coupon-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCustomerSourceStats",
                        "method": "GET",
                        "path": "/customer-source-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCustomerSubscriptionStats",
                        "method": "GET",
                        "path": "/customer-subscription-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyCustomerStats",
                        "method": "GET",
                        "path": "/customer-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyGiftCardChargeStats",
                        "method": "GET",
                        "path": "/daily-gift-card-charge-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyGiftCardStats",
                        "method": "GET",
                        "path": "/daily-gift-card-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyLoyaltyStats",
                        "method": "GET",
                        "path": "/daily-loyalty-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyMarketingStats",
                        "method": "GET",
                        "path": "/daily-marketing-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyOrderStats",
                        "method": "GET",
                        "path": "/daily-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyOwnerStats",
                        "method": "GET",
                        "path": "/daily-owner-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailySalesEpochsFromOrderSource",
                        "method": "GET",
                        "path": "/daily-sales-from-source-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailySalesStats",
                        "method": "GET",
                        "path": "/daily-sales-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailySessionStats",
                        "method": "GET",
                        "path": "/daily-session-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDailyUpsellStats",
                        "method": "GET",
                        "path": "/daily-upsell-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDeliveryStats",
                        "method": "GET",
                        "path": "/delivery-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getItemStats",
                        "method": "GET",
                        "path": "/item-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMarketingStats",
                        "method": "GET",
                        "path": "/marketing-summary",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getNewCustomers",
                        "method": "GET",
                        "path": "/new-customers",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getOrderConversionStats",
                        "method": "GET",
                        "path": "/order-conversion-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getOrderStatusStats",
                        "method": "GET",
                        "path": "/status-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getProductMixStats",
                        "method": "GET",
                        "path": "/product-mix-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getReturningCustomers",
                        "method": "GET",
                        "path": "/returning-customers",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getReviewsSummary",
                        "method": "GET",
                        "path": "/review-summary",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getSalesForCustomerSource",
                        "method": "GET",
                        "path": "/sales-for-customer-source",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getSourceStats",
                        "method": "GET",
                        "path": "/source-stats",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getStatsForToday",
                        "method": "GET",
                        "path": "/stats-today",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getTaxSummary",
                        "method": "GET",
                        "path": "/tax-summary",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "hestia",
        "path": "/hestia",
        "children": [
            {
                "type": "router",
                "name": "locations",
                "path": "/locations",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "activatePhoneRouting",
                        "method": "POST",
                        "path": "/{locationId}/phone/activate",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "changePhoneRoutingNumber",
                        "method": "POST",
                        "path": "/{locationId}/phone/number",
                        "errors": [
                            "invalid-area-code",
                            "unavailable",
                            "ineligible"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "checkPhoneRoutingNumberAvailability",
                        "method": "POST",
                        "path": "/{locationId}/phone/number/availability",
                        "errors": [
                            "invalid-area-code",
                            "unavailable",
                            "ineligible"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "confirmPhoneRoutingForwardingRemoved",
                        "method": "POST",
                        "path": "/{locationId}/phone/routing/forwarding-removed",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getLocation",
                        "method": "GET",
                        "path": "/{locationId}",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPhoneRoutingDashboard",
                        "method": "GET",
                        "path": "/{locationId}/phone/routing/dashboard",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPhoneRoutingListings",
                        "method": "GET",
                        "path": "/{locationId}/phone/routing/listings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPhoneRoutingRecording",
                        "method": "GET",
                        "path": "/{locationId}/phone/routing/recording",
                        "errors": [
                            "recording-not-found",
                            "recording-unavailable"
                        ],
                        "responseType": "arraybuffer"
                    },
                    {
                        "type": "endpoint",
                        "name": "getPhoneState",
                        "method": "GET",
                        "path": "/{locationId}/phone",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "joinPhoneAiWaitlist",
                        "method": "POST",
                        "path": "/{locationId}/phone/ai/waitlist",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "phoneAiVoice",
                        "path": "/{locationId}/phone/ai-voice",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "update",
                                "method": "PUT",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "phonePronunciation",
                        "path": "/{locationId}/phone/pronunciation",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "activate",
                                "method": "POST",
                                "path": "/activate",
                                "errors": [
                                    "conflict",
                                    "expired",
                                    "invalid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPreview",
                                "method": "GET",
                                "path": "/preview/{previewId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "preview",
                                "method": "POST",
                                "path": "/preview",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "remove",
                                "method": "DELETE",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "set",
                                "method": "PUT",
                                "path": "/",
                                "errors": [
                                    "invalid-audio",
                                    "not-configured"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "phoneVoice",
                        "path": "/{locationId}/phone/voice",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "preview",
                                "method": "POST",
                                "path": "/preview",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "update",
                                "method": "PUT",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "recordPhoneRoutingOffer",
                        "method": "POST",
                        "path": "/{locationId}/phone/routing/offer-viewed",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "resetPhoneRouting",
                        "method": "POST",
                        "path": "/{locationId}/phone/routing/reset",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setPhoneRouting",
                        "method": "POST",
                        "path": "/{locationId}/phone/routing",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "switchPhoneExperience",
                        "method": "POST",
                        "path": "/{locationId}/phone/experience",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updatePhoneRoutingSecondaryNumber",
                        "method": "PUT",
                        "path": "/{locationId}/phone/secondary-number",
                        "errors": [
                            "invalid-number",
                            "blocked-number",
                            "ineligible"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "menus",
                "path": "/menus/{locationId}/{menuId}",
                "children": [
                    {
                        "type": "router",
                        "name": "categories",
                        "path": "/categories",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getCategories",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getAllMenuData",
                        "method": "GET",
                        "path": "/all-entities",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMenu",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "modifiers",
                        "path": "/modifiers",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getModifier",
                                "method": "GET",
                                "path": "/{modifierId}",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "modifierSets",
                        "path": "/modifier-sets",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getModifierSet",
                                "method": "GET",
                                "path": "/{modifierSetId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getModifierSets",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "undoConsolidation",
                        "method": "POST",
                        "path": "/undo-consolidation",
                        "errors": [
                            "item-not-found",
                            "invalid-item",
                            "modifier-set-not-found",
                            "source-items-not-found"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "orders",
                "path": "/orders",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getOrder",
                        "method": "GET",
                        "path": "/{orderId}",
                        "errors": [
                            "order-not-found",
                            "location-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getOrders",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "conflicting-scope",
                            "missing-scope"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "paginate",
                        "path": "/paginate",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getCateringOrders",
                                "method": "GET",
                                "path": "/catering",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getCompletedOrders",
                                "method": "GET",
                                "path": "/completed",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getIncomingOrders",
                                "method": "GET",
                                "path": "/incoming",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getInProgressOrders",
                                "method": "GET",
                                "path": "/in-progress",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getScheduledOrders",
                                "method": "GET",
                                "path": "/scheduled",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands/{brandId}",
                        "children": [
                            {
                                "type": "router",
                                "name": "phone",
                                "path": "/phone",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getAvailability",
                                        "method": "GET",
                                        "path": "/availability",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getLocations",
                                        "method": "GET",
                                        "path": "/locations",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getRoutingDashboard",
                                        "method": "GET",
                                        "path": "/routing/dashboard",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSettings",
                                        "method": "GET",
                                        "path": "/settings",
                                        "errors": [
                                            "invalid-location"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "joinPhoneAiWaitlist",
                                        "method": "POST",
                                        "path": "/ai/waitlist",
                                        "errors": [
                                            "invalid-locations"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "pronunciation",
                                        "path": "/pronunciation",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "activate",
                                                "method": "POST",
                                                "path": "/activate",
                                                "errors": [
                                                    "conflict",
                                                    "expired",
                                                    "invalid"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPreview",
                                                "method": "GET",
                                                "path": "/preview/{previewId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "preview",
                                                "method": "POST",
                                                "path": "/preview",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "remove",
                                                "method": "DELETE",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "set",
                                                "method": "PUT",
                                                "path": "/",
                                                "errors": [
                                                    "invalid-audio"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setRouting",
                                        "method": "POST",
                                        "path": "/routing",
                                        "errors": [
                                            "invalid-locations"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "voice",
                                        "path": "/voice",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "preview",
                                                "method": "POST",
                                                "path": "/preview",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "PUT",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "phoneOrdering",
                                "path": "/phone-ordering",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "calls",
                                        "path": "/calls",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getCall",
                                                "method": "GET",
                                                "path": "/{callId}",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listCalls",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPhoneOrderingOverview",
                                        "method": "GET",
                                        "path": "/overview",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "languageNotes",
                                        "path": "/language-notes",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "approveLanguageNotesProposal",
                                                "method": "POST",
                                                "path": "/approve-proposal/{proposalId}",
                                                "errors": [
                                                    "stale-proposal"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "generateLanguageNotesProposal",
                                                "method": "POST",
                                                "path": "/generate-proposal",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getLanguageNotes",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "rejectLanguageNotesProposal",
                                                "method": "POST",
                                                "path": "/reject-proposal/{proposalId}",
                                                "errors": [
                                                    "stale-proposal"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "saveLanguageNotes",
                                                "method": "PUT",
                                                "path": "/",
                                                "errors": [
                                                    "stale-profile"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "learning",
                                        "path": "/learning",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "applyPhoneOrderingKnowledgePrompt",
                                                "method": "POST",
                                                "path": "/knowledge/prompt-apply",
                                                "errors": [
                                                    "invalid-diff",
                                                    "stale-knowledge"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "generatePhoneOrderingLearning",
                                                "method": "POST",
                                                "path": "/generate",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPhoneOrderingLearning",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "previewPhoneOrderingKnowledgePrompt",
                                                "method": "POST",
                                                "path": "/knowledge/prompt-preview",
                                                "errors": [
                                                    "invalid-prompt",
                                                    "model-failure"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "reviewPhoneOrderingRecommendation",
                                                "method": "POST",
                                                "path": "/recommendations/{recommendationId}/review",
                                                "errors": [
                                                    "invalid-decision",
                                                    "stale-recommendation"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "photographer",
                                "path": "/photographer",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createRun",
                                        "method": "POST",
                                        "path": "/runs",
                                        "errors": [
                                            "quota-exhausted",
                                            "ownership-unavailable"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getQuota",
                                        "method": "GET",
                                        "path": "/quota",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "keepRun",
                                        "method": "POST",
                                        "path": "/runs/{runId}/keep",
                                        "errors": [
                                            "unknown-run"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listPhotos",
                                        "method": "GET",
                                        "path": "/photos",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "promotionStatus",
                                        "method": "GET",
                                        "path": "/promotion-status",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "startRun",
                                        "method": "POST",
                                        "path": "/runs/{runId}/start",
                                        "errors": [
                                            "unknown-run",
                                            "start-in-progress"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "activatePhoneRouting",
                                "method": "POST",
                                "path": "/{locationId}/phone/activate",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "changePhoneRoutingNumber",
                                "method": "POST",
                                "path": "/{locationId}/phone/number",
                                "errors": [
                                    "invalid-area-code",
                                    "unavailable",
                                    "ineligible"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "checkPhoneRoutingNumberAvailability",
                                "method": "POST",
                                "path": "/{locationId}/phone/number/availability",
                                "errors": [
                                    "invalid-area-code",
                                    "unavailable",
                                    "ineligible"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "confirmPhoneRoutingForwardingRemoved",
                                "method": "POST",
                                "path": "/{locationId}/phone/routing/forwarding-removed",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getLocation",
                                "method": "GET",
                                "path": "/{locationId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getPhoneRoutingDashboard",
                                "method": "GET",
                                "path": "/{locationId}/phone/routing/dashboard",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getPhoneRoutingListings",
                                "method": "GET",
                                "path": "/{locationId}/phone/routing/listings",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getPhoneRoutingRecording",
                                "method": "GET",
                                "path": "/{locationId}/phone/routing/recording",
                                "errors": [
                                    "recording-not-found",
                                    "recording-unavailable"
                                ],
                                "responseType": "arraybuffer"
                            },
                            {
                                "type": "endpoint",
                                "name": "getPhoneState",
                                "method": "GET",
                                "path": "/{locationId}/phone",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "joinPhoneAiWaitlist",
                                "method": "POST",
                                "path": "/{locationId}/phone/ai/waitlist",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "phoneAiVoice",
                                "path": "/{locationId}/phone/ai-voice",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "update",
                                        "method": "PUT",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "phonePronunciation",
                                "path": "/{locationId}/phone/pronunciation",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "activate",
                                        "method": "POST",
                                        "path": "/activate",
                                        "errors": [
                                            "conflict",
                                            "expired",
                                            "invalid"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPreview",
                                        "method": "GET",
                                        "path": "/preview/{previewId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "preview",
                                        "method": "POST",
                                        "path": "/preview",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "remove",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "set",
                                        "method": "PUT",
                                        "path": "/",
                                        "errors": [
                                            "invalid-audio",
                                            "not-configured"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "phoneVoice",
                                "path": "/{locationId}/phone/voice",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "preview",
                                        "method": "POST",
                                        "path": "/preview",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "update",
                                        "method": "PUT",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "recordPhoneRoutingOffer",
                                "method": "POST",
                                "path": "/{locationId}/phone/routing/offer-viewed",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "resetPhoneRouting",
                                "method": "POST",
                                "path": "/{locationId}/phone/routing/reset",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "setPhoneRouting",
                                "method": "POST",
                                "path": "/{locationId}/phone/routing",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "switchPhoneExperience",
                                "method": "POST",
                                "path": "/{locationId}/phone/experience",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updatePhoneRoutingSecondaryNumber",
                                "method": "PUT",
                                "path": "/{locationId}/phone/secondary-number",
                                "errors": [
                                    "invalid-number",
                                    "blocked-number",
                                    "ineligible"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "menus",
                        "path": "/menus/{locationId}/{menuId}",
                        "children": [
                            {
                                "type": "router",
                                "name": "categories",
                                "path": "/categories",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getCategories",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getAllMenuData",
                                "method": "GET",
                                "path": "/all-entities",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getMenu",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "modifiers",
                                "path": "/modifiers",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getModifier",
                                        "method": "GET",
                                        "path": "/{modifierId}",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "modifierSets",
                                "path": "/modifier-sets",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getModifierSet",
                                        "method": "GET",
                                        "path": "/{modifierSetId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getModifierSets",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "undoConsolidation",
                                "method": "POST",
                                "path": "/undo-consolidation",
                                "errors": [
                                    "item-not-found",
                                    "invalid-item",
                                    "modifier-set-not-found",
                                    "source-items-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "orders",
                        "path": "/orders",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getOrder",
                                "method": "GET",
                                "path": "/{orderId}",
                                "errors": [
                                    "order-not-found",
                                    "location-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getOrders",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "conflicting-scope",
                                    "missing-scope"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "paginate",
                                "path": "/paginate",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getCateringOrders",
                                        "method": "GET",
                                        "path": "/catering",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCompletedOrders",
                                        "method": "GET",
                                        "path": "/completed",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getIncomingOrders",
                                        "method": "GET",
                                        "path": "/incoming",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getInProgressOrders",
                                        "method": "GET",
                                        "path": "/in-progress",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getScheduledOrders",
                                        "method": "GET",
                                        "path": "/scheduled",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "photographer",
                        "path": "/photographer",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "cachedUpscale",
                                "method": "GET",
                                "path": "/cached-upscale",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "classify",
                                "method": "POST",
                                "path": "/classify",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "createRun",
                                "method": "POST",
                                "path": "/runs",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getRun",
                                "method": "GET",
                                "path": "/runs/{runId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "startRun",
                                "method": "POST",
                                "path": "/runs/{runId}/start",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "quoteCheckout",
                        "path": "/quote-checkout",
                        "children": [
                            {
                                "type": "router",
                                "name": "checkoutSession",
                                "path": "/{checkoutSessionId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "execute",
                                        "method": "POST",
                                        "path": "/execute",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-checkout-session-not-found",
                                            "quote-checkout-session-unauthorized",
                                            "quote-checkout-session-not-open",
                                            "quote-checkout-session-expired",
                                            "quote-checkout-version-not-found",
                                            "quote-checkout-version-not-ready",
                                            "quote-checkout-snapshot-invalid",
                                            "quote-checkout-currency-mismatch",
                                            "quote-checkout-execution-failed",
                                            "quote-checkout-execution-snapshot-invalid",
                                            "quote-checkout-payment-method-required",
                                            "quote-checkout-payment-assignment-invalid",
                                            "stripe-proration-preview-failed",
                                            "quote-checkout-setup-intent-failed",
                                            "multi-brand-checkout-not-supported",
                                            "main-subscription-cycle-unavailable",
                                            "unsupported-quote-checkout-instruction",
                                            "quote-checkout-pricing-updated",
                                            "quote-checkout-bank-account-unverified",
                                            "quote-checkout-bank-account-blocked",
                                            "quote-price-outdated",
                                            "quote-checkout-deferred-invoice-not-payable",
                                            "quote-checkout-deferred-flip-failed",
                                            "quote-checkout-session-invalid-state",
                                            "quote-checkout-stalled-line-not-adoptable",
                                            "payment-method-not-found",
                                            "unauthorized-access",
                                            "invalid-payment-method",
                                            "card-declined",
                                            "invalid-cvc",
                                            "expired-card",
                                            "payment-not-captured"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "preview",
                                        "method": "POST",
                                        "path": "/preview",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-checkout-session-not-found",
                                            "quote-checkout-session-unauthorized",
                                            "quote-checkout-session-not-open",
                                            "quote-checkout-session-expired",
                                            "quote-checkout-version-not-found",
                                            "quote-checkout-version-not-ready",
                                            "quote-checkout-snapshot-invalid",
                                            "quote-checkout-currency-mismatch",
                                            "stripe-proration-preview-failed",
                                            "multi-brand-checkout-not-supported",
                                            "main-subscription-cycle-unavailable",
                                            "unsupported-quote-checkout-instruction"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "savedCards",
                                        "method": "POST",
                                        "path": "/saved-cards",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-checkout-session-not-found",
                                            "quote-checkout-session-unauthorized",
                                            "quote-checkout-session-not-open",
                                            "quote-checkout-session-expired",
                                            "quote-checkout-snapshot-invalid"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "savedPaymentMethods",
                                        "method": "POST",
                                        "path": "/saved-payment-methods",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-checkout-session-not-found",
                                            "quote-checkout-session-unauthorized",
                                            "quote-checkout-session-not-open",
                                            "quote-checkout-session-expired",
                                            "quote-checkout-snapshot-invalid"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setupIntent",
                                        "method": "POST",
                                        "path": "/setup-intent",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-checkout-session-not-found",
                                            "quote-checkout-session-unauthorized",
                                            "quote-checkout-session-not-open",
                                            "quote-checkout-session-expired",
                                            "quote-checkout-snapshot-invalid",
                                            "quote-checkout-setup-intent-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "state",
                                        "method": "POST",
                                        "path": "/state",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-checkout-session-not-found",
                                            "quote-checkout-session-unauthorized"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "quotes",
                                "path": "/quotes",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "quote",
                                        "path": "/{quoteId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "start",
                                                "method": "POST",
                                                "path": "/start",
                                                "errors": [
                                                    "feature-disabled",
                                                    "quote-not-approved",
                                                    "quote-not-found",
                                                    "quote-not-checkoutable"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resolve",
                                "method": "POST",
                                "path": "/resolve",
                                "errors": [
                                    "feature-disabled",
                                    "quote-checkout-session-not-found",
                                    "quote-checkout-session-unauthorized"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "sms",
                        "path": "/sms",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "sendAppDownloadSms",
                                "method": "POST",
                                "path": "/send-app-download",
                                "errors": [
                                    "sms-send-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "sendAppDownloadSmsPublic",
                                "method": "POST",
                                "path": "/send-app-download-public",
                                "errors": [
                                    "sms-send-failed"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "hodos",
        "path": "/hodos",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "redirects",
                        "path": "/redirects",
                        "children": [
                            {
                                "type": "router",
                                "name": "redirect",
                                "path": "/{slug}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "resolveHodosRedirect",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "hodos-redirect-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "hub",
        "path": "/v1/stripe",
        "children": [
            {
                "type": "endpoint",
                "name": "getStripeToken",
                "method": "POST",
                "path": "/token",
                "errors": [
                    "unauthorized"
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "images",
        "path": "/images",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "bulkUpdateMetadata",
                        "method": "PATCH",
                        "path": "/bulk-update-metadata",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "image",
                        "path": "/image",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getImage",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "imageNotFound"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "scoreImage",
                                "method": "POST",
                                "path": "/score",
                                "errors": [
                                    "scoringFailed"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "inbox",
        "path": "/inbox",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "locations",
                                        "path": "/locations",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "location",
                                                "path": "/{locationId}",
                                                "children": [
                                                    {
                                                        "type": "router",
                                                        "name": "threads",
                                                        "path": "/threads",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "list",
                                                                "method": "GET",
                                                                "path": "/",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "router",
                                                                "name": "thread",
                                                                "path": "/{threadId}",
                                                                "children": [
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "get",
                                                                        "method": "GET",
                                                                        "path": "/",
                                                                        "errors": [
                                                                            "thread-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "read",
                                                                        "method": "POST",
                                                                        "path": "/read",
                                                                        "errors": [
                                                                            "thread-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "reply",
                                                                        "method": "POST",
                                                                        "path": "/reply",
                                                                        "errors": [
                                                                            "thread-not-found",
                                                                            "invalid-transition",
                                                                            "outbound-failure",
                                                                            "listing-unavailable",
                                                                            "reply-feature-provisioning",
                                                                            "review-deleted",
                                                                            "already-replied-externally"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "suggestedReply",
                                                                        "method": "GET",
                                                                        "path": "/suggested-reply",
                                                                        "errors": [
                                                                            "thread-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "unread",
                                                                        "method": "POST",
                                                                        "path": "/unread",
                                                                        "errors": [
                                                                            "thread-not-found",
                                                                            "invalid-transition"
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "unreadCount",
                                                                "method": "GET",
                                                                "path": "/unread-count",
                                                                "errors": []
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "threads",
                                        "path": "/threads",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "non-org-subject"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "unreadCount",
                                                "method": "GET",
                                                "path": "/unread-count",
                                                "errors": [
                                                    "non-org-subject"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "unreadCountByLocation",
                                                "method": "GET",
                                                "path": "/unread-count-by-location",
                                                "errors": [
                                                    "non-org-subject"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "internal",
        "path": "/internal",
        "children": [
            {
                "type": "router",
                "name": "appleOnboarding",
                "path": "/apple-onboarding",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "notifyApproved",
                        "method": "POST",
                        "path": "/notify-approved",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "bulkDeployments",
                "path": "/bulk-deployments",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "activeBulk",
                        "method": "GET",
                        "path": "/active",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "buildingTemplateBulks",
                        "method": "GET",
                        "path": "/building-template",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "bulkLifecycle",
                        "method": "POST",
                        "path": "/{bulkId}/lifecycle",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "completeVerifiedAbort",
                        "method": "POST",
                        "path": "/{bulkId}/complete-verified-abort",
                        "errors": [
                            "forbidden",
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getBulkDeployment",
                        "method": "GET",
                        "path": "/{bulkId}",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "putBulkDeployment",
                        "method": "PUT",
                        "path": "/{bulkId}",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "queuedApps",
                        "method": "POST",
                        "path": "/{bulkId}/queued-apps",
                        "errors": [
                            "not-found"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "deployments",
                "path": "/deployments",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "aggregateDeployments",
                        "method": "GET",
                        "path": "/aggregate",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDeployment",
                        "method": "GET",
                        "path": "/{deploymentId}",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "listDeployments",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "unknown-status"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "putDeployment",
                        "method": "PUT",
                        "path": "/{deploymentId}",
                        "errors": [
                            "attempt-collision",
                            "idempotency-conflict",
                            "not-found",
                            "classifier-contract-violation"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "reconcileStale",
                        "method": "POST",
                        "path": "/{deploymentId}/reconcile-stale",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "recordAscSubmissionObservation",
                        "method": "POST",
                        "path": "/{deploymentId}/asc-submission-observations",
                        "errors": [
                            "forbidden",
                            "not-found",
                            "invalid-platform",
                            "invalid-app",
                            "observation-conflict"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "transitionDeployment",
                        "method": "POST",
                        "path": "/{deploymentId}/transitions",
                        "errors": [
                            "single-writer-conflict",
                            "monotonic-violation",
                            "idempotency-conflict",
                            "not-found",
                            "classifier-contract-violation"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "mobileApps",
                "path": "/mobile-apps",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "ascWebhookStatus",
                        "method": "PATCH",
                        "path": "/{mobileAppId}/asc-webhook-status",
                        "errors": [
                            "forbidden"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "bulkEligibility",
                        "method": "GET",
                        "path": "/bulk-eligibility",
                        "errors": [
                            "invalid-version"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "deploySnapshot",
                        "method": "GET",
                        "path": "/{brandId}/deploy-snapshot",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "recordAscReviewRejection",
                        "method": "POST",
                        "path": "/{brandId}/asc-review-rejections",
                        "errors": [
                            "forbidden",
                            "not-found",
                            "no-app-store-id",
                            "rejection-conflict"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "recordAscVersionStateObservation",
                        "method": "POST",
                        "path": "/{brandId}/asc-version-state-observations",
                        "errors": [
                            "forbidden",
                            "not-found",
                            "no-app-store-id",
                            "observation-conflict"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "recoveryActions",
                "path": "/recovery-actions",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getRecoveryInvocation",
                        "method": "GET",
                        "path": "/invocations/{invocationId}",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "invokeRecoveryAction",
                        "method": "POST",
                        "path": "/{category}/invocations",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "smsRegistration",
                "path": "/sms-registration",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getBrand",
                                "method": "GET",
                                "path": "/{brandId}",
                                "errors": [
                                    "brand-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getWorkflow",
                                "method": "GET",
                                "path": "/{brandId}/workflow",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listBrands",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "restartWorkflow",
                                "method": "POST",
                                "path": "/{brandId}/workflow/restart",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getSummary",
                        "method": "GET",
                        "path": "/summary",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "uberMenus",
                "path": "/uber-menus",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "import",
                        "method": "POST",
                        "path": "/import",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "submit",
                        "method": "POST",
                        "path": "/submit",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "items",
        "path": "/items",
        "children": [
            {
                "type": "endpoint",
                "name": "create",
                "method": "POST",
                "path": "/",
                "errors": [
                    "traversal-cycle",
                    "traversal-depth"
                ]
            },
            {
                "type": "endpoint",
                "name": "get",
                "method": "GET",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "item",
                "path": "/{menuItemId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "delete",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteImpact",
                        "method": "GET",
                        "path": "/delete-impact",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getModifierSets",
                        "method": "GET",
                        "path": "/modifier-sets",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedCategories",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedMenus",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifiers",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifierSets",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "like",
                        "method": "POST",
                        "path": "/like",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "setAvailability",
                        "method": "PATCH",
                        "path": "/availability",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "unlike",
                        "method": "POST",
                        "path": "/unlike",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "update",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "traversal-cycle",
                            "traversal-depth"
                        ]
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "markAsPopular",
                "method": "PATCH",
                "path": "/mark-as-popular",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "jobs",
        "path": "/jobs",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getOptions",
                        "method": "GET",
                        "path": "/options",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "run",
                        "method": "POST",
                        "path": "/run",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getOptions",
                        "method": "GET",
                        "path": "/options",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRuns",
                        "method": "GET",
                        "path": "/runs",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "run",
                        "method": "POST",
                        "path": "/run",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "kitchen",
        "path": "/kitchen",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getKitchenSettings",
                                        "method": "GET",
                                        "path": "/kitchen-settings",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateKitchenSettings",
                                        "method": "PATCH",
                                        "path": "/kitchen-settings",
                                        "errors": [
                                            "not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "launch",
        "path": "/launch",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getGatingContext",
                                        "method": "GET",
                                        "path": "/gating-context",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "updateLaunchConfiguration",
                                        "method": "PUT",
                                        "path": "/update-config",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "branding",
                                        "path": "/branding",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "confirmBranding",
                                                "method": "POST",
                                                "path": "/confirm",
                                                "errors": [
                                                    "location-not-in-brand"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "confirmLogo",
                                                "method": "POST",
                                                "path": "/confirm-logo",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "enableAutomatedMarketing",
                                        "method": "POST",
                                        "path": "/automated-marketing/enable",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "kickoff",
                                        "path": "/kickoff",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "completeKickoff",
                                                "method": "POST",
                                                "path": "/complete",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getKickoffContent",
                                                "method": "GET",
                                                "path": "/content",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getKickoffStatus",
                                                "method": "GET",
                                                "path": "/status",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "legalEntities",
                                        "path": "/legal-entities",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "addOwners",
                                                "method": "POST",
                                                "path": "/{legalEntityId}/owners",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "assignLocations",
                                                "method": "POST",
                                                "path": "/{legalEntityId}/locations",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "checkEin",
                                                "method": "POST",
                                                "path": "/check-ein",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createLegalEntity",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "deleteLegalEntity",
                                                "method": "DELETE",
                                                "path": "/{legalEntityId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listLegalEntities",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "unassignLocations",
                                                "method": "DELETE",
                                                "path": "/{legalEntityId}/locations",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateLegalEntity",
                                                "method": "PATCH",
                                                "path": "/{legalEntityId}",
                                                "errors": [
                                                    "ein-conflict"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "messaging",
                                        "path": "/messaging",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "listFeed",
                                                "method": "GET",
                                                "path": "/feed",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listSendAddresses",
                                                "method": "GET",
                                                "path": "/addresses",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "sendSms",
                                                "method": "POST",
                                                "path": "/sms",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "pickupDeliverySetup",
                                        "path": "/pickup-delivery-setup",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "applyDeliveryZones",
                                                "method": "POST",
                                                "path": "/delivery-zones/apply",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "applyTimeSettings",
                                                "method": "POST",
                                                "path": "/time-settings/apply",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "approveMenu",
                                        "method": "POST",
                                        "path": "/approve-menu",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "approveWebsiteAndOloLaunch",
                                        "method": "POST",
                                        "path": "/approve-website-and-olo-launch",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "archiveManualTask",
                                        "method": "DELETE",
                                        "path": "/manual-tasks/{taskId}",
                                        "errors": [
                                            "manual-task-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "confirmHardwareReceipt",
                                        "method": "POST",
                                        "path": "/confirm-hardware-receipt",
                                        "errors": [
                                            "hardware-order-mismatch",
                                            "hardware-not-delivered",
                                            "no-hardware-order-submitted",
                                            "salesforce-shipment-fetch-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "confirmOloTestOrderPrint",
                                        "method": "POST",
                                        "path": "/olo-test-order/confirm-print",
                                        "errors": [
                                            "olo-test-order-print-confirmation-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createCloverOAuthUrl",
                                        "method": "POST",
                                        "path": "/clover-oauth-url",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createHardwareOrder",
                                        "method": "POST",
                                        "path": "/create-hardware-order",
                                        "errors": [
                                            "quote-hardware-order-already-requested",
                                            "no-brand-admin",
                                            "salesforce-account-not-synced",
                                            "salesforce-account-create-failed",
                                            "salesforce-contact-create-failed",
                                            "salesforce-order-create-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createManualTask",
                                        "method": "POST",
                                        "path": "/manual-tasks",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createOloTestOrderCode",
                                        "method": "POST",
                                        "path": "/olo-test-order-code",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createUberDisconnectUrl",
                                        "method": "POST",
                                        "path": "/uber-disconnect-url",
                                        "errors": [
                                            "feature-disabled",
                                            "not-connected"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createUberOAuthUrl",
                                        "method": "POST",
                                        "path": "/uber-oauth-url",
                                        "errors": [
                                            "feature-disabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createUberSpecialistSetupCallBooking",
                                        "method": "POST",
                                        "path": "/create-uber-specialist-setup-call-booking",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBusinessInfo",
                                        "method": "GET",
                                        "path": "/business-info",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getChecklistStatus",
                                        "method": "GET",
                                        "path": "/checklist-status",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getDomainSetupWorkflowState",
                                        "method": "GET",
                                        "path": "/domain-setup",
                                        "errors": [
                                            "workflow-not-applicable"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getLaunchWorkflows",
                                        "method": "GET",
                                        "path": "/workflows",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getOloTestOrderHealthCheck",
                                        "method": "GET",
                                        "path": "/olo-test-order/health-check",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getOloTestOrderStatus",
                                        "method": "GET",
                                        "path": "/olo-test-order-status",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "launchDomain",
                                        "method": "POST",
                                        "path": "/launch-domain",
                                        "errors": [
                                            "domain-launch-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "launchOlo",
                                        "method": "POST",
                                        "path": "/launch-olo",
                                        "errors": [
                                            "olo-launch-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "launchWebsiteAndOlo",
                                        "method": "POST",
                                        "path": "/launch-website-and-olo",
                                        "errors": [
                                            "domain-launch-failed",
                                            "olo-launch-failed",
                                            "website-and-olo-launch-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listManualTasks",
                                        "method": "GET",
                                        "path": "/manual-tasks",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listUberSpecialistSetupCallSlots",
                                        "method": "POST",
                                        "path": "/list-uber-specialist-setup-call-slots",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listUberStores",
                                        "method": "GET",
                                        "path": "/uber-stores",
                                        "errors": [
                                            "test-pos-forbidden",
                                            "feature-disabled",
                                            "authorization-expired"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "recordConsultationBooking",
                                        "method": "POST",
                                        "path": "/record-consultation-booking",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "recordLaunchCallBooking",
                                        "method": "POST",
                                        "path": "/record-launch-call-booking",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "recordPosCallBooking",
                                        "method": "POST",
                                        "path": "/record-pos-call-booking",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "recordUberSpecialistSetupCallBooking",
                                        "method": "POST",
                                        "path": "/record-uber-specialist-setup-call-booking",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "requestHardwareOrderApproval",
                                        "method": "POST",
                                        "path": "/request-hardware-order-approval",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "rescheduleUberSpecialistSetupCallBooking",
                                        "method": "POST",
                                        "path": "/reschedule-uber-specialist-setup-call-booking",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "selectDomain",
                                        "method": "POST",
                                        "path": "/select-domain",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "selectUberStore",
                                        "method": "POST",
                                        "path": "/uber-store",
                                        "errors": [
                                            "test-pos-forbidden",
                                            "feature-disabled",
                                            "authorization-expired",
                                            "pos-conflict",
                                            "store-in-use",
                                            "claim-lost",
                                            "wrong-merchant-account",
                                            "uber-already-live"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "submitBusinessInfo",
                                        "method": "POST",
                                        "path": "/business-info",
                                        "errors": [
                                            "ein-required"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "submitDomainInformation",
                                        "method": "POST",
                                        "path": "/submit-domain-information",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "submitOloTestOrder",
                                        "method": "POST",
                                        "path": "/olo-test-order/submit",
                                        "errors": [
                                            "test-pos-forbidden"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "submitPosSelection",
                                        "method": "POST",
                                        "path": "/submit-pos-selection",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "submitPreConsultationInfo",
                                        "method": "POST",
                                        "path": "/submit-pre-consultation-info",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "submitSkipFeedback",
                                        "method": "POST",
                                        "path": "/submit-skip-feedback",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "toggleDomainSelfServe",
                                        "method": "POST",
                                        "path": "/toggle-domain-self-serve",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateChecklistItem",
                                        "method": "POST",
                                        "path": "/update-checklist-item",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateLaunchConfiguration",
                                        "method": "PUT",
                                        "path": "/update-config",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateManualTask",
                                        "method": "PATCH",
                                        "path": "/manual-tasks/{taskId}",
                                        "errors": [
                                            "manual-task-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "messaging",
                        "path": "/messaging",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listGlobalInbox",
                                "method": "GET",
                                "path": "/global-inbox",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listSpecialistInbox",
                                "method": "GET",
                                "path": "/inbox",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v3",
                "path": "/v3",
                "children": [
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getProductOperation",
                                        "method": "GET",
                                        "path": "/product-operations/{operationId}",
                                        "errors": [
                                            "operation-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "requestLaunch",
                                        "method": "POST",
                                        "path": "/request-launch",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "requestOloLaunch",
                                        "method": "POST",
                                        "path": "/request-olo-launch",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "requestSiteLaunch",
                                        "method": "POST",
                                        "path": "/request-site-launch",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "legal",
        "path": "/legal",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "acceptances",
                        "path": "/acceptances",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createAcceptance",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "agreements",
                        "path": "/agreements",
                        "children": [
                            {
                                "type": "router",
                                "name": "agreement",
                                "path": "/{agreementId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "get",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createAgreement",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getAgreements",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "acceptances",
                                        "path": "/acceptances",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "lifecycle",
        "path": "/lifecycle",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "attestations",
                                        "path": "/attestations",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "listLifecycleAttestations",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "recordLifecycleAttestation",
                                                "method": "POST",
                                                "path": "/record",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "checks",
                                        "path": "/checks",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "unwaiveLifecycleCheck",
                                                "method": "POST",
                                                "path": "/unwaive",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "waiveLifecycleCheck",
                                                "method": "POST",
                                                "path": "/waive",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandLifecycleState",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandLifecycleStateSettled",
                                        "method": "GET",
                                        "path": "/settled",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "timeline",
                                        "path": "/timeline",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getLifecycleTimeline",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "transitions",
                                        "path": "/transitions",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "signalBrandLifecycleTransition",
                                                "method": "POST",
                                                "path": "/signal",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getLocationLifecycleState",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getLocationLifecycleStateSettled",
                                        "method": "GET",
                                        "path": "/settled",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "holdLocationLifecycle",
                                        "method": "POST",
                                        "path": "/hold",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "resumeLocationLifecycle",
                                        "method": "POST",
                                        "path": "/resume",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "transitions",
                                        "path": "/transitions",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "signalLocationLifecycleTransition",
                                                "method": "POST",
                                                "path": "/signal",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "machine",
                        "path": "/machine",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getLifecycleMachine",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "workflows",
                "path": "/workflows",
                "children": [
                    {
                        "type": "router",
                        "name": "v1",
                        "path": "/v1",
                        "children": [
                            {
                                "type": "router",
                                "name": "brands",
                                "path": "/brands",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "brand",
                                        "path": "/{brandId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getWorkflows",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "internal-server-error"
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "locations",
                                                "path": "/locations",
                                                "children": [
                                                    {
                                                        "type": "router",
                                                        "name": "location",
                                                        "path": "/{locationId}",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "createWorkflow",
                                                                "method": "POST",
                                                                "path": "/workflow",
                                                                "errors": [
                                                                    "lifecycle-service-error"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getLocationWorkflows",
                                                                "method": "GET",
                                                                "path": "/",
                                                                "errors": [
                                                                    "internal-server-error"
                                                                ]
                                                            },
                                                            {
                                                                "type": "router",
                                                                "name": "signals",
                                                                "path": "/signals",
                                                                "children": [
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "listingOptedIn",
                                                                        "method": "POST",
                                                                        "path": "/listing-opted-in",
                                                                        "errors": [
                                                                            "lifecycle-service-error"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "restartPolling",
                                                                        "method": "POST",
                                                                        "path": "/restart-polling",
                                                                        "errors": [
                                                                            "lifecycle-service-error"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "subscriptionCreated",
                                                                        "method": "POST",
                                                                        "path": "/subscription-created",
                                                                        "errors": [
                                                                            "lifecycle-service-error"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "websiteLive",
                                                                        "method": "POST",
                                                                        "path": "/website-live",
                                                                        "errors": [
                                                                            "lifecycle-service-error"
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "triggerLocationWorkflows",
                                                                "method": "POST",
                                                                "path": "/trigger-workflows",
                                                                "errors": []
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "listings",
        "path": "/listings",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "categories",
                                        "path": "/categories",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getCategories",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "listings-error",
                                                    "location-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "publishListings",
                                                "method": "POST",
                                                "path": "/publish",
                                                "errors": [
                                                    "publish-error"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "setCategories",
                                                "method": "PATCH",
                                                "path": "/",
                                                "errors": [
                                                    "listings-error",
                                                    "location-not-found"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "locations",
                                        "path": "/locations",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "location",
                                                "path": "/{locationId}",
                                                "children": [
                                                    {
                                                        "type": "router",
                                                        "name": "seo",
                                                        "path": "/seo",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "checkGbpDiscrepancyFlag",
                                                                "method": "GET",
                                                                "path": "/gbp-discrepancy-flag",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "compareGbpDiscrepancy",
                                                                "method": "POST",
                                                                "path": "/gbp-discrepancy",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "createGBPData",
                                                                "method": "POST",
                                                                "path": "/gbp-data",
                                                                "errors": [
                                                                    "gbp-data-error"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "createGmbPulse",
                                                                "method": "POST",
                                                                "path": "/gmb-pulse",
                                                                "errors": [
                                                                    "gmb-pulse-error",
                                                                    "workflow-start-error"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getLatestGBPData",
                                                                "method": "GET",
                                                                "path": "/gbp-data",
                                                                "errors": [
                                                                    "gbp-data-error",
                                                                    "workflow-start-error"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getLatestGmbPulse",
                                                                "method": "GET",
                                                                "path": "/gmb-pulse",
                                                                "errors": [
                                                                    "gmb-pulse-error"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "resolveGbpDiscrepancy",
                                                                "method": "POST",
                                                                "path": "/resolve-gbp-discrepancy",
                                                                "errors": [
                                                                    "no-gbp-data",
                                                                    "resolve-error"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "triggerGbpIngestionWorkflow",
                                                                "method": "POST",
                                                                "path": "/gbp-ingestion-workflow",
                                                                "errors": [
                                                                    "feature-disabled",
                                                                    "workflow-start-error"
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "seo",
                                        "path": "/seo",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getGscVerification",
                                                "method": "GET",
                                                "path": "/gsc-verification",
                                                "errors": [
                                                    "gsc-verification-error"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "fetchGBPCategories",
                        "method": "GET",
                        "path": "/gbp-categories",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "mappings",
                        "path": "/mappings",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "categories",
                                "method": "GET",
                                "path": "/categories",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "locations",
        "path": "/locations",
        "children": [
            {
                "type": "endpoint",
                "name": "getLocations",
                "method": "GET",
                "path": "/",
                "errors": [
                    "unscoped-location-pagination-forbidden"
                ]
            },
            {
                "type": "router",
                "name": "location",
                "path": "/{locationId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "approveSalesTaxSuggestion",
                        "method": "POST",
                        "path": "/sales-tax-suggestion/approve",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "clearOtterMigrationStoreId",
                        "method": "POST",
                        "path": "/clear-otter-migration-store-id",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "configureOwnerPos",
                        "method": "PUT",
                        "path": "/owner-pos",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "createTestPosCloverOAuthUrl",
                        "method": "POST",
                        "path": "/test-pos/clover-oauth-url",
                        "errors": [
                            "test-pos-forbidden"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "createTestPosUberOAuthUrl",
                        "method": "POST",
                        "path": "/test-pos/uber-oauth-url",
                        "errors": [
                            "test-pos-forbidden",
                            "uber-already-live"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteThrottleCounters",
                        "method": "DELETE",
                        "path": "/checkout-settings/throttle-counters",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteThrottleCounterSlot",
                        "method": "DELETE",
                        "path": "/checkout-settings/throttle-counters/slot",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "forceRemoveUberPos",
                        "method": "POST",
                        "path": "/force-remove-uber-pos",
                        "errors": [
                            "not-connected"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "funnel",
                        "path": "/funnel",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "setLinks",
                                "method": "PUT",
                                "path": "/links",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getAllMenus",
                        "method": "GET",
                        "path": "/menus",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCateringSettings",
                        "method": "GET",
                        "path": "/catering-settings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCheckoutSettings",
                        "method": "GET",
                        "path": "/checkout-settings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCustomers",
                        "method": "GET",
                        "path": "/customers",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getDeliveryConfigs",
                        "method": "GET",
                        "path": "/delivery",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getLocation",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "location-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getLocationMainPhone",
                        "method": "GET",
                        "path": "/main-phone",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getLocationOrderSettings",
                        "method": "GET",
                        "path": "/order-settings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getLocationSeoSettings",
                        "method": "GET",
                        "path": "/seo-settings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getLocationSettings",
                        "method": "GET",
                        "path": "/settings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMenuSyncs",
                        "method": "GET",
                        "path": "/menu-sync",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMyLikes",
                        "method": "GET",
                        "path": "/my-likes",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getOnlineHealthScore",
                        "method": "GET",
                        "path": "/online-health",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPosIntegrationStatus",
                        "method": "GET",
                        "path": "/pos-integration-status",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPosStoreSettings",
                        "method": "GET",
                        "path": "/pos-store-settings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getSalesTaxSuggestion",
                        "method": "GET",
                        "path": "/sales-tax-suggestion",
                        "errors": [
                            "address-required",
                            "tax-lookup-failed"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getTabletLoginPassphrase",
                        "method": "GET",
                        "path": "/tablet-login-passphrase",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getTabletPermissions",
                        "method": "GET",
                        "path": "/tablet-permissions",
                        "errors": [
                            "not-found",
                            "fetch-failed"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getTestPos",
                        "method": "GET",
                        "path": "/test-pos",
                        "errors": [
                            "test-pos-forbidden"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getThrottleCounters",
                        "method": "GET",
                        "path": "/checkout-settings/throttle-counters",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getThrottleExclusions",
                        "method": "GET",
                        "path": "/checkout-settings/throttle-exclusions",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "importOtterMenu",
                        "method": "POST",
                        "path": "/import-otter-menu",
                        "errors": [
                            "import-failed"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "invoices",
                        "path": "/invoices",
                        "children": [
                            {
                                "type": "router",
                                "name": "invoice",
                                "path": "/{invoiceId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "retryPayment",
                                        "method": "POST",
                                        "path": "/retry-payment",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "linkOtterStore",
                        "method": "PUT",
                        "path": "/otter-store-id",
                        "errors": [
                            "otter-store-id-in-use"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "linkSquareLocation",
                        "method": "PUT",
                        "path": "/square-location",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "linkUberStore",
                        "method": "PUT",
                        "path": "/uber-store-id",
                        "errors": [
                            "uber-store-id-in-use",
                            "pos-already-connected"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "processingSettings",
                        "path": "/processing-settings",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getProcessingSettings",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "rateCards",
                                "path": "/rate-cards",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createRateCard",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "no-custom-stripe-account"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "current",
                                        "path": "/current",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "deleteCurrentRateCard",
                                                "method": "DELETE",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getCurrentRateCard",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "putTabletPermissions",
                        "method": "PUT",
                        "path": "/tablet-permissions",
                        "errors": [
                            "not-found",
                            "update-failed"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "recreateSync",
                        "method": "POST",
                        "path": "/recreate-sync",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "removePosIntegration",
                        "method": "DELETE",
                        "path": "/pos",
                        "errors": [
                            "uber-requires-authorization"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "removeTestPos",
                        "method": "DELETE",
                        "path": "/test-pos",
                        "errors": [
                            "test-pos-forbidden"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "restorePos",
                        "method": "POST",
                        "path": "/restore-pos",
                        "errors": [
                            "no-archived-pos",
                            "ambiguous-restore-target"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setTestPos",
                        "method": "PUT",
                        "path": "/test-pos",
                        "errors": [
                            "test-pos-forbidden",
                            "location-not-found",
                            "otter-store-id-in-use",
                            "same-as-live-pos"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "specialHours",
                        "path": "/special-hours",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createSpecialHours",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getSpecialHours",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "specialHoursEntry",
                                "path": "/{specialHoursId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteSpecialHoursEntry",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSpecialHoursEntry",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "squareTicketComm",
                        "method": "POST",
                        "path": "/square-ticket-comm",
                        "errors": [
                            "location-not-found",
                            "operation-not-supported",
                            "pos-failed"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "unlinkStripeAccount",
                        "method": "PATCH",
                        "path": "/unlink-stripe",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updateCateringNotificationRecipients",
                        "method": "PATCH",
                        "path": "/catering-notification-recipients",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updateCateringSettings",
                        "method": "PATCH",
                        "path": "/catering-settings",
                        "errors": [
                            "invalid-catering-constraint",
                            "no-fields-to-update"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateCheckoutSettings",
                        "method": "PATCH",
                        "path": "/checkout-settings",
                        "errors": [
                            "not-found",
                            "invalid-day-part-overrides",
                            "day-parts-missing-day",
                            "day-parts-duration-negative",
                            "day-parts-invalid-time-values",
                            "day-parts-overlapping",
                            "invalid-tip-options",
                            "tip-options-invalid-array-length",
                            "tip-options-not-increasing",
                            "tip-options-invalid-default",
                            "tip-options-invalid-percentage",
                            "tip-options-invalid-fixed-amount",
                            "tip-options-third-party-required",
                            "tip-options-cannot-be-null",
                            "store-closed-cannot-pause"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateGuestBearing",
                        "method": "PATCH",
                        "path": "/guest-bearing",
                        "errors": [
                            "invalid-guestBearing-value",
                            "failed-to-update"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateLocation",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "main-phone-locked",
                            "invalid-main-phone",
                            "slug-not-available",
                            "invalid-address",
                            "location-country-mismatch",
                            "unsupported-region",
                            "uber-deliveries-in-progress",
                            "uber-address-sync-failed",
                            "invalid-phone",
                            "invalid-hours-buffer",
                            "invalid-catering-constraint",
                            "pickup-managed-by-uber",
                            "failed-to-update"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateLocationOrderSettings",
                        "method": "PATCH",
                        "path": "/order-settings",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updateLocationSeoSettings",
                        "method": "PATCH",
                        "path": "/seo-settings",
                        "errors": [
                            "forbidden"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateOwnerFeeSettings",
                        "method": "PATCH",
                        "path": "/owner-fee-settings",
                        "errors": [
                            "invalid-fixed-fee",
                            "invalid-percent-fee",
                            "invalid-fee-cap",
                            "invalid-subtotal-cap",
                            "invalid-guestBearing-value",
                            "failed-to-update"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updatePosFeatures",
                        "method": "PATCH",
                        "path": "/pos-features",
                        "errors": [
                            "menu-sync-not-supported-for-pos",
                            "pos-not-found-for-location"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "marketing",
        "path": "/marketing",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "blocks",
                        "path": "/blocks",
                        "children": [
                            {
                                "type": "router",
                                "name": "block",
                                "path": "/{blockId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "deleteBlock",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBlock",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateBlock",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "carts",
                                        "path": "/carts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getLatestCartForCustomer",
                                                "method": "GET",
                                                "path": "/latest/{customerId}",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "coupons",
                                        "path": "/coupons",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "checkGuestCouponEligibility",
                                                "method": "GET",
                                                "path": "/{resourceId}/guest-eligibility/{customerId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getRenderableCoupon",
                                                "method": "GET",
                                                "path": "/{resourceId}/renderable",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createHotLaunchCampaign",
                                        "method": "POST",
                                        "path": "/hot-launch",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createPrebuiltCampaigns",
                                        "method": "POST",
                                        "path": "/campaigns",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "customCampaigns",
                                        "path": "/campaigns",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "reportMe2TerminalStatus",
                                                "method": "POST",
                                                "path": "/by-slug/{slug}/me2-status",
                                                "errors": [
                                                    "campaign-not-found"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deleteHotLaunchCampaign",
                                        "method": "DELETE",
                                        "path": "/hot-launch",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "deviceFingerprints",
                                        "path": "/device-fingerprints",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "checkFingerprint",
                                                "method": "POST",
                                                "path": "/check-fingerprint",
                                                "errors": [
                                                    "missing-brand-campaign"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "checkFingerprintForCampaign",
                                                "method": "POST",
                                                "path": "/check-fingerprint-for-campaign",
                                                "errors": [
                                                    "missing-brand-campaign"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createFingerprint",
                                                "method": "POST",
                                                "path": "/create-fingerprint",
                                                "errors": [
                                                    "missing-fingerprint-source",
                                                    "invalid-fingerprint-source",
                                                    "missing-brand-campaign",
                                                    "create-fingerprint-error"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "matchFingerprint",
                                                "method": "POST",
                                                "path": "/match-fingerprint",
                                                "errors": [
                                                    "match-fingerprint-error"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandCampaignAnalytics",
                                        "method": "GET",
                                        "path": "/analytics",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandContext",
                                        "method": "GET",
                                        "path": "/brand-context",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandMarketingSettings",
                                        "method": "GET",
                                        "path": "/settings",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getTopPerformingCampaigns",
                                        "method": "GET",
                                        "path": "/top-performing",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "items",
                                        "path": "/items",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getRenderableItem",
                                                "method": "GET",
                                                "path": "/{resourceId}/renderable",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getRepresentativeItem",
                                                "method": "GET",
                                                "path": "/representative-item",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "locations",
                                        "path": "/locations",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "location",
                                                "path": "/{locationId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getLocationInfo",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "location-not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "shortLinkRedirecter",
                                        "method": "GET",
                                        "path": "/redirect",
                                        "errors": [
                                            "invalid-path",
                                            "invalid-token",
                                            "invalid-scan-params",
                                            "internal-server-error"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "templates",
                                        "path": "/templates",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "template",
                                                "path": "/{templateSlug}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getInCodeTemplate",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "trackShortlinkRedirectEvent",
                                        "method": "POST",
                                        "path": "/track-shortlink-redirect-event",
                                        "errors": [
                                            "missing-redirect-slug",
                                            "brand-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateBrandMarketingSettings",
                                        "method": "PATCH",
                                        "path": "/settings",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "campaigns",
                        "path": "/campaigns",
                        "children": [
                            {
                                "type": "router",
                                "name": "campaign",
                                "path": "/{campaignId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "addParticipant",
                                        "method": "POST",
                                        "path": "/participant",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createBlock",
                                        "method": "POST",
                                        "path": "/blocks",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deleteCampaign",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": [
                                            "campaign-already-sending",
                                            "archive-cancel-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "editMe2CustomCampaign",
                                        "method": "POST",
                                        "path": "/edit-me2-custom-campaign",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBlocks",
                                        "method": "GET",
                                        "path": "/blocks",
                                        "errors": [
                                            "campaign-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCampaign",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "campaign-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCampaignAnalytics",
                                        "method": "GET",
                                        "path": "/analytics",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getEligibleParticipants",
                                        "method": "GET",
                                        "path": "/eligible-participants",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getFullBlockGraph",
                                        "method": "GET",
                                        "path": "/block-graph",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "mobilePromotionalCopy",
                                        "method": "GET",
                                        "path": "/mobile-promotional-copy",
                                        "errors": [
                                            "campaign-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "retargetCampaign",
                                        "method": "POST",
                                        "path": "/retarget",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "revalidateCampaign",
                                        "method": "POST",
                                        "path": "/revalidate",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "scheduleCustomCampaign",
                                        "method": "POST",
                                        "path": "/schedule",
                                        "errors": [
                                            "marketing-not-available"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateCampaign",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "marketing-not-available"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createCampaign",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "marketing-sms-not-available"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getCampaigns",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "templates",
                        "path": "/templates",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getInCodeTemplates",
                                "method": "GET",
                                "path": "/in-code-templates",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "testSendEmail",
                        "path": "/test-send-email",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "testSendEmail",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "invalid-template-slug",
                                    "missing-template",
                                    "template-not-found",
                                    "send-failed"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandContext",
                                        "method": "GET",
                                        "path": "/brand-context",
                                        "errors": [
                                            "theme-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getMarketingSettingsForBrand",
                                        "method": "GET",
                                        "path": "/settings",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getSalesOverview",
                                        "method": "GET",
                                        "path": "/sales-overview",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateMarketingSettingsForBrand",
                                        "method": "PATCH",
                                        "path": "/settings",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "campaigns",
                        "path": "/campaigns",
                        "children": [
                            {
                                "type": "router",
                                "name": "automated",
                                "path": "/automated",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getCalendarCampaigns",
                                        "method": "GET",
                                        "path": "/calendar",
                                        "errors": [
                                            "brandIdRequired",
                                            "conflictingTimeframeFilters"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getLifecycleCampaigns",
                                        "method": "GET",
                                        "path": "/lifecycle",
                                        "errors": [
                                            "brandIdRequired"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "campaign",
                                "path": "/{campaignSlug}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "brands",
                                        "path": "/brands",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "brand",
                                                "path": "/{brandId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getCampaign",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "campaignNotFound",
                                                            "internalServerError"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getCampaignAnalytics",
                                                        "method": "GET",
                                                        "path": "/analytics",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "router",
                                                        "name": "templates",
                                                        "path": "/templates",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getTemplates",
                                                                "method": "GET",
                                                                "path": "/",
                                                                "errors": [
                                                                    "missing-template-parameter"
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateCampaign",
                                                        "method": "PATCH",
                                                        "path": "/",
                                                        "errors": [
                                                            "campaignNotFound",
                                                            "internalServerError"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "campaignById",
                                "path": "/{campaignId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getCampaign",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getCampaigns",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "brandIdRequired"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "me1CampaignMigration",
                                "path": "/me1-campaign-migration/{campaignSlug}/brands/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "disconnectME1CampaignCoupons",
                                        "method": "POST",
                                        "path": "/disconnect-coupons",
                                        "errors": [
                                            "internalServerError"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getME1CampaignStatus",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "campaignNotFound",
                                            "internalServerError"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "marketplace",
        "path": "/marketplace",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "integrations",
                                        "path": "/integrations",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "doordash",
                                                "path": "/doordash",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "activateIntegration",
                                                        "method": "POST",
                                                        "path": "/activate-integration",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "settings-not-found",
                                                            "not-onboarding",
                                                            "not-menu-qualified",
                                                            "db-error",
                                                            "doordash-api-error"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "connectionStatus",
                                                        "method": "GET",
                                                        "path": "/connection-status",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteMerchantJwt",
                                                        "method": "DELETE",
                                                        "path": "/merchant-jwt",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getMarketplaceSettings",
                                                        "method": "GET",
                                                        "path": "/marketplace-settings",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getNewMerchantUrl",
                                                        "method": "POST",
                                                        "path": "/signup-url",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "location-not-found",
                                                            "missing-address",
                                                            "missing-phone",
                                                            "missing-email",
                                                            "doordash-api-error"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "oauth",
                                                        "method": "GET",
                                                        "path": "/oauth",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "onboardingMenuPull",
                                                        "method": "POST",
                                                        "path": "/onboarding-menu-pull",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "settings-not-found",
                                                            "not-onboarding",
                                                            "already-active",
                                                            "doordash-api-error"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "storeMappings",
                                                        "method": "POST",
                                                        "path": "/store-mappings",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "invalid-location"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "stores",
                                                        "method": "GET",
                                                        "path": "/stores",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "token-not-found",
                                                            "token-expired",
                                                            "not-business-admin",
                                                            "api-error"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "grubhub",
                                                "path": "/grubhub",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "connectionStatus",
                                                        "method": "GET",
                                                        "path": "/connection-status",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "connectStores",
                                                        "method": "POST",
                                                        "path": "/connect-stores",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "oauth-required",
                                                            "location-not-in-brand"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deactivate",
                                                        "method": "POST",
                                                        "path": "/deactivate",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "not-connected",
                                                            "cross-brand"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deactivateStore",
                                                        "method": "POST",
                                                        "path": "/deactivate-store",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "oauth-required",
                                                            "owner-integration-exists"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteMerchantToken",
                                                        "method": "DELETE",
                                                        "path": "/merchant-token",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "marketplaceSettings",
                                                        "method": "GET",
                                                        "path": "/marketplace-settings",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "oauth",
                                                        "method": "POST",
                                                        "path": "/oauth",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "selfDeactivate",
                                                        "method": "POST",
                                                        "path": "/self-deactivate",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "not-connected",
                                                            "cross-brand",
                                                            "oauth-required"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "stores",
                                                        "method": "GET",
                                                        "path": "/stores",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "oauth-required",
                                                            "oauth-expired"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "ubereats",
                                                "path": "/ubereats",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "connectionStatus",
                                                        "method": "GET",
                                                        "path": "/connection-status",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "connection-check-failed"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deactivate",
                                                        "method": "POST",
                                                        "path": "/deactivate",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "invalid-location",
                                                            "merchant-token-missing",
                                                            "uber-verify-failed",
                                                            "uber-delete-failed",
                                                            "merchant-token-store-mismatch"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteMerchantToken",
                                                        "method": "DELETE",
                                                        "path": "/merchant-token",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getMarketplaceSettings",
                                                        "method": "GET",
                                                        "path": "/marketplace-settings",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "oauth",
                                                        "method": "GET",
                                                        "path": "/oauth",
                                                        "errors": [
                                                            "feature-disabled"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "provisionStores",
                                                        "method": "POST",
                                                        "path": "/provision-stores",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "token-not-found",
                                                            "token-expired"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "storeMappings",
                                                        "method": "POST",
                                                        "path": "/store-mappings",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "invalid-location"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "stores",
                                                        "method": "GET",
                                                        "path": "/stores",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "token-not-found",
                                                            "token-expired",
                                                            "api-error"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "doordash",
                        "path": "/doordash",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "callback",
                                "method": "GET",
                                "path": "/callback",
                                "errors": [
                                    "feature-disabled",
                                    "invalid-state",
                                    "missing-code",
                                    "oauth-error",
                                    "token-exchange-failed"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{location}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "activateStore",
                                        "method": "POST",
                                        "path": "/activate-store",
                                        "errors": [
                                            "feature-disabled",
                                            "settings-not-found",
                                            "already-activated",
                                            "doordash-api-error",
                                            "settings-update-failed",
                                            "location-pos-integrated"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deactivateStore",
                                        "method": "POST",
                                        "path": "/deactivate-store",
                                        "errors": [
                                            "feature-disabled",
                                            "settings-not-found",
                                            "already-deactivated",
                                            "doordash-api-error",
                                            "settings-update-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "publishMenu",
                                        "method": "POST",
                                        "path": "/publish-menu",
                                        "errors": [
                                            "feature-disabled",
                                            "doordash-publish-error",
                                            "not-configured",
                                            "menu-not-found",
                                            "invalid-menu-structure",
                                            "api-error",
                                            "authentication-error"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "settings",
                                        "path": "/settings",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "deleteMarketplaceSettings",
                                                "method": "DELETE",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled",
                                                    "settings-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSettings",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "not-found",
                                                    "feature-disabled"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSettings",
                                                "method": "PUT",
                                                "path": "/",
                                                "errors": [
                                                    "update-failed",
                                                    "feature-disabled",
                                                    "location-pos-integrated"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "orders",
                                "path": "/orders/{orderId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "cancelOrder",
                                        "method": "POST",
                                        "path": "/cancel",
                                        "errors": [
                                            "feature-disabled",
                                            "order-not-found",
                                            "not-doordash-order",
                                            "missing-marketplace-id",
                                            "not-cancellable",
                                            "already-cancelled",
                                            "doordash-api-error"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "readyForPickup",
                                        "method": "POST",
                                        "path": "/ready-for-pickup",
                                        "errors": [
                                            "feature-disabled",
                                            "order-not-found",
                                            "not-doordash-order",
                                            "missing-marketplace-id",
                                            "not-active",
                                            "doordash-api-error"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "grubhub",
                        "path": "/grubhub",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "callback",
                                "method": "GET",
                                "path": "/callback",
                                "errors": [
                                    "invalid-state",
                                    "oauth-error"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{location}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "manualPublishMenu",
                                        "method": "POST",
                                        "path": "/manual-publish-menu",
                                        "errors": [
                                            "feature-disabled",
                                            "not-configured",
                                            "authentication-error",
                                            "api-error"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "pauseStore",
                                        "method": "POST",
                                        "path": "/pause-store",
                                        "errors": [
                                            "feature-disabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "publishMenu",
                                        "method": "POST",
                                        "path": "/publish-menu",
                                        "errors": [
                                            "feature-disabled",
                                            "settings-not-found",
                                            "not-configured",
                                            "no-menus-configured",
                                            "publish-failed",
                                            "unsync-previous-failed",
                                            "too-many-menus"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "resumeStore",
                                        "method": "POST",
                                        "path": "/resume-store",
                                        "errors": [
                                            "feature-disabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSettings",
                                        "method": "PATCH",
                                        "path": "/settings",
                                        "errors": [
                                            "feature-disabled",
                                            "settings-not-found",
                                            "not-configured",
                                            "no-menus-configured",
                                            "publish-failed",
                                            "unsync-previous-failed",
                                            "too-many-menus"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "orders",
                                "path": "/orders/{orderId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "cancelOrder",
                                        "method": "POST",
                                        "path": "/cancel",
                                        "errors": [
                                            "feature-disabled",
                                            "order-not-found",
                                            "not-grubhub-order",
                                            "missing-marketplace-id",
                                            "missing-merchant-id",
                                            "not-cancellable",
                                            "already-requested",
                                            "grubhub-api-error"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "ubereats",
                        "path": "/ubereats",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "callback",
                                "method": "GET",
                                "path": "/callback",
                                "errors": [
                                    "invalid-state"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{location}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "holidayHours",
                                        "method": "GET",
                                        "path": "/holiday-hours",
                                        "errors": [
                                            "feature-disabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "pauseStore",
                                        "method": "POST",
                                        "path": "/pause-store",
                                        "errors": [
                                            "feature-disabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "publishMenu",
                                        "method": "POST",
                                        "path": "/publish-menu",
                                        "errors": [
                                            "feature-disabled",
                                            "not-configured",
                                            "authentication-error",
                                            "api-error"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "resumeStore",
                                        "method": "POST",
                                        "path": "/resume-store",
                                        "errors": [
                                            "feature-disabled"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "settings",
                                        "path": "/settings",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "deleteMarketplaceSettings",
                                                "method": "DELETE",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled",
                                                    "settings-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSettings",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled",
                                                    "settings-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSettings",
                                                "method": "PATCH",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled",
                                                    "settings-not-found"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "syncHolidayHours",
                                        "method": "POST",
                                        "path": "/sync-holiday-hours",
                                        "errors": [
                                            "feature-disabled"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "orders",
                                "path": "/orders/{orderId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "acceptOrder",
                                        "method": "POST",
                                        "path": "/accept",
                                        "errors": [
                                            "feature-disabled",
                                            "order-not-found",
                                            "not-ubereats-order",
                                            "missing-marketplace-id",
                                            "already-accepted",
                                            "ubereats-api-error"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "cancelOrder",
                                        "method": "POST",
                                        "path": "/cancel",
                                        "errors": [
                                            "feature-disabled",
                                            "order-not-found",
                                            "not-ubereats-order",
                                            "missing-marketplace-id",
                                            "not-cancellable",
                                            "already-cancelled",
                                            "restricted-reason",
                                            "ubereats-api-error"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "denyOrder",
                                        "method": "POST",
                                        "path": "/deny",
                                        "errors": [
                                            "feature-disabled",
                                            "order-not-found",
                                            "not-ubereats-order",
                                            "missing-marketplace-id",
                                            "already-accepted",
                                            "already-denied",
                                            "ubereats-api-error"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "registration",
                                "method": "GET",
                                "path": "/registration",
                                "errors": [
                                    "missing-auth-cookie",
                                    "missing-store-id"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "start",
                                "method": "GET",
                                "path": "/start",
                                "errors": [
                                    "missing-store-id"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "mcpRouter",
        "path": "/mcps",
        "children": [
            {
                "type": "router",
                "name": "ordering",
                "path": "/ordering",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "deleteTransport",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getTransport",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "postTransport",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "ownerAgentInsights",
                "path": "/owner-agent-insights",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "deleteTransport",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getTransport",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "postTransport",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "media",
        "path": "/media",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brand",
                        "path": "/brand",
                        "children": [
                            {
                                "type": "router",
                                "name": "brandId",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "byTag",
                                        "path": "/by-tag/{tag}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getByTag",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "tag-not-readable"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listInventory",
                                        "method": "GET",
                                        "path": "/inventory",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "createMedia",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "brand-not-found",
                            "media-not-found",
                            "parent-not-found",
                            "self-parent",
                            "same-brand-required",
                            "relationship-exists",
                            "circular-reference",
                            "relationship-not-found",
                            "primary-already-exists",
                            "cannot-archive-primary",
                            "media-not-attached",
                            "media-not-ready",
                            "already-vanguard",
                            "not-vanguard",
                            "invalid-tags"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "media",
                        "path": "/{mediaId}",
                        "children": [
                            {
                                "type": "router",
                                "name": "analysis",
                                "path": "/analysis",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getLatestAnalysis",
                                        "method": "GET",
                                        "path": "/latest",
                                        "errors": [
                                            "media-not-found",
                                            "no-analysis-found"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "children",
                                "path": "/children",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "listChildren",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getMedia",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "media-not-found"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "parents",
                                "path": "/parents",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "addParent",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listParents",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "removeParent",
                                        "method": "DELETE",
                                        "path": "/{parentId}",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "tags",
                                "path": "/tags",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "addTags",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getTags",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "media-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "removeTags",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateStatus",
                                "method": "PATCH",
                                "path": "/status",
                                "errors": [
                                    "brand-not-found",
                                    "media-not-found",
                                    "parent-not-found",
                                    "self-parent",
                                    "same-brand-required",
                                    "relationship-exists",
                                    "circular-reference",
                                    "relationship-not-found",
                                    "primary-already-exists",
                                    "cannot-archive-primary",
                                    "media-not-attached",
                                    "media-not-ready",
                                    "already-vanguard",
                                    "not-vanguard",
                                    "invalid-tags"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "menuItem",
                        "path": "/menu-item",
                        "children": [
                            {
                                "type": "router",
                                "name": "menuItem",
                                "path": "/{itemId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "attachMedia",
                                        "method": "POST",
                                        "path": "/attach",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listMedia",
                                        "method": "GET",
                                        "path": "/list",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setPrimary",
                                        "method": "POST",
                                        "path": "/primary",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "vanguard",
                        "path": "/{brandId}/vanguard",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addVanguard",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "brand-not-found",
                                    "media-not-found",
                                    "parent-not-found",
                                    "self-parent",
                                    "same-brand-required",
                                    "relationship-exists",
                                    "circular-reference",
                                    "relationship-not-found",
                                    "primary-already-exists",
                                    "cannot-archive-primary",
                                    "media-not-attached",
                                    "media-not-ready",
                                    "already-vanguard",
                                    "not-vanguard",
                                    "invalid-tags"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "isVanguard",
                                "method": "GET",
                                "path": "/{mediaId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listVanguard",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "removeVanguard",
                                "method": "DELETE",
                                "path": "/{mediaId}",
                                "errors": [
                                    "brand-not-found",
                                    "media-not-found",
                                    "parent-not-found",
                                    "self-parent",
                                    "same-brand-required",
                                    "relationship-exists",
                                    "circular-reference",
                                    "relationship-not-found",
                                    "primary-already-exists",
                                    "cannot-archive-primary",
                                    "media-not-attached",
                                    "media-not-ready",
                                    "already-vanguard",
                                    "not-vanguard",
                                    "invalid-tags"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "vulcan",
                        "path": "/vulcan/runs",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createRun",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "vulcan-error"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getRun",
                                "method": "GET",
                                "path": "/{runId}",
                                "errors": [
                                    "vulcan-not-found",
                                    "vulcan-error"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "menuItem",
                        "path": "/menu-item",
                        "children": [
                            {
                                "type": "router",
                                "name": "menuItem",
                                "path": "/{itemId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "attachMedia",
                                        "method": "POST",
                                        "path": "/attach",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listMedia",
                                        "method": "GET",
                                        "path": "/list",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "setPrimary",
                                        "method": "POST",
                                        "path": "/primary",
                                        "errors": [
                                            "brand-not-found",
                                            "media-not-found",
                                            "parent-not-found",
                                            "self-parent",
                                            "same-brand-required",
                                            "relationship-exists",
                                            "circular-reference",
                                            "relationship-not-found",
                                            "primary-already-exists",
                                            "cannot-archive-primary",
                                            "media-not-attached",
                                            "media-not-ready",
                                            "already-vanguard",
                                            "not-vanguard",
                                            "invalid-tags"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "menu",
        "path": "/menu",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "coupons",
                                        "path": "/coupons",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getCouponsByCode",
                                                "method": "GET",
                                                "path": "/{code}",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getMarketingProductCandidates",
                                        "method": "GET",
                                        "path": "/marketing-product-candidates",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "imageVersions",
                                        "path": "/image-versions",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "listImageVersions",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "legacyGetPopularItems",
                                        "method": "GET",
                                        "path": "/legacy-get-popular-items",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listFreeItemProvisioningItems",
                                        "method": "GET",
                                        "path": "/free-item-provisioning-items",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "matchFreeItemCategories",
                                        "method": "POST",
                                        "path": "/match-free-item-categories",
                                        "errors": [
                                            "timeout"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "replateRuns",
                                        "path": "/replate-runs",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getReplateRunStatus",
                                                "method": "GET",
                                                "path": "/current",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "triggerReplate",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "experiments",
                        "path": "/experiments",
                        "children": [
                            {
                                "type": "router",
                                "name": "locationLevelLiveMenuQa",
                                "path": "/location-level-live-menu-qa",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getArtifact",
                                        "method": "GET",
                                        "path": "/artifacts/{experimentId}",
                                        "errors": [
                                            "manifest-not-found",
                                            "location-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "qualityReports",
                                        "method": "GET",
                                        "path": "/quality-reports/{experimentId}",
                                        "errors": [
                                            "manifest-not-found",
                                            "location-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "start",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "invalid-schedule",
                                            "workflow-already-running"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "status",
                                        "method": "GET",
                                        "path": "/status/{experimentId}",
                                        "errors": [
                                            "manifest-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "verifyLiveMenuExport",
                                        "method": "GET",
                                        "path": "/verify/{experimentId}/live-menu-export",
                                        "errors": [
                                            "manifest-not-found",
                                            "location-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "items",
                        "path": "/items",
                        "children": [
                            {
                                "type": "router",
                                "name": "experiments",
                                "path": "/experiments",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "experiment",
                                        "path": "/{experimentName}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "clearImageExperiment",
                                                "method": "POST",
                                                "path": "/clear",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "primaryImageSource",
                                "path": "/primaryImageSource",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "setPrimaryImageSource",
                                        "method": "POST",
                                        "path": "/set",
                                        "errors": [
                                            "invalid-source",
                                            "item-not-found",
                                            "experiment-not-populated"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "retouch",
                                "path": "/retouch",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "clearReplateExperiment",
                                        "method": "POST",
                                        "path": "/clear",
                                        "errors": [
                                            "item-not-found",
                                            "no-experiment",
                                            "experiment-changed",
                                            "experimental-flag-required"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "copyPhotoToExperiment",
                                        "method": "POST",
                                        "path": "/copy-to-experiment",
                                        "errors": [
                                            "item-not-found",
                                            "same-cohort",
                                            "no-source-photo",
                                            "source-changed",
                                            "experimental-flag-required"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "promoteReplateDraft",
                                        "method": "POST",
                                        "path": "/promote",
                                        "errors": [
                                            "item-not-found",
                                            "no-draft",
                                            "draft-changed",
                                            "experimental-flag-required"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "retouchItemPhoto",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "bulk",
                                        "path": "/bulk",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getItems",
                                                "method": "GET",
                                                "path": "/items",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getModifiers",
                                                "method": "GET",
                                                "path": "/modifiers",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "jobs",
                                                "path": "/jobs",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "createBulkEditingJob",
                                                        "method": "POST",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "router",
                                                        "name": "job",
                                                        "path": "/{jobId}",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "commitBulkEditJob",
                                                                "method": "POST",
                                                                "path": "/commit",
                                                                "errors": [
                                                                    "menu-clone-failed",
                                                                    "traversal-cycle",
                                                                    "traversal-depth",
                                                                    "bulk-edit-job-mutate-after-commit",
                                                                    "bulk-edit-job-invalid-target-type",
                                                                    "bulk-edit-job-invalid-targets",
                                                                    "bulk-edit-job-not-found",
                                                                    "bulk-edit-job-invalid-overrides",
                                                                    "bulk-edit-killswitch-enabled",
                                                                    "cannot-edit-pos-entity",
                                                                    "cannot-delete-pos-entity",
                                                                    "duplicate-coupon-code-brand",
                                                                    "duplicate-coupon-code-location",
                                                                    "free-delivery-coupons-not-enabled"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "deleteBulkEditJob",
                                                                "method": "DELETE",
                                                                "path": "/",
                                                                "errors": [
                                                                    "menu-clone-failed",
                                                                    "traversal-cycle",
                                                                    "traversal-depth",
                                                                    "bulk-edit-job-mutate-after-commit",
                                                                    "bulk-edit-job-invalid-target-type",
                                                                    "bulk-edit-job-invalid-targets",
                                                                    "bulk-edit-job-not-found",
                                                                    "bulk-edit-job-invalid-overrides",
                                                                    "bulk-edit-killswitch-enabled",
                                                                    "cannot-edit-pos-entity",
                                                                    "cannot-delete-pos-entity",
                                                                    "duplicate-coupon-code-brand",
                                                                    "duplicate-coupon-code-location",
                                                                    "free-delivery-coupons-not-enabled"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getBulkEditJob",
                                                                "method": "GET",
                                                                "path": "/",
                                                                "errors": [
                                                                    "menu-clone-failed",
                                                                    "traversal-cycle",
                                                                    "traversal-depth",
                                                                    "bulk-edit-job-mutate-after-commit",
                                                                    "bulk-edit-job-invalid-target-type",
                                                                    "bulk-edit-job-invalid-targets",
                                                                    "bulk-edit-job-not-found",
                                                                    "bulk-edit-job-invalid-overrides",
                                                                    "bulk-edit-killswitch-enabled",
                                                                    "cannot-edit-pos-entity",
                                                                    "cannot-delete-pos-entity",
                                                                    "duplicate-coupon-code-brand",
                                                                    "duplicate-coupon-code-location",
                                                                    "free-delivery-coupons-not-enabled"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "getBulkEditPreview",
                                                                "method": "GET",
                                                                "path": "/preview",
                                                                "errors": [
                                                                    "menu-clone-failed",
                                                                    "traversal-cycle",
                                                                    "traversal-depth",
                                                                    "bulk-edit-job-mutate-after-commit",
                                                                    "bulk-edit-job-invalid-target-type",
                                                                    "bulk-edit-job-invalid-targets",
                                                                    "bulk-edit-job-not-found",
                                                                    "bulk-edit-job-invalid-overrides",
                                                                    "bulk-edit-killswitch-enabled",
                                                                    "cannot-edit-pos-entity",
                                                                    "cannot-delete-pos-entity",
                                                                    "duplicate-coupon-code-brand",
                                                                    "duplicate-coupon-code-location",
                                                                    "free-delivery-coupons-not-enabled"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "updateBulkEditOperation",
                                                                "method": "PATCH",
                                                                "path": "/operation",
                                                                "errors": [
                                                                    "menu-clone-failed",
                                                                    "traversal-cycle",
                                                                    "traversal-depth",
                                                                    "bulk-edit-job-mutate-after-commit",
                                                                    "bulk-edit-job-invalid-target-type",
                                                                    "bulk-edit-job-invalid-targets",
                                                                    "bulk-edit-job-not-found",
                                                                    "bulk-edit-job-invalid-overrides",
                                                                    "bulk-edit-killswitch-enabled",
                                                                    "cannot-edit-pos-entity",
                                                                    "cannot-delete-pos-entity",
                                                                    "duplicate-coupon-code-brand",
                                                                    "duplicate-coupon-code-location",
                                                                    "free-delivery-coupons-not-enabled"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "updateBulkEditOverrides",
                                                                "method": "PATCH",
                                                                "path": "/overrides",
                                                                "errors": [
                                                                    "menu-clone-failed",
                                                                    "traversal-cycle",
                                                                    "traversal-depth",
                                                                    "bulk-edit-job-mutate-after-commit",
                                                                    "bulk-edit-job-invalid-target-type",
                                                                    "bulk-edit-job-invalid-targets",
                                                                    "bulk-edit-job-not-found",
                                                                    "bulk-edit-job-invalid-overrides",
                                                                    "bulk-edit-killswitch-enabled",
                                                                    "cannot-edit-pos-entity",
                                                                    "cannot-delete-pos-entity",
                                                                    "duplicate-coupon-code-brand",
                                                                    "duplicate-coupon-code-location",
                                                                    "free-delivery-coupons-not-enabled"
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "updateBulkEditTargets",
                                                                "method": "PATCH",
                                                                "path": "/targets",
                                                                "errors": [
                                                                    "menu-clone-failed",
                                                                    "traversal-cycle",
                                                                    "traversal-depth",
                                                                    "bulk-edit-job-mutate-after-commit",
                                                                    "bulk-edit-job-invalid-target-type",
                                                                    "bulk-edit-job-invalid-targets",
                                                                    "bulk-edit-job-not-found",
                                                                    "bulk-edit-job-invalid-overrides",
                                                                    "bulk-edit-killswitch-enabled",
                                                                    "cannot-edit-pos-entity",
                                                                    "cannot-delete-pos-entity",
                                                                    "duplicate-coupon-code-brand",
                                                                    "duplicate-coupon-code-location",
                                                                    "free-delivery-coupons-not-enabled"
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "cloneMenus",
                                        "method": "POST",
                                        "path": "/clone-menus",
                                        "errors": [
                                            "target-locations-include-source-location",
                                            "location-not-found",
                                            "mismatched-brands",
                                            "no-menus-in-source",
                                            "menu-sync-pos-connected-location",
                                            "brand-menu-creation-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getAllMenus",
                                        "method": "GET",
                                        "path": "/menus",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "importCateringMenu",
                                        "method": "POST",
                                        "path": "/import-catering-menu",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "importFromJson",
                                        "method": "POST",
                                        "path": "/import-from-json",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "importFromUrl",
                                        "method": "POST",
                                        "path": "/import-from-url",
                                        "errors": [
                                            "not-found",
                                            "parse-failed",
                                            "no-menus-extracted"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "pos",
                                        "path": "/pos",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "syncs",
                                                "path": "/syncs",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getPosSyncs",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "resyncPos",
                                                        "method": "POST",
                                                        "path": "/",
                                                        "errors": [
                                                            "location-not-found",
                                                            "menu-sync-not-supported-for-pos",
                                                            "pos-not-found-for-location",
                                                            "pos-sync-failed",
                                                            "operation-not-supported"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "publishMenu",
                                        "method": "POST",
                                        "path": "/publish-menu",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "menus",
                        "path": "/menus",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "finalizeImports",
                                "method": "POST",
                                "path": "/finalize-imports",
                                "errors": [
                                    "keep-not-imported"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "menu",
                                "path": "/{menuId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "detectionReports",
                                        "path": "/detection-reports",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "byId",
                                                "path": "/{reportId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getDetectionReport",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "report-not-found"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getDetectionReports",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "exportJson",
                                        "method": "GET",
                                        "path": "/export-json",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "pipelineRuns",
                                        "path": "/pipeline-runs",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "byId",
                                                "path": "/{runId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "cancelPipelineRun",
                                                        "method": "POST",
                                                        "path": "/cancel",
                                                        "errors": [
                                                            "run-not-found",
                                                            "run-not-cancelable"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getPipelineRun",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "run-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "router",
                                                        "name": "interventions",
                                                        "path": "/interventions",
                                                        "children": [
                                                            {
                                                                "type": "router",
                                                                "name": "bulk",
                                                                "path": "/bulk",
                                                                "children": [
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "reject",
                                                                        "method": "POST",
                                                                        "path": "/reject",
                                                                        "errors": [
                                                                            "run-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "updateStatus",
                                                                        "method": "POST",
                                                                        "path": "/update-status",
                                                                        "errors": [
                                                                            "run-not-found"
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "type": "router",
                                                                "name": "byInterventionId",
                                                                "path": "/{interventionId}",
                                                                "children": [
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "addModifierSetVirtual",
                                                                        "method": "POST",
                                                                        "path": "/add-modifier-set-virtual",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "item-not-found",
                                                                            "parent-entity-not-found",
                                                                            "parent-entity-deleted"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "addModifierToSet",
                                                                        "method": "POST",
                                                                        "path": "/add-modifier-to-set",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "modifier-set-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "addModifierToSetVirtual",
                                                                        "method": "POST",
                                                                        "path": "/add-modifier-to-set-virtual",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "modifier-set-not-found",
                                                                            "modifier-set-deleted",
                                                                            "modifier-set-required"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "addPricedModifierSet",
                                                                        "method": "POST",
                                                                        "path": "/add-priced-modifier-set",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "invalid-item",
                                                                            "invalid-clover-action",
                                                                            "item-not-found",
                                                                            "modifier-set-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "applyIntervention",
                                                                        "method": "POST",
                                                                        "path": "/apply",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "approveIntervention",
                                                                        "method": "POST",
                                                                        "path": "/approve",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "consolidateCategories",
                                                                        "method": "POST",
                                                                        "path": "/consolidate-categories",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "category-not-found",
                                                                            "menu-not-found",
                                                                            "insufficient-categories"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "consolidateCategoriesVirtual",
                                                                        "method": "POST",
                                                                        "path": "/consolidate-categories-virtual",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "category-not-found",
                                                                            "menu-not-found",
                                                                            "insufficient-categories",
                                                                            "source-entity-hidden"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "consolidateVariations",
                                                                        "method": "POST",
                                                                        "path": "/consolidate-variations",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "item-not-found",
                                                                            "modifier-count-mismatch",
                                                                            "items-have-different-modifier-sets"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "consolidateVariationsVirtual",
                                                                        "method": "POST",
                                                                        "path": "/consolidate-variations-virtual",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "item-not-found",
                                                                            "modifier-count-mismatch",
                                                                            "category-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "deduplicateItems",
                                                                        "method": "POST",
                                                                        "path": "/deduplicate-items",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "item-not-found",
                                                                            "insufficient-items",
                                                                            "invalid-surviving-item"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "deduplicateItemsPresentational",
                                                                        "method": "POST",
                                                                        "path": "/deduplicate-items-presentational",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "item-not-found",
                                                                            "insufficient-items",
                                                                            "invalid-surviving-item",
                                                                            "source-entity-hidden"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "enforcedPizzaModifier",
                                                                        "method": "POST",
                                                                        "path": "/enforced-pizza-modifier",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "modifier-set-not-found",
                                                                            "insufficient-modifiers",
                                                                            "invalid-modifier-set"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "enforcedPizzaModifierVirtual",
                                                                        "method": "POST",
                                                                        "path": "/enforced-pizza-modifier-virtual",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "modifier-set-not-found",
                                                                            "insufficient-modifiers",
                                                                            "invalid-modifier-set",
                                                                            "source-entity-hidden"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "missingChoice",
                                                                        "method": "POST",
                                                                        "path": "/missing-choice",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "item-not-found",
                                                                            "modifier-set-not-found",
                                                                            "no-modifier-sets-provided"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "rejectIntervention",
                                                                        "method": "POST",
                                                                        "path": "/reject",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "requireModifierSet",
                                                                        "method": "POST",
                                                                        "path": "/require-modifier-set",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "modifier-set-not-found",
                                                                            "invalid-modifier-set",
                                                                            "invalid-item",
                                                                            "modifier-set-required"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "splitMixedAdditionAndRemovalModifiers",
                                                                        "method": "POST",
                                                                        "path": "/split-mixed-addition-and-removal-modifiers",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "modifier-set-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "splitMixedModifiersVirtual",
                                                                        "method": "POST",
                                                                        "path": "/split-mixed-modifiers-virtual",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "modifier-set-not-found",
                                                                            "insufficient-modifiers",
                                                                            "overlapping-modifiers"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "updateInterventionStatus",
                                                                        "method": "POST",
                                                                        "path": "/update-status",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "endpoint",
                                                                        "name": "updateItemPrice",
                                                                        "method": "POST",
                                                                        "path": "/update-item-price",
                                                                        "errors": [
                                                                            "run-not-found",
                                                                            "intervention-not-found",
                                                                            "invalid-intervention-type",
                                                                            "item-not-found",
                                                                            "invalid-item",
                                                                            "stale-intervention"
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "listInterventions",
                                                                "method": "GET",
                                                                "path": "/",
                                                                "errors": [
                                                                    "run-not-found"
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "resumePipelineRun",
                                                        "method": "POST",
                                                        "path": "/resume",
                                                        "errors": [
                                                            "run-not-found",
                                                            "run-not-resumable"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createPipelineRun",
                                                "method": "POST",
                                                "path": "/create",
                                                "errors": [
                                                    "pipeline-paused"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPipelineRuns",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "snapshots",
                                        "path": "/snapshots",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createSnapshot",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listSnapshots",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "menus",
        "path": "/menus",
        "children": [
            {
                "type": "endpoint",
                "name": "create",
                "method": "POST",
                "path": "/",
                "errors": [
                    "traversal-cycle",
                    "traversal-depth"
                ]
            },
            {
                "type": "endpoint",
                "name": "get",
                "method": "GET",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "menu",
                "path": "/{menuItemId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "delete",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteImpact",
                        "method": "GET",
                        "path": "/delete-impact",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getCategories",
                        "method": "GET",
                        "path": "/categories",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedCategories",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedItems",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifiers",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifierSets",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "setAvailability",
                        "method": "PATCH",
                        "path": "/availability",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "update",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "traversal-cycle",
                            "traversal-depth"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "menuSnapshots",
        "path": "/menu-snapshots",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "snapshot",
                        "path": "/{snapshotId}",
                        "children": [
                            {
                                "type": "router",
                                "name": "diff",
                                "path": "/diff/{snapshotBId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "diffSnapshots",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getRawSnapshot",
                                "method": "GET",
                                "path": "/raw",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getSnapshot",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "mercury",
        "path": "/mercury",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getRecentlyOrderedItems",
                        "method": "GET",
                        "path": "/recent-order-items",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "landingPage",
                        "method": "GET",
                        "path": "/landing-page",
                        "errors": [
                            "location-not-found",
                            "no-location-for-brand"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "resolveLocationBrandId",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "location-not-found"
                        ]
                    }
                ]
            }
        ],
        "subGroup": "website-bff"
    },
    {
        "type": "router",
        "name": "mobileApps",
        "path": "/mobile-apps",
        "children": [
            {
                "type": "router",
                "name": "ascObservations",
                "path": "/asc-observations",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "paginateAscObservations",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "bulkDeployments",
                "path": "/bulk-deployments",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "abortBulkDeployment",
                        "method": "POST",
                        "path": "/{bulkId}/abort",
                        "errors": [
                            "bulk-deployment-not-found",
                            "bulk-deployment-already-cancelled",
                            "verified-abort-required"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "cancelBulkDeployment",
                        "method": "DELETE",
                        "path": "/{id}/cancel",
                        "errors": [
                            "bulk-deployment-not-found",
                            "verified-abort-required"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "createBulkDeployment",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "createManualBulkDeployment",
                        "method": "POST",
                        "path": "/manual",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "createRecoveryBulkDeployment",
                        "method": "POST",
                        "path": "/{id}/recover",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "dispatchBulkDeployment",
                        "method": "POST",
                        "path": "/dispatch",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "dispatchPreviewBulkDeployment",
                        "method": "POST",
                        "path": "/dispatch-preview",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "forceCancelBulkDeployment",
                        "method": "POST",
                        "path": "/{id}/force-cancel",
                        "errors": [
                            "bulk-deployment-not-found",
                            "verified-abort-in-progress",
                            "force-cancel-raced"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getBulkAbort",
                        "method": "GET",
                        "path": "/{bulkId}/abort/{operationId}",
                        "errors": [
                            "bulk-abort-not-found",
                            "bulk-abort-unavailable"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getBulkDeployment",
                        "method": "GET",
                        "path": "/{id}",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getBulkDeploymentFailureBreakdown",
                        "method": "GET",
                        "path": "/{id}/failure-breakdown",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getBulkDeployments",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "notifyTemplateBuildComplete",
                        "method": "POST",
                        "path": "/{id}/template-ready",
                        "errors": [
                            "bulk-deployment-not-found",
                            "invalid-status"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "previewAutoBulkDeployment",
                        "method": "GET",
                        "path": "/preview",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "previewRecoveryBulkDeployment",
                        "method": "POST",
                        "path": "/{id}/recovery-preview",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "resolveRefBulkDeployment",
                        "method": "POST",
                        "path": "/resolve-ref",
                        "errors": []
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "createMobileApp",
                "method": "POST",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "deployments",
                "path": "/deployments",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "createDeployment",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "validation-failed",
                            "orchestrator-dispatch-unavailable"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "createUpdate",
                        "method": "POST",
                        "path": "/update",
                        "errors": [
                            "orchestrator-dispatch-unavailable"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "deployment",
                        "path": "/{deploymentId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "deleteDeployment",
                                "method": "DELETE",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getDeployment",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updateDeployment",
                                "method": "PATCH",
                                "path": "/",
                                "errors": [
                                    "single-writer-conflict",
                                    "classifier-contract-violation"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "paginateDeployments",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "exportMobileApps",
                "method": "GET",
                "path": "/export",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "getFirebaseConfig",
                "method": "GET",
                "path": "/firebase-config",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "getMobileAppBySlug",
                "method": "GET",
                "path": "/brand",
                "errors": [
                    "not-found"
                ]
            },
            {
                "type": "router",
                "name": "mobileApp",
                "path": "/{mobileAppId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "deleteMobileApp",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getMobileApp",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "lockIosAccount",
                        "method": "POST",
                        "path": "/ios/lock-account",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "unlockIosAccount",
                        "method": "POST",
                        "path": "/ios/unlock-account",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updateFirebaseInfo",
                        "method": "PUT",
                        "path": "/firebase",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "updateMobileApp",
                        "method": "PATCH",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "paginateMobileApps",
                "method": "GET",
                "path": "/",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "provisionInboundPhone",
                "method": "POST",
                "path": "/provision-inbound-phone/{brandId}",
                "errors": [
                    "mobile-app-not-found"
                ]
            },
            {
                "type": "endpoint",
                "name": "provisionIos",
                "method": "POST",
                "path": "/provision-ios",
                "errors": [
                    "provision-failed"
                ]
            },
            {
                "type": "endpoint",
                "name": "provisionIosBuilds",
                "method": "GET",
                "path": "/provision-ios/builds",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "updateAppStoreMetadata",
                "method": "PATCH",
                "path": "/app-store-metadata",
                "errors": []
            },
            {
                "type": "endpoint",
                "name": "verifyPushVendorState",
                "method": "POST",
                "path": "/push-vendor-state/verify",
                "errors": [
                    "mobile-app-not-found"
                ]
            },
            {
                "type": "router",
                "name": "versions",
                "path": "/versions",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "createVersion",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getLatestVersion",
                        "method": "GET",
                        "path": "/latest",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "paginateVersions",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "modifiers",
        "path": "/modifiers",
        "children": [
            {
                "type": "endpoint",
                "name": "create",
                "method": "POST",
                "path": "/",
                "errors": [
                    "traversal-cycle",
                    "traversal-depth"
                ]
            },
            {
                "type": "endpoint",
                "name": "get",
                "method": "GET",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "modifier",
                "path": "/{menuItemId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "delete",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteImpact",
                        "method": "GET",
                        "path": "/delete-impact",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getModifierSets",
                        "method": "GET",
                        "path": "/modifier-sets",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedCategories",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedItems",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedMenus",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifiers",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifierSets",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "setAvailability",
                        "method": "PATCH",
                        "path": "/availability",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "update",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "traversal-cycle",
                            "traversal-depth"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "modifierSets",
        "path": "/modifier-sets",
        "children": [
            {
                "type": "endpoint",
                "name": "create",
                "method": "POST",
                "path": "/",
                "errors": [
                    "traversal-cycle",
                    "traversal-depth"
                ]
            },
            {
                "type": "endpoint",
                "name": "get",
                "method": "GET",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "modifierSet",
                "path": "/{menuItemId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "delete",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteImpact",
                        "method": "GET",
                        "path": "/delete-impact",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getModifiers",
                        "method": "GET",
                        "path": "/modifiers",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getPreselectedModifiers",
                        "method": "GET",
                        "path": "/preselected-modifiers",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedCategories",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedItems",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedMenus",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifiers",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getRelatedModifierSets",
                        "method": "GET",
                        "path": "/relations",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "setAvailability",
                        "method": "PATCH",
                        "path": "/availability",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "update",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "traversal-cycle",
                            "traversal-depth"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "moduleCoupons",
        "path": "/coupons",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "coupon",
                        "path": "/{couponId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "enableCouponAndCampaign",
                                "method": "PATCH",
                                "path": "/enable-coupon-and-campaign",
                                "errors": [
                                    "not-found",
                                    "campaign-and-coupon-not-connected"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "copyOverCouponsForNewLocation",
                                        "method": "POST",
                                        "path": "/copy-over-coupons-for-new-location",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "notifications",
        "path": "/notifications",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "liveActivity",
                        "path": "/live-activity",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "registerToken",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "unregisterToken",
                                "method": "DELETE",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "templates",
                        "path": "/templates",
                        "children": [
                            {
                                "type": "router",
                                "name": "emails",
                                "path": "/emails",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createEmailTemplate",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "email",
                                        "path": "/{emailTemplateId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "deleteEmailTemplate",
                                                "method": "DELETE",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getEmailTemplate",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSections",
                                                "method": "GET",
                                                "path": "/sections",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateEmailTemplate",
                                                "method": "PATCH",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "generateEmailTemplate",
                                        "method": "POST",
                                        "path": "/generate",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "sections",
                                        "path": "/sections",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createEmailSection",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "section",
                                                "path": "/{sectionId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteEmailSection",
                                                        "method": "DELETE",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateEmailSection",
                                                        "method": "PATCH",
                                                        "path": "/",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "sms",
                                "path": "/sms",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createSMSTemplate",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "sections",
                                        "path": "/sections",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createSMSSection",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "deleteSMSSection",
                                                "method": "DELETE",
                                                "path": "/{sectionId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSMSSection",
                                                "method": "PATCH",
                                                "path": "/{sectionId}",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "sms",
                                        "path": "/{smsTemplateId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "deleteSMSTemplate",
                                                "method": "DELETE",
                                                "path": "/",
                                                "errors": [
                                                    "sms-template-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSections",
                                                "method": "GET",
                                                "path": "/sections",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSMSTemplate",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "sms-template-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSMSTemplate",
                                                "method": "PATCH",
                                                "path": "/",
                                                "errors": [
                                                    "sms-template-not-found"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "endpoint",
        "name": "oauth",
        "method": "POST",
        "path": "/oauth",
        "errors": []
    },
    {
        "type": "router",
        "name": "oldDomainsRouter",
        "path": "/domains",
        "children": [
            {
                "type": "endpoint",
                "name": "createDomain",
                "method": "POST",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "domain",
                "path": "/{domainId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "deleteDomain",
                        "method": "DELETE",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "findByName",
                "method": "GET",
                "path": "/brand",
                "errors": [
                    "not-found",
                    "invalid-brand-slug",
                    "no-brand-slug"
                ]
            },
            {
                "type": "endpoint",
                "name": "getDomains",
                "method": "GET",
                "path": "/",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "oldReviews",
        "path": "/reviews",
        "children": [
            {
                "type": "endpoint",
                "name": "getReviews",
                "method": "GET",
                "path": "/",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "onboarding",
        "path": "/onboarding",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "actions",
                                        "path": "/actions",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "action",
                                                "path": "/{actionId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "complete",
                                                        "method": "POST",
                                                        "path": "/complete",
                                                        "errors": [
                                                            "not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "dismiss",
                                                        "method": "POST",
                                                        "path": "/dismiss",
                                                        "errors": [
                                                            "action-not-dismissible",
                                                            "action-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "update",
                                                        "method": "PATCH",
                                                        "path": "/",
                                                        "errors": [
                                                            "action-not-found"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createMissingActions",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "upsertAction",
                                                "method": "POST",
                                                "path": "/upsert",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "list",
                                        "method": "GET",
                                        "path": "/actions",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "orders",
        "path": "/orders",
        "children": [
            {
                "type": "router",
                "name": "v3",
                "path": "/v3",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "bulkUpdateTickets",
                        "method": "PATCH",
                        "path": "/ticket-statuses",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getOrders",
                        "method": "GET",
                        "path": "/",
                        "errors": [],
                        "subGroup": "poll"
                    },
                    {
                        "type": "endpoint",
                        "name": "getPendingOrderLink",
                        "method": "GET",
                        "path": "/pending-order-link",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "order",
                        "path": "/{orderId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "addGuestPayment",
                                "method": "POST",
                                "path": "/payment-guest",
                                "errors": [
                                    "order-not-found",
                                    "order-not-payable",
                                    "already-paid",
                                    "nothing-to-pay"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "addPayment",
                                "method": "POST",
                                "path": "/payment",
                                "errors": [
                                    "card-declined",
                                    "invalid-cvc",
                                    "expired-card",
                                    "decline-unknown",
                                    "charge-in-progress",
                                    "payment-intent-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "associateCustomer",
                                "method": "PATCH",
                                "path": "/associate-customer",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "chargeOrder",
                                "method": "POST",
                                "path": "/charge",
                                "errors": [
                                    "card-declined",
                                    "invalid-cvc",
                                    "expired-card",
                                    "decline-unknown",
                                    "charge-in-progress",
                                    "payment-intent-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "convertDeliveryToPickup",
                                "method": "PATCH",
                                "path": "/delivery-to-pickup",
                                "errors": [
                                    "cannot-create-without-contact",
                                    "delivery-not-cancellable",
                                    "delivery-not-found",
                                    "failed-to-cancel-delivery",
                                    "3pd-funds-transfer-failed",
                                    "failed-to-refund-guest",
                                    "failed-to-update-order",
                                    "marketplace-order-not-convertible",
                                    "not-a-delivery-order",
                                    "order-not-found",
                                    "order-terminal-status"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "convertInhouseToThirdPartyDelivery",
                                "method": "PATCH",
                                "path": "/delivery-third-party",
                                "errors": [
                                    "already-third-party-delivery",
                                    "cannot-create-without-contact",
                                    "delivery-address-not-serviceable",
                                    "delivery-not-found",
                                    "delivery-time-in-past",
                                    "minimum-subtotal-not-met",
                                    "no-address-on-order",
                                    "no-delivery-config-for-location",
                                    "no-delivery-options-available",
                                    "no-delivery-zones-for-location",
                                    "not-a-delivery-order",
                                    "order-not-found",
                                    "order-terminal-status",
                                    "pickup-address-not-geocodable",
                                    "pickup-deadline-too-early",
                                    "pickup-ready-too-early"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "convertPickupToDelivery",
                                "method": "PATCH",
                                "path": "/convert-to-delivery",
                                "errors": [
                                    "cannot-create-without-contact",
                                    "delivery-address-not-serviceable",
                                    "delivery-not-found",
                                    "delivery-time-in-past",
                                    "minimum-subtotal-not-met",
                                    "no-delivery-config-for-location",
                                    "no-delivery-options-available",
                                    "no-delivery-zones-for-location",
                                    "marketplace-order-not-convertible",
                                    "not-a-pickup-order",
                                    "order-not-found",
                                    "order-terminal-status",
                                    "pickup-address-not-geocodable",
                                    "pickup-deadline-too-early",
                                    "pickup-ready-too-early"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "convertThirdPartyToInHouse",
                                "method": "PATCH",
                                "path": "/third-party-to-in-house",
                                "errors": [
                                    "already-inhouse-delivery",
                                    "delivery-not-cancellable",
                                    "delivery-not-found",
                                    "failed-to-cancel-delivery",
                                    "failed-to-update-order",
                                    "marketplace-order-not-convertible",
                                    "not-a-delivery-order",
                                    "order-not-found",
                                    "order-terminal-status",
                                    "3pd-funds-transfer-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "exchangeOrderToken",
                                "method": "GET",
                                "path": "/exchange-order-token",
                                "errors": [
                                    "order-not-found",
                                    "invalid-token"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "exchangeOrderTokenForSession",
                                "method": "POST",
                                "path": "/exchange-order-token-for-session",
                                "errors": [
                                    "order-not-found",
                                    "invalid-token"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getConfirmationOrder",
                                "method": "GET",
                                "path": "/confirmation",
                                "errors": [
                                    "order-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getCourierLocationHistory",
                                "method": "GET",
                                "path": "/courier-location-history",
                                "errors": [
                                    "order-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getDeliveryEvents",
                                "method": "GET",
                                "path": "/delivery-events",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getDeliveryRoute",
                                "method": "GET",
                                "path": "/delivery-route",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getGuestPaymentBalance",
                                "method": "GET",
                                "path": "/payment-guest",
                                "errors": [
                                    "order-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getOrder",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "order-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getOrderItems",
                                "method": "GET",
                                "path": "/items",
                                "errors": [
                                    "order-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getOrderLink",
                                "method": "GET",
                                "path": "/order-link",
                                "errors": [
                                    "order-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPosHubOrder",
                                "method": "GET",
                                "path": "/pos-hub",
                                "errors": [
                                    "order-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getUberOrderParity",
                                "method": "GET",
                                "path": "/pos/uber/parity",
                                "errors": [
                                    "order-not-found",
                                    "not-uber-order",
                                    "uber-order-id-unavailable",
                                    "uber-order-projection-failed",
                                    "uber-order-readback-unavailable",
                                    "uber-order-readback-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "guestCancelEligibilityEndpoint",
                                "method": "GET",
                                "path": "/guest-cancel",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "guestCancelOrderEndpoint",
                                "method": "POST",
                                "path": "/guest-cancel",
                                "errors": [
                                    "not-eligible",
                                    "kitchen-started",
                                    "outside-window"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "hydrateCart",
                                "method": "POST",
                                "path": "/hydrate-cart",
                                "errors": [
                                    "cart-not-found",
                                    "order-not-found",
                                    "order-paid"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "operatorCancelOrderEndpoint",
                                "method": "POST",
                                "path": "/cancel",
                                "errors": [
                                    "not-eligible",
                                    "already-cancelled",
                                    "not-cancellable"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "refundOrder",
                                "method": "POST",
                                "path": "/refund",
                                "errors": [
                                    "refund-charge-disputed",
                                    "refund-already-refunded",
                                    "refund-in-progress",
                                    "refund-marketplace-order"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resendAuthenticatedOrderLink",
                                "method": "GET",
                                "path": "/resend-authenticated-order-link",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "respondToRequest",
                                "method": "POST",
                                "path": "/respond-to-request",
                                "errors": [
                                    "order-not-found",
                                    "order-is-not-unconfirmed",
                                    "confirmation-workflow-id-not-present",
                                    "confirmation-workflow-not-found",
                                    "confirmation-workflow-not-running"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "tickets",
                                "path": "/tickets",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "ticket",
                                        "path": "/{ticketId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "updateOrderTicketPrepareBy",
                                                "method": "PATCH",
                                                "path": "/estimated-prepared-time",
                                                "errors": [
                                                    "order-not-found",
                                                    "order-ticket-not-found",
                                                    "order-time-locked"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateOrderTicketStatus",
                                                "method": "PATCH",
                                                "path": "/status",
                                                "errors": [
                                                    "order-not-found",
                                                    "order-ticket-not-found"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateOrder",
                                "method": "PATCH",
                                "path": "/",
                                "errors": [
                                    "delivery-already-rescheduled",
                                    "order-time-locked"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "updateOrderItemStatus",
                                "method": "PUT",
                                "path": "/item-status",
                                "errors": [
                                    "invalid-fulfillment-transition",
                                    "order-item-not-found",
                                    "order-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateOrders",
                        "method": "PATCH",
                        "path": "/",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "ordersV0",
        "path": "/orders",
        "children": [
            {
                "type": "endpoint",
                "name": "getOrders",
                "method": "GET",
                "path": "/",
                "errors": []
            },
            {
                "type": "router",
                "name": "order",
                "path": "/{orderId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "chargeOrder",
                        "method": "POST",
                        "path": "/charge",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "convertInhouseToThirdPartyDelivery",
                        "method": "PATCH",
                        "path": "/delivery-third-party",
                        "errors": [
                            "already-third-party-delivery",
                            "cannot-create-without-contact",
                            "no-address-on-order",
                            "no-delivery-config-for-location",
                            "not-a-delivery-order",
                            "order-not-found",
                            "order-terminal-status"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "convertPickupToDelivery",
                        "method": "PATCH",
                        "path": "/convert-to-delivery",
                        "errors": [
                            "cannot-create-without-contact",
                            "not-a-pickup-order",
                            "order-not-found",
                            "order-terminal-status"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getOrder",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "order-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getOrderItems",
                        "method": "GET",
                        "path": "/items",
                        "errors": [
                            "order-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "refundOrder",
                        "method": "POST",
                        "path": "/refund",
                        "errors": [
                            "refund-charge-disputed",
                            "refund-already-refunded",
                            "refund-in-progress",
                            "refund-marketplace-order"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "updateOrder",
                        "method": "PATCH",
                        "path": "/",
                        "errors": [
                            "order-time-locked"
                        ]
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "updateOrders",
                "method": "PATCH",
                "path": "/",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "partner",
        "path": "/partner",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "assignDefaultOwnershipGroup",
                                        "method": "PUT",
                                        "path": "/default-ownership-group",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "destroyBrand",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "fetchBrandTimezone",
                                        "method": "GET",
                                        "path": "/timezone",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "ownerPayments",
                                        "path": "/owner-payments",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "listLocations",
                                                "method": "GET",
                                                "path": "/locations",
                                                "errors": [
                                                    "owner-payments-not-enabled",
                                                    "partial-location-scope"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "paymentsTargeting",
                                        "path": "/payments-targeting",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "recommendPlatform",
                                                "method": "GET",
                                                "path": "/recommend-platform",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "removeDefaultOwnershipGroup",
                                        "method": "DELETE",
                                        "path": "/default-ownership-group",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "listings",
                        "path": "/listings",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "triggerGbpIngestion",
                                "method": "POST",
                                "path": "/trigger-gbp-ingestion",
                                "errors": [
                                    "feature-disabled",
                                    "workflow-start-error"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listByStatus",
                                "method": "GET",
                                "path": "/by-status",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "accountManagementStripeSession",
                                        "method": "POST",
                                        "path": "/account-management-stripe-session",
                                        "errors": [
                                            "location-closed-or-cancelled",
                                            "location-not-found",
                                            "stripe-account-not-found",
                                            "stripe-account-creation-failed",
                                            "invalid-location-phone",
                                            "invalid-location-email",
                                            "invalid-location-data",
                                            "stripe-session-creation-failed",
                                            "payment-processor-account-not-found",
                                            "payment-processing-restricted",
                                            "payment-processor-error",
                                            "step-up-required",
                                            "auth-service-unavailable"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createIdentityVerificationLink",
                                        "method": "POST",
                                        "path": "/identity-verification-link/generate",
                                        "errors": [
                                            "session-creation-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createIdentityVerificationSession",
                                        "method": "POST",
                                        "path": "/identity-verification-session",
                                        "errors": [
                                            "session-creation-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createStripeAccountLink",
                                        "method": "POST",
                                        "path": "/stripe-account-link",
                                        "errors": [
                                            "location-not-found",
                                            "location-closed-or-cancelled",
                                            "stripe-account-creation-failed",
                                            "onboarding-already-complete",
                                            "invalid-location-phone",
                                            "invalid-location-email",
                                            "invalid-location-data",
                                            "account-link-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createTerminalLocation",
                                        "method": "POST",
                                        "path": "/create-terminal-location",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "destroyLocation",
                                        "method": "POST",
                                        "path": "/destroy-location",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getIdentityVerificationImage",
                                        "method": "GET",
                                        "path": "/identity-verification-image",
                                        "errors": [
                                            "report-not-found",
                                            "report-location-mismatch",
                                            "no-document-file",
                                            "file-link-failed",
                                            "identity-document-requires-stripe-dashboard"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getStripeConnectionToken",
                                        "method": "GET",
                                        "path": "/stripe-terminal-connection-token",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "listings",
                                        "path": "/listings",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createScanListingsJob",
                                                "method": "POST",
                                                "path": "/scan",
                                                "errors": [
                                                    "missing-required-arguments"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createSubscription",
                                                "method": "POST",
                                                "path": "/subscription",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "forceSync",
                                                "method": "PUT",
                                                "path": "/force-sync",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getGbpAccountLinkedStatus",
                                                "method": "GET",
                                                "path": "/gbp-account-linked-status",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getGbpPrefill",
                                                "method": "GET",
                                                "path": "/gbp-prefill",
                                                "errors": [
                                                    "no-gbp-data"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getListingIssues",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getListingStatus",
                                                "method": "GET",
                                                "path": "/status",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getListingSyncStatus",
                                                "method": "GET",
                                                "path": "/listing-sync-status",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getScanListingsJob",
                                                "method": "GET",
                                                "path": "/scan",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getServices",
                                                "method": "GET",
                                                "path": "/services",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getYextUrl",
                                                "method": "GET",
                                                "path": "/yext-url",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "optInToPublishers",
                                                "method": "PUT",
                                                "path": "/opt-in-to-publishers",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "overrideGBPCategories",
                                                "method": "PATCH",
                                                "path": "/",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "readyToOnboard",
                                                "method": "GET",
                                                "path": "/ready-to-onboard",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "runPowerListingScan",
                                                "method": "POST",
                                                "path": "/power-listing-scan",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "saveRequiredFields",
                                                "method": "POST",
                                                "path": "/save-required-fields",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "upsertListing",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "bad-request"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "phoneTree",
                                        "path": "/phone-tree",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "deletePhoneTreeSettings",
                                                "method": "DELETE",
                                                "path": "/settings",
                                                "errors": [
                                                    "phone-tree-settings-not-found",
                                                    "yext-update-failed"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPhoneTreeSettings",
                                                "method": "GET",
                                                "path": "/settings",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "patchPhoneTreeSettings",
                                                "method": "PATCH",
                                                "path": "/settings",
                                                "errors": [
                                                    "phone-tree-settings-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "setupPhoneTreeForLocation",
                                                "method": "POST",
                                                "path": "/setup",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "registerStripeReader",
                                        "method": "POST",
                                        "path": "/register-stripe-reader",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "resetIdentityVerification",
                                        "method": "POST",
                                        "path": "/identity-verification-reset",
                                        "errors": [
                                            "reset-not-recorded"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "sendIdentityVerificationLink",
                                        "method": "POST",
                                        "path": "/identity-verification-link",
                                        "errors": [
                                            "session-creation-failed",
                                            "sms-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "stripeAccounts",
                                        "path": "/stripe-accounts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "clearScheduledActivation",
                                                "method": "DELETE",
                                                "path": "/schedule-active",
                                                "errors": [
                                                    "clear-failed"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "createStripeAccount",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "location-not-found",
                                                    "location-closed-or-cancelled",
                                                    "account-already-exists",
                                                    "platform-not-configured",
                                                    "invalid-location-phone",
                                                    "invalid-location-email",
                                                    "invalid-location-data",
                                                    "stripe-account-creation-failed",
                                                    "platform-not-eligible"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "deleteStripeAccount",
                                                "method": "DELETE",
                                                "path": "/{accountId}",
                                                "errors": [
                                                    "account-not-found",
                                                    "account-is-active"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listStripeAccounts",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "refreshMetadata",
                                                "method": "POST",
                                                "path": "/refresh-metadata",
                                                "errors": [
                                                    "account-not-found",
                                                    "refresh-failed"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "scheduleActiveAccount",
                                                "method": "POST",
                                                "path": "/schedule-active",
                                                "errors": [
                                                    "account-not-found",
                                                    "activation-window-not-found",
                                                    "schedule-failed"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "startOwnerPayments",
                                                "method": "POST",
                                                "path": "/owner-payments",
                                                "errors": [
                                                    "owner-payments-not-enabled",
                                                    "location-not-found",
                                                    "location-closed-or-cancelled",
                                                    "platform-not-configured",
                                                    "invalid-location-phone",
                                                    "invalid-location-email",
                                                    "invalid-location-data",
                                                    "stripe-account-creation-failed"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "switchActiveAccount",
                                                "method": "PATCH",
                                                "path": "/active",
                                                "errors": [
                                                    "account-not-found",
                                                    "account-not-ready",
                                                    "switch-failed"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "stripeAccountSession",
                                        "method": "POST",
                                        "path": "/stripe-account-session",
                                        "errors": [
                                            "location-closed-or-cancelled",
                                            "location-not-found",
                                            "stripe-account-not-found",
                                            "stripe-account-creation-failed",
                                            "invalid-location-phone",
                                            "invalid-location-email",
                                            "invalid-location-data",
                                            "stripe-session-creation-failed",
                                            "payment-processor-account-not-found",
                                            "payment-processing-restricted",
                                            "payment-processor-error"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "stripeAppRedirect",
                                "method": "GET",
                                "path": "/stripe-app-redirect",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "ownershipGroups",
                        "path": "/ownership-groups",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createOwnershipGroup",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "listOwnershipGroups",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "ownershipGroup",
                                "path": "/{ownershipGroupId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "assignLocations",
                                        "method": "POST",
                                        "path": "/locations",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deleteOwnershipGroup",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getOwnershipGroup",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateOwnershipGroup",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "partnerReferrals",
        "path": "/partner-referral",
        "children": [
            {
                "type": "endpoint",
                "name": "createPartnerReferral",
                "method": "POST",
                "path": "/",
                "errors": []
            }
        ]
    },
    {
        "type": "router",
        "name": "partnership",
        "path": "/partnership",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "updatePartnershipType",
                                        "method": "PUT",
                                        "path": "/partnership-type",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "uber",
                        "path": "/uber",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "upgradeToPro",
                                "method": "POST",
                                "path": "/upgrade-to-pro",
                                "errors": [
                                    "feature-disabled",
                                    "no-eligible-locations",
                                    "multi-brand-not-supported"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "payments",
        "path": "/payments",
        "children": [
            {
                "type": "endpoint",
                "name": "bulkUpdateTransactionStatus",
                "method": "POST",
                "path": "/bulk-update-transaction-status",
                "errors": [
                    "invalid-file-type"
                ]
            },
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "refunds",
                                        "path": "/refunds",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "transactions",
                                        "path": "/transactions",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/{transactionId}",
                                                "errors": [
                                                    "transaction-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "payouts",
        "path": "/payouts",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "admin",
                        "path": "/admin",
                        "children": [
                            {
                                "type": "router",
                                "name": "reconcile",
                                "path": "/reconcile",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "reconcileByStripeId",
                                        "method": "POST",
                                        "path": "/{stripePayoutId}",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "balances",
                                        "method": "GET",
                                        "path": "/balances",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "list",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "locations",
                                        "path": "/locations",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "location",
                                                "path": "/{locationId}",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "payouts",
                                        "path": "/payouts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/{payoutId}",
                                                "errors": [
                                                    "payout-not-found"
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "payout",
                                                "path": "/{payoutId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "transactions",
                                                        "method": "GET",
                                                        "path": "/transactions",
                                                        "errors": [
                                                            "payout-not-found",
                                                            "payout-transactions-unavailable"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "recentPayouts",
                                        "method": "GET",
                                        "path": "/recent-payouts",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v3",
                "path": "/v3",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "balances",
                                        "method": "GET",
                                        "path": "/balances",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "physicalMedia",
        "path": "/physical-media",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "printShop",
                                        "path": "/print-shop",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "catalog",
                                                "path": "/catalog",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "get",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": []
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "landingImages",
                                                "path": "/landing-images",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "get",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": []
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "orders",
                                                "path": "/orders",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "checkout",
                                                        "method": "POST",
                                                        "path": "/checkout",
                                                        "errors": [
                                                            "legacy-billing-required",
                                                            "brand-not-found",
                                                            "location-not-in-brand",
                                                            "invalid-review-location",
                                                            "not-a-user",
                                                            "unknown-goal",
                                                            "unknown-offer-for-goal",
                                                            "unknown-custom-coupon",
                                                            "unknown-template",
                                                            "invalid-quantity-option",
                                                            "unknown-shipping-option",
                                                            "quote-unavailable"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "create",
                                                        "method": "POST",
                                                        "path": "/",
                                                        "errors": [
                                                            "brand-not-found",
                                                            "location-not-in-brand",
                                                            "location-required-for-gift-cards",
                                                            "gift-cards-not-included-in-plan",
                                                            "not-a-user",
                                                            "unknown-goal",
                                                            "unknown-offer-for-goal",
                                                            "unknown-custom-coupon",
                                                            "unknown-template",
                                                            "brand-not-billable",
                                                            "card-declined",
                                                            "charge-failed",
                                                            "invalid-quantity-option",
                                                            "unknown-shipping-option"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "downloadUrl",
                                                        "method": "GET",
                                                        "path": "/{physicalMediaOrderId}/download-url",
                                                        "errors": [
                                                            "order-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "list",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "location-not-in-brand"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "orderPromoCards",
                                                        "method": "POST",
                                                        "path": "/promo-cards",
                                                        "errors": [
                                                            "not-a-user",
                                                            "not-internal",
                                                            "brand-not-found",
                                                            "location-not-in-brand",
                                                            "location-missing-address",
                                                            "unknown-template"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "quotes",
                                                "path": "/quotes",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "abandon",
                                                        "method": "POST",
                                                        "path": "/{quoteId}/abandon",
                                                        "errors": [
                                                            "quote-unavailable"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "create",
                                                        "method": "POST",
                                                        "path": "/",
                                                        "errors": [
                                                            "legacy-billing-required",
                                                            "invalid-draft"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "get",
                                                        "method": "GET",
                                                        "path": "/{quoteId}",
                                                        "errors": [
                                                            "quote-unavailable"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateItem",
                                                        "method": "PUT",
                                                        "path": "/{quoteId}/items/{quoteItemId}",
                                                        "errors": [
                                                            "legacy-billing-required",
                                                            "quote-unavailable"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "printShop",
                        "path": "/print-shop",
                        "children": [
                            {
                                "type": "router",
                                "name": "orderAsset",
                                "path": "/order-asset",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "get",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "order-not-found",
                                            "asset-not-ready"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "scan",
                                "path": "/scan",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "get",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "invalid-token",
                                            "invalid-scan-params"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "vendorAsset",
                                "path": "/vendor-asset",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "get",
                                        "method": "GET",
                                        "path": "/{orderId}/artwork.pdf",
                                        "errors": [
                                            "order-not-found",
                                            "asset-not-ready"
                                        ],
                                        "responseType": "arraybuffer"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "posintegration",
        "path": "/posintegration",
        "children": [
            {
                "type": "router",
                "name": "uber",
                "path": "/uber",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "callback",
                        "method": "GET",
                        "path": "/callback",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "printShop",
        "path": "/printShop",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brand",
                        "path": "/brand/{brandId}",
                        "children": [
                            {
                                "type": "router",
                                "name": "customCoupons",
                                "path": "/custom-coupons",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getCustomCoupons",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "designs",
                                "path": "/designs",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createDesign",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "vulcan-error",
                                            "unknown-custom-coupon"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deleteDesign",
                                        "method": "DELETE",
                                        "path": "/{designId}",
                                        "errors": [
                                            "design-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getDesign",
                                        "method": "GET",
                                        "path": "/{designId}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listDesigns",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listTemplates",
                                        "method": "GET",
                                        "path": "/templates",
                                        "errors": [
                                            "unknown-custom-coupon"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "tweakDesign",
                                        "method": "POST",
                                        "path": "/{designId}/tweaks",
                                        "errors": [
                                            "design-not-found",
                                            "design-not-ready",
                                            "vulcan-error",
                                            "unknown-custom-coupon"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "recommendations",
        "path": "/recommendations/v1",
        "children": [
            {
                "type": "router",
                "name": "location",
                "path": "/location/{locationId}",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getUpsellRecommendations",
                        "method": "POST",
                        "path": "/upsells",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "redirects",
        "path": "/redirects",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createRedirect",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "redirect-already-exists",
                                            "invalid-path",
                                            "self-referential-redirect",
                                            "invalid-external-target"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deleteRedirect",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "generateRedirects",
                                        "method": "POST",
                                        "path": "/generate",
                                        "errors": [
                                            "domain-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getRedirectCountByPage",
                                        "method": "GET",
                                        "path": "/page-redirect-count",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listOwnerPages",
                                        "method": "GET",
                                        "path": "/owner-pages",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listRedirects",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateRedirect",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "redirect-does-not-exist",
                                            "invalid-path",
                                            "self-referential-redirect",
                                            "invalid-external-target"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "registrar",
        "path": "/registrar",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "bulkCheck",
                        "method": "POST",
                        "path": "/bulk-check",
                        "errors": [
                            "bulk-check-failed",
                            "bulk-check-timeout"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "fqdn",
                        "path": "/{fqdn}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "check",
                                "method": "GET",
                                "path": "/check",
                                "errors": [
                                    "invalid-domain",
                                    "check-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "disableAutoRenewal",
                                "method": "DELETE",
                                "path": "/auto-renewal",
                                "errors": [
                                    "domain-not-registered",
                                    "auto-renewal-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "enableAutoRenewal",
                                "method": "PUT",
                                "path": "/auto-renewal",
                                "errors": [
                                    "domain-not-registered",
                                    "auto-renewal-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getRegistrationStatus",
                                "method": "GET",
                                "path": "/register/{jobId}",
                                "errors": [
                                    "job-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "info",
                                "method": "GET",
                                "path": "/info",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "refresh",
                                "method": "POST",
                                "path": "/refresh",
                                "errors": [
                                    "domain-not-registered"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "register",
                                "method": "POST",
                                "path": "/register",
                                "errors": [
                                    "domain-already-registered",
                                    "domain-not-available",
                                    "registration-failed",
                                    "registration-rejected",
                                    "availability-check-failed",
                                    "tld-validation-failed",
                                    "transfer-scrape-failed",
                                    "transfer-domain-exists",
                                    "transfer-setup-failed",
                                    "transfer-domain-in-use",
                                    "transfer-brand-has-domain",
                                    "transfer-already-owner-hosted",
                                    "transfer-in-failed",
                                    "transfer-in-rejected",
                                    "domain-not-registered",
                                    "transfer-out-failed",
                                    "registration-in-progress",
                                    "auto-renewal-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "registerAsync",
                                "method": "POST",
                                "path": "/register-async",
                                "errors": [
                                    "domain-already-registered",
                                    "domain-not-available",
                                    "registration-failed",
                                    "registration-rejected",
                                    "availability-check-failed",
                                    "tld-validation-failed",
                                    "transfer-scrape-failed",
                                    "transfer-domain-exists",
                                    "transfer-setup-failed",
                                    "transfer-domain-in-use",
                                    "transfer-brand-has-domain",
                                    "transfer-already-owner-hosted",
                                    "transfer-in-failed",
                                    "transfer-in-rejected",
                                    "domain-not-registered",
                                    "transfer-out-failed",
                                    "registration-in-progress",
                                    "auto-renewal-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "scrape",
                                "method": "GET",
                                "path": "/scrape",
                                "errors": [
                                    "scrape-failed",
                                    "domain-in-use",
                                    "transfer-already-owner-hosted"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "startSetup",
                                "method": "POST",
                                "path": "/start-setup",
                                "errors": [
                                    "domain-in-use",
                                    "domain-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "transferIn",
                                "method": "POST",
                                "path": "/transfer-in",
                                "errors": [
                                    "domain-already-registered",
                                    "domain-not-available",
                                    "registration-failed",
                                    "registration-rejected",
                                    "availability-check-failed",
                                    "tld-validation-failed",
                                    "transfer-scrape-failed",
                                    "transfer-domain-exists",
                                    "transfer-setup-failed",
                                    "transfer-domain-in-use",
                                    "transfer-brand-has-domain",
                                    "transfer-already-owner-hosted",
                                    "transfer-in-failed",
                                    "transfer-in-rejected",
                                    "domain-not-registered",
                                    "transfer-out-failed",
                                    "registration-in-progress",
                                    "auto-renewal-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "transferOut",
                                "method": "POST",
                                "path": "/transfer-out",
                                "errors": [
                                    "domain-not-registered",
                                    "transfer-out-failed"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "suggest",
                        "method": "GET",
                        "path": "/suggest",
                        "errors": [
                            "brand-not-found",
                            "suggestions-failed"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "relay",
        "path": "/relay",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "blocks",
                        "path": "/blocks",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createBlock",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "deleteBlock",
                                "method": "DELETE",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "composeMessage",
                                        "method": "POST",
                                        "path": "/compose",
                                        "errors": [
                                            "no-brand-settings",
                                            "postmark-error",
                                            "unauthorised-from"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listMessages",
                                        "method": "GET",
                                        "path": "/messages",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "messages",
                                        "path": "/messages",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "message",
                                                "path": "/{messageId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "enhanceMessage",
                                                        "method": "POST",
                                                        "path": "/enhance",
                                                        "errors": [
                                                            "message-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getMessage",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "message-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "processMessage",
                                                        "method": "POST",
                                                        "path": "/process",
                                                        "errors": [
                                                            "message-not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "deleteBrandRelay",
                        "method": "DELETE",
                        "path": "/brand",
                        "errors": [
                            "relay-in-use",
                            "reset-reason-required"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getBrandRelay",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "brand-not-found"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "messages",
                        "path": "/messages",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listGlobalMessages",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "replyToMessage",
                        "method": "POST",
                        "path": "/reply",
                        "errors": [
                            "no-brand-settings",
                            "message-not-found",
                            "postmark-error"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setupBrandRelay",
                        "method": "POST",
                        "path": "/setup",
                        "errors": [
                            "no-domain-for-brand",
                            "postmark-error",
                            "dns-config-error",
                            "entri-error"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "verifyRelayDomain",
                        "method": "POST",
                        "path": "/verify",
                        "errors": [
                            "no-brand-settings",
                            "postmark-error"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "reporting",
        "path": "/reporting",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "checkout",
                                        "path": "/checkout",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getConversionCardTotals",
                                                "method": "GET",
                                                "path": "/conversion-card-totals",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getOrderTotals",
                                                "method": "GET",
                                                "path": "/order-totals",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "coupons",
                                        "path": "/coupons",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getCouponBreakdownLog",
                                                "method": "GET",
                                                "path": "/breakdown/log",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getCouponBreakdownReport",
                                                "method": "GET",
                                                "path": "/breakdown",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "customers",
                                        "path": "/customers",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getCustomerTotals",
                                                "method": "GET",
                                                "path": "/customer-totals",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getTopCustomers",
                                                "method": "GET",
                                                "path": "/top-customers",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "items",
                                        "path": "/items",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getItemStats",
                                                "method": "GET",
                                                "path": "/stats",
                                                "errors": [
                                                    "brand-not-found",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "location-not-found",
                                                    "location-brand-mismatch"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "labor",
                                        "path": "/labor",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getCostOfLaborByJob",
                                                "method": "GET",
                                                "path": "/cost-of-labor-by-job",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getCostOfLaborSummary",
                                                "method": "GET",
                                                "path": "/cost-of-labor-summary",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "marketing",
                                        "path": "/marketing",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getNewSubscribers",
                                                "method": "GET",
                                                "path": "/new-subscribers",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSubscriberTotalBySubscriptionType",
                                                "method": "GET",
                                                "path": "/subscriber-totals-by-type",
                                                "errors": [
                                                    "brand-not-found",
                                                    "invalid-date-format",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "internal-server-error"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSubscriberTotals",
                                                "method": "GET",
                                                "path": "/subscriber-totals",
                                                "errors": [
                                                    "brand-not-found",
                                                    "invalid-date-format",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "location-not-found",
                                                    "location-brand-mismatch"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "menu",
                                        "path": "/menu",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getMenuItemRankMetrics",
                                                "method": "GET",
                                                "path": "/item-rank-metrics",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "not-yet-implemented",
                                                    "invalid-date-range",
                                                    "invalid-brand-or-location-filter",
                                                    "brand-no-locations"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getMenuItemRanks",
                                                "method": "GET",
                                                "path": "/item-ranks",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "not-yet-implemented",
                                                    "invalid-date-range",
                                                    "invalid-brand-or-location-filter",
                                                    "brand-no-locations"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "modifierSets",
                                        "path": "/modifier-sets",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getModifierSetStats",
                                                "method": "GET",
                                                "path": "/stats",
                                                "errors": [
                                                    "brand-not-found",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "date-range-too-large"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "payments",
                                        "path": "/payments",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getPaymentMethodStats",
                                                "method": "GET",
                                                "path": "/payment-method-stats",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-filter-unavailable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPaymentMethodStatsByOrder",
                                                "method": "GET",
                                                "path": "/payment-method-stats-by-order",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPaymentStatsByEpoch",
                                                "method": "GET",
                                                "path": "/payment-stats-by-epoch",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "payouts",
                                        "path": "/payouts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getPayoutStats",
                                                "method": "GET",
                                                "path": "/payout-stats",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "printShop",
                                        "path": "/print-shop",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getPerformanceSummary",
                                                "method": "GET",
                                                "path": "/performance-summary",
                                                "errors": [
                                                    "brand-not-found",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "location-not-found",
                                                    "location-brand-mismatch"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "reviews",
                                        "path": "/reviews",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getGoogleReviewTotals",
                                                "method": "GET",
                                                "path": "/google-review-totals",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "sales",
                                        "path": "/sales",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getAvailableChannels",
                                                "method": "GET",
                                                "path": "/available-channels",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-filter-unavailable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getEstimatedLostSales",
                                                "method": "GET",
                                                "path": "/estimated-lost-sales",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSalesData",
                                                "method": "GET",
                                                "path": "/sales-data",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "brand-no-locations",
                                                    "location-brand-mismatch",
                                                    "invalid-date-range",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSalesSummary",
                                                "method": "GET",
                                                "path": "/sales-summary",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-filter-unavailable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSalesSummaryByEpoch",
                                                "method": "GET",
                                                "path": "/sales-summary-by-epoch",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-filter-unavailable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSalesSummaryByOrder",
                                                "method": "GET",
                                                "path": "/sales-summary-by-order",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-filter-unavailable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSalesSummaryByStaff",
                                                "method": "GET",
                                                "path": "/sales-summary-by-staff",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-filter-unavailable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSalesTotals",
                                                "method": "GET",
                                                "path": "/sales-totals",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "seo",
                                        "path": "/seo",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getOverallSEORank",
                                                "method": "GET",
                                                "path": "/overall-seo-rank",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "invalid-brand-or-location-filter",
                                                    "brand-no-locations"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSeoKeywordRanks",
                                                "method": "GET",
                                                "path": "/keyword-ranks",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "invalid-brand-or-location-filter",
                                                    "brand-no-locations",
                                                    "not-yet-implemented"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "sessions",
                                        "path": "/sessions",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getSessionTotals",
                                                "method": "GET",
                                                "path": "/session-totals",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "staffTips",
                                        "path": "/staff-tips",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getStaffTipOrders",
                                                "method": "GET",
                                                "path": "/employees/{employeeId}/orders",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-attribution-unavailable",
                                                    "date-range-too-large"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getStaffTipsSummary",
                                                "method": "GET",
                                                "path": "/summary",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter",
                                                    "staff-attribution-unavailable",
                                                    "date-range-too-large"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "tipsFees",
                                        "path": "/tips-fees",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getTipsFeesSummary",
                                                "method": "GET",
                                                "path": "/tips-fees-summary",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "valueEngine",
                                        "path": "/value-engine",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getValueEngineFeeds",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "voids",
                                        "path": "/voids",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getVoidedOrders",
                                                "method": "GET",
                                                "path": "/orders",
                                                "errors": [
                                                    "brand-not-found",
                                                    "location-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations",
                                                    "invalid-brand-or-location-filter"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "sync",
                        "path": "/sync",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "densityGrid",
                                "method": "POST",
                                "path": "/density-grid",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "gpScore",
                                "method": "POST",
                                "path": "/gp-score",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "greenShoots",
                                "method": "POST",
                                "path": "/green-shoots",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "marketplacePricing",
                                "method": "POST",
                                "path": "/marketplace-pricing",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "valueEngineProduct",
                                "method": "POST",
                                "path": "/value-engine",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "reportingVerification",
        "path": "/reporting-verification",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "payouts",
                                        "path": "/payouts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "payout",
                                                "path": "/{payoutId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "comparison",
                                                        "method": "GET",
                                                        "path": "/comparison",
                                                        "errors": [
                                                            "payout-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "get",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "payout-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "reconcile",
                                                        "method": "POST",
                                                        "path": "/reconcile",
                                                        "errors": [
                                                            "payout-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "runComparison",
                                                        "method": "POST",
                                                        "path": "/comparison",
                                                        "errors": [
                                                            "payout-not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "reconciliationFailures",
                        "path": "/reconciliation-failures",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "list",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "endpoint",
        "name": "requestFileUploadKey",
        "method": "GET",
        "path": "/file-upload",
        "errors": []
    },
    {
        "type": "endpoint",
        "name": "requestFileUploadKeyAdmin",
        "method": "GET",
        "path": "/file-upload-admin",
        "errors": []
    },
    {
        "type": "router",
        "name": "reviews",
        "path": "/reviews",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "getReviews",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createReview",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "reviews-not-enabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "upsertPotentialReview",
                                        "method": "POST",
                                        "path": "/upsert-potential-review",
                                        "errors": [
                                            "brand-not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "review",
                        "path": "/{reviewId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "deleteReview",
                                "method": "DELETE",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getReview",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "sales",
        "path": "/sales",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "claim",
                                        "method": "POST",
                                        "path": "/claim",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createPaymentMethodForUser",
                                        "method": "POST",
                                        "path": "/payment-method",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandMetadata",
                                        "method": "GET",
                                        "path": "/metadata",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "hardwareOrders",
                                        "path": "/hardware-orders",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "hardwareOrder",
                                                "path": "/{orderId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "releaseHardwareOrder",
                                                        "method": "POST",
                                                        "path": "/release",
                                                        "errors": [
                                                            "warehouse-release-failed",
                                                            "hardware-order-not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "setHardwareOrderSerial",
                                                        "method": "PUT",
                                                        "path": "/serials",
                                                        "errors": [
                                                            "hardware-order-not-found",
                                                            "hardware-order-unit-not-found"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listHardwareOrders",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "initializeLocation",
                                        "method": "POST",
                                        "path": "/locations",
                                        "errors": [
                                            "location-quebec-not-supported"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listLocations",
                                        "method": "GET",
                                        "path": "/locations",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listPaymentMethodsForUser",
                                        "method": "GET",
                                        "path": "/payment-methods",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateCustomerIndicatedLocationCount",
                                        "method": "PUT",
                                        "path": "/customer-indicated-location-count",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSalesIndicatedLocationCount",
                                        "method": "PUT",
                                        "path": "/sales-indicated-location-count",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "findDuplicateCandidates",
                                "method": "GET",
                                "path": "/duplicate-candidates",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "initializeBrand",
                                "method": "POST",
                                "path": "/initialize",
                                "errors": [
                                    "invalid-address",
                                    "unsupported-region"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "searchAccessibleBrands",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "enrichment",
                        "path": "/enrichment",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "evaluateBusiness",
                                "method": "POST",
                                "path": "/evaluate-business",
                                "errors": [
                                    "enrichment-service-error",
                                    "no-businesses-found",
                                    "forbidden-origin"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "addOns",
                                        "path": "/add-ons",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "addOn",
                                                "path": "/{addOnName}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "cancelAddOn",
                                                        "method": "POST",
                                                        "path": "/cancel",
                                                        "errors": [
                                                            "add-on-not-found",
                                                            "add-on-not-attached",
                                                            "add-on-already-active",
                                                            "add-on-charge-failed",
                                                            "add-on-invalid-state",
                                                            "add-on-offer-invalid",
                                                            "add-on-coupon-not-found",
                                                            "add-on-coupon-currency-mismatch"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listAddOns",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "add-on-not-found",
                                                    "add-on-not-attached",
                                                    "add-on-already-active",
                                                    "add-on-charge-failed",
                                                    "add-on-invalid-state",
                                                    "add-on-offer-invalid",
                                                    "add-on-coupon-not-found",
                                                    "add-on-coupon-currency-mismatch"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getLocationSalesInfo",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getOfferedPlans",
                                        "method": "GET",
                                        "path": "/offered-plans",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "processingStatements",
                                        "path": "/processing-statements",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createUploadUrl",
                                                "method": "POST",
                                                "path": "/upload-url",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "processingStatement",
                                                "path": "/{statementId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getStatement",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "statement-file-not-owned",
                                                            "statement-file-missing",
                                                            "statement-file-already-recorded",
                                                            "quote-statement-already-attached",
                                                            "statement-not-found",
                                                            "statement-location-mismatch",
                                                            "statement-file-unreadable"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "recordStatement",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "statement-file-not-owned",
                                                    "statement-file-missing",
                                                    "statement-file-already-recorded",
                                                    "quote-statement-already-attached",
                                                    "statement-not-found",
                                                    "statement-location-mismatch",
                                                    "statement-file-unreadable"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateImplementationFee",
                                        "method": "PATCH",
                                        "path": "/implementation-fee",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updatePurchaseType",
                                        "method": "PUT",
                                        "path": "/purchase-type",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "selfServeCheckout",
                                "method": "POST",
                                "path": "/self-serve-checkout",
                                "errors": [
                                    "feature-disabled",
                                    "no-eligible-locations",
                                    "multi-brand-not-supported",
                                    "plan-not-offered"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "nacho",
                        "path": "/nacho",
                        "children": [
                            {
                                "type": "router",
                                "name": "brands",
                                "path": "/brands",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createBrand",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "feature-disabled",
                                            "pipeline-not-found",
                                            "payer-not-found",
                                            "quote-has-no-location-items"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createLocation",
                                        "method": "POST",
                                        "path": "/{brandId}/locations",
                                        "errors": [
                                            "feature-disabled",
                                            "pipeline-not-found",
                                            "payer-not-found",
                                            "quote-has-no-location-items"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "upsertBrandAdmin",
                                        "method": "POST",
                                        "path": "/{brandId}/admins",
                                        "errors": [
                                            "feature-disabled",
                                            "pipeline-not-found",
                                            "payer-not-found",
                                            "quote-has-no-location-items",
                                            "insufficient-location-access",
                                            "invalid-email",
                                            "existing-brand-relationship"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "pipelines",
                                "path": "/pipelines",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getPipelineStatus",
                                        "method": "GET",
                                        "path": "/{pipelineExecutionId}",
                                        "errors": [
                                            "feature-disabled",
                                            "pipeline-not-found",
                                            "payer-not-found",
                                            "quote-has-no-location-items"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "quotes",
                                "path": "/quotes",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createQuote",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed",
                                            "pipeline-not-found",
                                            "payer-not-found",
                                            "quote-has-no-location-items"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getQuote",
                                        "method": "GET",
                                        "path": "/{quoteId}",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed",
                                            "pipeline-not-found",
                                            "payer-not-found",
                                            "quote-has-no-location-items"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "sendQuote",
                                        "method": "POST",
                                        "path": "/{quoteId}/send",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed",
                                            "pipeline-not-found",
                                            "payer-not-found",
                                            "quote-has-no-location-items"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "quotes",
                        "path": "/quotes",
                        "children": [
                            {
                                "type": "router",
                                "name": "approvalRequests",
                                "path": "/approval-requests",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "approvalRequest",
                                        "path": "/{approvalRequestId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getApprovalRequest",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled",
                                                    "quote-not-editable",
                                                    "quote-not-priceable",
                                                    "quote-processing-statement-required",
                                                    "quote-requires-brand",
                                                    "quote-scope-brand-mismatch",
                                                    "quote-brand-not-found",
                                                    "quote-brand-not-in-scope",
                                                    "quote-location-brand-mismatch",
                                                    "quote-primary-brand-not-in-scope",
                                                    "unknown-quote-product",
                                                    "unsupported-quote-product-sale-context",
                                                    "unsupported-quote-product-fulfillment",
                                                    "invalid-quote-product-scope",
                                                    "invalid-quote-product-config",
                                                    "invalid-quote-item-quantity",
                                                    "quote-item-exceeds-location-limit",
                                                    "quote-item-not-created",
                                                    "quote-item-not-found",
                                                    "unknown-quote-coupon",
                                                    "quote-coupon-not-created",
                                                    "invalid-quote-status-transition",
                                                    "quote-version-quote-mismatch",
                                                    "quote-version-not-pending-approval",
                                                    "quote-not-pending-approval",
                                                    "quote-approval-requester-required",
                                                    "quote-not-approved",
                                                    "quote-version-not-approved",
                                                    "quote-version-not-current",
                                                    "quote-version-snapshot-invalid",
                                                    "quote-approval-request-not-found",
                                                    "not-billing-admin",
                                                    "quote-approval-review-invalid",
                                                    "quote-currency-mismatch",
                                                    "quote-modifier-currency-mismatch",
                                                    "quote-region-not-enabled",
                                                    "quote-location-region-unsupported",
                                                    "quote-product-not-available-in-region",
                                                    "quote-installments-disabled",
                                                    "quote-product-not-offered",
                                                    "quote-installments-not-supported",
                                                    "standard-subscription-plan-required",
                                                    "standard-subscription-plan-not-found",
                                                    "quote-price-binding-not-found",
                                                    "quote-requires-item",
                                                    "quote-billing-location-required",
                                                    "quote-coupon-not-applicable",
                                                    "quote-fee-adjustment-not-created",
                                                    "quote-fee-adjustment-location-invalid",
                                                    "checkout-session-requires-version",
                                                    "checkout-version-not-found",
                                                    "checkout-quote-not-found",
                                                    "multi-brand-checkout-not-supported",
                                                    "checkout-quote-missing-brand",
                                                    "checkout-session-expiration-invalid",
                                                    "checkout-version-quote-mismatch",
                                                    "checkout-version-not-ready",
                                                    "checkout-version-not-loaded",
                                                    "checkout-version-not-current",
                                                    "checkout-quote-not-ready",
                                                    "quote-not-found",
                                                    "quote-checkout-plan-not-found",
                                                    "quote-checkout-assignment-not-found",
                                                    "quote-checkout-location-not-in-quote",
                                                    "quote-checkout-payment-allocation-invalid",
                                                    "quote-not-chargeable",
                                                    "quote-not-checkoutable",
                                                    "quote-charge-requires-charges",
                                                    "quote-charge-location-not-payable",
                                                    "quote-charge-location-already-fulfilled",
                                                    "quote-charge-card-owner-mismatch",
                                                    "quote-charge-run-in-progress",
                                                    "quote-charge-run-not-found",
                                                    "quote-charge-run-unavailable",
                                                    "quote-checkout-recipient-required",
                                                    "quote-checkout-send-failed"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listApprovalRequests",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createQuote",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "feature-disabled",
                                    "quote-not-editable",
                                    "quote-not-priceable",
                                    "quote-processing-statement-required",
                                    "quote-requires-brand",
                                    "quote-scope-brand-mismatch",
                                    "quote-brand-not-found",
                                    "quote-brand-not-in-scope",
                                    "quote-location-brand-mismatch",
                                    "quote-primary-brand-not-in-scope",
                                    "unknown-quote-product",
                                    "unsupported-quote-product-sale-context",
                                    "unsupported-quote-product-fulfillment",
                                    "invalid-quote-product-scope",
                                    "invalid-quote-product-config",
                                    "invalid-quote-item-quantity",
                                    "quote-item-exceeds-location-limit",
                                    "quote-item-not-created",
                                    "quote-item-not-found",
                                    "unknown-quote-coupon",
                                    "quote-coupon-not-created",
                                    "invalid-quote-status-transition",
                                    "quote-version-quote-mismatch",
                                    "quote-version-not-pending-approval",
                                    "quote-not-pending-approval",
                                    "quote-approval-requester-required",
                                    "quote-not-approved",
                                    "quote-version-not-approved",
                                    "quote-version-not-current",
                                    "quote-version-snapshot-invalid",
                                    "quote-approval-request-not-found",
                                    "not-billing-admin",
                                    "quote-approval-review-invalid",
                                    "quote-currency-mismatch",
                                    "quote-modifier-currency-mismatch",
                                    "quote-region-not-enabled",
                                    "quote-location-region-unsupported",
                                    "quote-product-not-available-in-region",
                                    "quote-installments-disabled",
                                    "quote-product-not-offered",
                                    "quote-installments-not-supported",
                                    "standard-subscription-plan-required",
                                    "standard-subscription-plan-not-found",
                                    "quote-price-binding-not-found",
                                    "quote-requires-item",
                                    "quote-billing-location-required",
                                    "quote-coupon-not-applicable",
                                    "quote-fee-adjustment-not-created",
                                    "quote-fee-adjustment-location-invalid",
                                    "checkout-session-requires-version",
                                    "checkout-version-not-found",
                                    "checkout-quote-not-found",
                                    "multi-brand-checkout-not-supported",
                                    "checkout-quote-missing-brand",
                                    "checkout-session-expiration-invalid",
                                    "checkout-version-quote-mismatch",
                                    "checkout-version-not-ready",
                                    "checkout-version-not-loaded",
                                    "checkout-version-not-current",
                                    "checkout-quote-not-ready",
                                    "quote-not-found",
                                    "quote-checkout-plan-not-found",
                                    "quote-checkout-assignment-not-found",
                                    "quote-checkout-location-not-in-quote",
                                    "quote-checkout-payment-allocation-invalid",
                                    "quote-not-chargeable",
                                    "quote-not-checkoutable",
                                    "quote-charge-requires-charges",
                                    "quote-charge-location-not-payable",
                                    "quote-charge-location-already-fulfilled",
                                    "quote-charge-card-owner-mismatch",
                                    "quote-charge-run-in-progress",
                                    "quote-charge-run-not-found",
                                    "quote-charge-run-unavailable",
                                    "quote-checkout-recipient-required",
                                    "quote-checkout-send-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "isApprover",
                                "method": "GET",
                                "path": "/is-approver",
                                "errors": [
                                    "feature-disabled",
                                    "quote-not-editable",
                                    "quote-not-priceable",
                                    "quote-processing-statement-required",
                                    "quote-requires-brand",
                                    "quote-scope-brand-mismatch",
                                    "quote-brand-not-found",
                                    "quote-brand-not-in-scope",
                                    "quote-location-brand-mismatch",
                                    "quote-primary-brand-not-in-scope",
                                    "unknown-quote-product",
                                    "unsupported-quote-product-sale-context",
                                    "unsupported-quote-product-fulfillment",
                                    "invalid-quote-product-scope",
                                    "invalid-quote-product-config",
                                    "invalid-quote-item-quantity",
                                    "quote-item-exceeds-location-limit",
                                    "quote-item-not-created",
                                    "quote-item-not-found",
                                    "unknown-quote-coupon",
                                    "quote-coupon-not-created",
                                    "invalid-quote-status-transition",
                                    "quote-version-quote-mismatch",
                                    "quote-version-not-pending-approval",
                                    "quote-not-pending-approval",
                                    "quote-approval-requester-required",
                                    "quote-not-approved",
                                    "quote-version-not-approved",
                                    "quote-version-not-current",
                                    "quote-version-snapshot-invalid",
                                    "quote-approval-request-not-found",
                                    "not-billing-admin",
                                    "quote-approval-review-invalid",
                                    "quote-currency-mismatch",
                                    "quote-modifier-currency-mismatch",
                                    "quote-region-not-enabled",
                                    "quote-location-region-unsupported",
                                    "quote-product-not-available-in-region",
                                    "quote-installments-disabled",
                                    "quote-product-not-offered",
                                    "quote-installments-not-supported",
                                    "standard-subscription-plan-required",
                                    "standard-subscription-plan-not-found",
                                    "quote-price-binding-not-found",
                                    "quote-requires-item",
                                    "quote-billing-location-required",
                                    "quote-coupon-not-applicable",
                                    "quote-fee-adjustment-not-created",
                                    "quote-fee-adjustment-location-invalid",
                                    "checkout-session-requires-version",
                                    "checkout-version-not-found",
                                    "checkout-quote-not-found",
                                    "multi-brand-checkout-not-supported",
                                    "checkout-quote-missing-brand",
                                    "checkout-session-expiration-invalid",
                                    "checkout-version-quote-mismatch",
                                    "checkout-version-not-ready",
                                    "checkout-version-not-loaded",
                                    "checkout-version-not-current",
                                    "checkout-quote-not-ready",
                                    "quote-not-found",
                                    "quote-checkout-plan-not-found",
                                    "quote-checkout-assignment-not-found",
                                    "quote-checkout-location-not-in-quote",
                                    "quote-checkout-payment-allocation-invalid",
                                    "quote-not-chargeable",
                                    "quote-not-checkoutable",
                                    "quote-charge-requires-charges",
                                    "quote-charge-location-not-payable",
                                    "quote-charge-location-already-fulfilled",
                                    "quote-charge-card-owner-mismatch",
                                    "quote-charge-run-in-progress",
                                    "quote-charge-run-not-found",
                                    "quote-charge-run-unavailable",
                                    "quote-checkout-recipient-required",
                                    "quote-checkout-send-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listCoupons",
                                "method": "GET",
                                "path": "/coupons",
                                "errors": [
                                    "feature-disabled",
                                    "quote-not-editable",
                                    "quote-not-priceable",
                                    "quote-processing-statement-required",
                                    "quote-requires-brand",
                                    "quote-scope-brand-mismatch",
                                    "quote-brand-not-found",
                                    "quote-brand-not-in-scope",
                                    "quote-location-brand-mismatch",
                                    "quote-primary-brand-not-in-scope",
                                    "unknown-quote-product",
                                    "unsupported-quote-product-sale-context",
                                    "unsupported-quote-product-fulfillment",
                                    "invalid-quote-product-scope",
                                    "invalid-quote-product-config",
                                    "invalid-quote-item-quantity",
                                    "quote-item-exceeds-location-limit",
                                    "quote-item-not-created",
                                    "quote-item-not-found",
                                    "unknown-quote-coupon",
                                    "quote-coupon-not-created",
                                    "invalid-quote-status-transition",
                                    "quote-version-quote-mismatch",
                                    "quote-version-not-pending-approval",
                                    "quote-not-pending-approval",
                                    "quote-approval-requester-required",
                                    "quote-not-approved",
                                    "quote-version-not-approved",
                                    "quote-version-not-current",
                                    "quote-version-snapshot-invalid",
                                    "quote-approval-request-not-found",
                                    "not-billing-admin",
                                    "quote-approval-review-invalid",
                                    "quote-currency-mismatch",
                                    "quote-modifier-currency-mismatch",
                                    "quote-region-not-enabled",
                                    "quote-location-region-unsupported",
                                    "quote-product-not-available-in-region",
                                    "quote-installments-disabled",
                                    "quote-product-not-offered",
                                    "quote-installments-not-supported",
                                    "standard-subscription-plan-required",
                                    "standard-subscription-plan-not-found",
                                    "quote-price-binding-not-found",
                                    "quote-requires-item",
                                    "quote-billing-location-required",
                                    "quote-coupon-not-applicable",
                                    "quote-fee-adjustment-not-created",
                                    "quote-fee-adjustment-location-invalid",
                                    "checkout-session-requires-version",
                                    "checkout-version-not-found",
                                    "checkout-quote-not-found",
                                    "multi-brand-checkout-not-supported",
                                    "checkout-quote-missing-brand",
                                    "checkout-session-expiration-invalid",
                                    "checkout-version-quote-mismatch",
                                    "checkout-version-not-ready",
                                    "checkout-version-not-loaded",
                                    "checkout-version-not-current",
                                    "checkout-quote-not-ready",
                                    "quote-not-found",
                                    "quote-checkout-plan-not-found",
                                    "quote-checkout-assignment-not-found",
                                    "quote-checkout-location-not-in-quote",
                                    "quote-checkout-payment-allocation-invalid",
                                    "quote-not-chargeable",
                                    "quote-not-checkoutable",
                                    "quote-charge-requires-charges",
                                    "quote-charge-location-not-payable",
                                    "quote-charge-location-already-fulfilled",
                                    "quote-charge-card-owner-mismatch",
                                    "quote-charge-run-in-progress",
                                    "quote-charge-run-not-found",
                                    "quote-charge-run-unavailable",
                                    "quote-checkout-recipient-required",
                                    "quote-checkout-send-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listProducts",
                                "method": "GET",
                                "path": "/products",
                                "errors": [
                                    "feature-disabled",
                                    "quote-not-editable",
                                    "quote-not-priceable",
                                    "quote-processing-statement-required",
                                    "quote-requires-brand",
                                    "quote-scope-brand-mismatch",
                                    "quote-brand-not-found",
                                    "quote-brand-not-in-scope",
                                    "quote-location-brand-mismatch",
                                    "quote-primary-brand-not-in-scope",
                                    "unknown-quote-product",
                                    "unsupported-quote-product-sale-context",
                                    "unsupported-quote-product-fulfillment",
                                    "invalid-quote-product-scope",
                                    "invalid-quote-product-config",
                                    "invalid-quote-item-quantity",
                                    "quote-item-exceeds-location-limit",
                                    "quote-item-not-created",
                                    "quote-item-not-found",
                                    "unknown-quote-coupon",
                                    "quote-coupon-not-created",
                                    "invalid-quote-status-transition",
                                    "quote-version-quote-mismatch",
                                    "quote-version-not-pending-approval",
                                    "quote-not-pending-approval",
                                    "quote-approval-requester-required",
                                    "quote-not-approved",
                                    "quote-version-not-approved",
                                    "quote-version-not-current",
                                    "quote-version-snapshot-invalid",
                                    "quote-approval-request-not-found",
                                    "not-billing-admin",
                                    "quote-approval-review-invalid",
                                    "quote-currency-mismatch",
                                    "quote-modifier-currency-mismatch",
                                    "quote-region-not-enabled",
                                    "quote-location-region-unsupported",
                                    "quote-product-not-available-in-region",
                                    "quote-installments-disabled",
                                    "quote-product-not-offered",
                                    "quote-installments-not-supported",
                                    "standard-subscription-plan-required",
                                    "standard-subscription-plan-not-found",
                                    "quote-price-binding-not-found",
                                    "quote-requires-item",
                                    "quote-billing-location-required",
                                    "quote-coupon-not-applicable",
                                    "quote-fee-adjustment-not-created",
                                    "quote-fee-adjustment-location-invalid",
                                    "checkout-session-requires-version",
                                    "checkout-version-not-found",
                                    "checkout-quote-not-found",
                                    "multi-brand-checkout-not-supported",
                                    "checkout-quote-missing-brand",
                                    "checkout-session-expiration-invalid",
                                    "checkout-version-quote-mismatch",
                                    "checkout-version-not-ready",
                                    "checkout-version-not-loaded",
                                    "checkout-version-not-current",
                                    "checkout-quote-not-ready",
                                    "quote-not-found",
                                    "quote-checkout-plan-not-found",
                                    "quote-checkout-assignment-not-found",
                                    "quote-checkout-location-not-in-quote",
                                    "quote-checkout-payment-allocation-invalid",
                                    "quote-not-chargeable",
                                    "quote-not-checkoutable",
                                    "quote-charge-requires-charges",
                                    "quote-charge-location-not-payable",
                                    "quote-charge-location-already-fulfilled",
                                    "quote-charge-card-owner-mismatch",
                                    "quote-charge-run-in-progress",
                                    "quote-charge-run-not-found",
                                    "quote-charge-run-unavailable",
                                    "quote-checkout-recipient-required",
                                    "quote-checkout-send-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listQuoteIndex",
                                "method": "GET",
                                "path": "/index",
                                "errors": [
                                    "feature-disabled",
                                    "quote-not-editable",
                                    "quote-not-priceable",
                                    "quote-processing-statement-required",
                                    "quote-requires-brand",
                                    "quote-scope-brand-mismatch",
                                    "quote-brand-not-found",
                                    "quote-brand-not-in-scope",
                                    "quote-location-brand-mismatch",
                                    "quote-primary-brand-not-in-scope",
                                    "unknown-quote-product",
                                    "unsupported-quote-product-sale-context",
                                    "unsupported-quote-product-fulfillment",
                                    "invalid-quote-product-scope",
                                    "invalid-quote-product-config",
                                    "invalid-quote-item-quantity",
                                    "quote-item-exceeds-location-limit",
                                    "quote-item-not-created",
                                    "quote-item-not-found",
                                    "unknown-quote-coupon",
                                    "quote-coupon-not-created",
                                    "invalid-quote-status-transition",
                                    "quote-version-quote-mismatch",
                                    "quote-version-not-pending-approval",
                                    "quote-not-pending-approval",
                                    "quote-approval-requester-required",
                                    "quote-not-approved",
                                    "quote-version-not-approved",
                                    "quote-version-not-current",
                                    "quote-version-snapshot-invalid",
                                    "quote-approval-request-not-found",
                                    "not-billing-admin",
                                    "quote-approval-review-invalid",
                                    "quote-currency-mismatch",
                                    "quote-modifier-currency-mismatch",
                                    "quote-region-not-enabled",
                                    "quote-location-region-unsupported",
                                    "quote-product-not-available-in-region",
                                    "quote-installments-disabled",
                                    "quote-product-not-offered",
                                    "quote-installments-not-supported",
                                    "standard-subscription-plan-required",
                                    "standard-subscription-plan-not-found",
                                    "quote-price-binding-not-found",
                                    "quote-requires-item",
                                    "quote-billing-location-required",
                                    "quote-coupon-not-applicable",
                                    "quote-fee-adjustment-not-created",
                                    "quote-fee-adjustment-location-invalid",
                                    "checkout-session-requires-version",
                                    "checkout-version-not-found",
                                    "checkout-quote-not-found",
                                    "multi-brand-checkout-not-supported",
                                    "checkout-quote-missing-brand",
                                    "checkout-session-expiration-invalid",
                                    "checkout-version-quote-mismatch",
                                    "checkout-version-not-ready",
                                    "checkout-version-not-loaded",
                                    "checkout-version-not-current",
                                    "checkout-quote-not-ready",
                                    "quote-not-found",
                                    "quote-checkout-plan-not-found",
                                    "quote-checkout-assignment-not-found",
                                    "quote-checkout-location-not-in-quote",
                                    "quote-checkout-payment-allocation-invalid",
                                    "quote-not-chargeable",
                                    "quote-not-checkoutable",
                                    "quote-charge-requires-charges",
                                    "quote-charge-location-not-payable",
                                    "quote-charge-location-already-fulfilled",
                                    "quote-charge-card-owner-mismatch",
                                    "quote-charge-run-in-progress",
                                    "quote-charge-run-not-found",
                                    "quote-charge-run-unavailable",
                                    "quote-checkout-recipient-required",
                                    "quote-checkout-send-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "listQuotes",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "feature-disabled",
                                    "quote-not-editable",
                                    "quote-not-priceable",
                                    "quote-processing-statement-required",
                                    "quote-requires-brand",
                                    "quote-scope-brand-mismatch",
                                    "quote-brand-not-found",
                                    "quote-brand-not-in-scope",
                                    "quote-location-brand-mismatch",
                                    "quote-primary-brand-not-in-scope",
                                    "unknown-quote-product",
                                    "unsupported-quote-product-sale-context",
                                    "unsupported-quote-product-fulfillment",
                                    "invalid-quote-product-scope",
                                    "invalid-quote-product-config",
                                    "invalid-quote-item-quantity",
                                    "quote-item-exceeds-location-limit",
                                    "quote-item-not-created",
                                    "quote-item-not-found",
                                    "unknown-quote-coupon",
                                    "quote-coupon-not-created",
                                    "invalid-quote-status-transition",
                                    "quote-version-quote-mismatch",
                                    "quote-version-not-pending-approval",
                                    "quote-not-pending-approval",
                                    "quote-approval-requester-required",
                                    "quote-not-approved",
                                    "quote-version-not-approved",
                                    "quote-version-not-current",
                                    "quote-version-snapshot-invalid",
                                    "quote-approval-request-not-found",
                                    "not-billing-admin",
                                    "quote-approval-review-invalid",
                                    "quote-currency-mismatch",
                                    "quote-modifier-currency-mismatch",
                                    "quote-region-not-enabled",
                                    "quote-location-region-unsupported",
                                    "quote-product-not-available-in-region",
                                    "quote-installments-disabled",
                                    "quote-product-not-offered",
                                    "quote-installments-not-supported",
                                    "standard-subscription-plan-required",
                                    "standard-subscription-plan-not-found",
                                    "quote-price-binding-not-found",
                                    "quote-requires-item",
                                    "quote-billing-location-required",
                                    "quote-coupon-not-applicable",
                                    "quote-fee-adjustment-not-created",
                                    "quote-fee-adjustment-location-invalid",
                                    "checkout-session-requires-version",
                                    "checkout-version-not-found",
                                    "checkout-quote-not-found",
                                    "multi-brand-checkout-not-supported",
                                    "checkout-quote-missing-brand",
                                    "checkout-session-expiration-invalid",
                                    "checkout-version-quote-mismatch",
                                    "checkout-version-not-ready",
                                    "checkout-version-not-loaded",
                                    "checkout-version-not-current",
                                    "checkout-quote-not-ready",
                                    "quote-not-found",
                                    "quote-checkout-plan-not-found",
                                    "quote-checkout-assignment-not-found",
                                    "quote-checkout-location-not-in-quote",
                                    "quote-checkout-payment-allocation-invalid",
                                    "quote-not-chargeable",
                                    "quote-not-checkoutable",
                                    "quote-charge-requires-charges",
                                    "quote-charge-location-not-payable",
                                    "quote-charge-location-already-fulfilled",
                                    "quote-charge-card-owner-mismatch",
                                    "quote-charge-run-in-progress",
                                    "quote-charge-run-not-found",
                                    "quote-charge-run-unavailable",
                                    "quote-checkout-recipient-required",
                                    "quote-checkout-send-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "pricePreview",
                                "method": "POST",
                                "path": "/price-preview",
                                "errors": [
                                    "feature-disabled",
                                    "quote-not-editable",
                                    "quote-not-priceable",
                                    "quote-processing-statement-required",
                                    "quote-requires-brand",
                                    "quote-scope-brand-mismatch",
                                    "quote-brand-not-found",
                                    "quote-brand-not-in-scope",
                                    "quote-location-brand-mismatch",
                                    "quote-primary-brand-not-in-scope",
                                    "unknown-quote-product",
                                    "unsupported-quote-product-sale-context",
                                    "unsupported-quote-product-fulfillment",
                                    "invalid-quote-product-scope",
                                    "invalid-quote-product-config",
                                    "invalid-quote-item-quantity",
                                    "quote-item-exceeds-location-limit",
                                    "quote-item-not-created",
                                    "quote-item-not-found",
                                    "unknown-quote-coupon",
                                    "quote-coupon-not-created",
                                    "invalid-quote-status-transition",
                                    "quote-version-quote-mismatch",
                                    "quote-version-not-pending-approval",
                                    "quote-not-pending-approval",
                                    "quote-approval-requester-required",
                                    "quote-not-approved",
                                    "quote-version-not-approved",
                                    "quote-version-not-current",
                                    "quote-version-snapshot-invalid",
                                    "quote-approval-request-not-found",
                                    "not-billing-admin",
                                    "quote-approval-review-invalid",
                                    "quote-currency-mismatch",
                                    "quote-modifier-currency-mismatch",
                                    "quote-region-not-enabled",
                                    "quote-location-region-unsupported",
                                    "quote-product-not-available-in-region",
                                    "quote-installments-disabled",
                                    "quote-product-not-offered",
                                    "quote-installments-not-supported",
                                    "standard-subscription-plan-required",
                                    "standard-subscription-plan-not-found",
                                    "quote-price-binding-not-found",
                                    "quote-requires-item",
                                    "quote-billing-location-required",
                                    "quote-coupon-not-applicable",
                                    "quote-fee-adjustment-not-created",
                                    "quote-fee-adjustment-location-invalid",
                                    "checkout-session-requires-version",
                                    "checkout-version-not-found",
                                    "checkout-quote-not-found",
                                    "multi-brand-checkout-not-supported",
                                    "checkout-quote-missing-brand",
                                    "checkout-session-expiration-invalid",
                                    "checkout-version-quote-mismatch",
                                    "checkout-version-not-ready",
                                    "checkout-version-not-loaded",
                                    "checkout-version-not-current",
                                    "checkout-quote-not-ready",
                                    "quote-not-found",
                                    "quote-checkout-plan-not-found",
                                    "quote-checkout-assignment-not-found",
                                    "quote-checkout-location-not-in-quote",
                                    "quote-checkout-payment-allocation-invalid",
                                    "quote-not-chargeable",
                                    "quote-not-checkoutable",
                                    "quote-charge-requires-charges",
                                    "quote-charge-location-not-payable",
                                    "quote-charge-location-already-fulfilled",
                                    "quote-charge-card-owner-mismatch",
                                    "quote-charge-run-in-progress",
                                    "quote-charge-run-not-found",
                                    "quote-charge-run-unavailable",
                                    "quote-checkout-recipient-required",
                                    "quote-checkout-send-failed"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "quote",
                                "path": "/{quoteId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "addCoupon",
                                        "method": "POST",
                                        "path": "/coupons",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "addFeeAdjustment",
                                        "method": "POST",
                                        "path": "/fee-adjustments",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "addItem",
                                        "method": "POST",
                                        "path": "/items",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "archiveQuote",
                                        "method": "POST",
                                        "path": "/archive",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "cancelQuote",
                                        "method": "POST",
                                        "path": "/cancel",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "chargeQuote",
                                        "method": "POST",
                                        "path": "/charge",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed",
                                            "payment-method-not-found",
                                            "unauthorized-access",
                                            "invalid-payment-method",
                                            "card-declined",
                                            "invalid-cvc",
                                            "expired-card",
                                            "payment-not-captured"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createCheckoutSession",
                                        "method": "POST",
                                        "path": "/checkout-sessions",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deleteItem",
                                        "method": "DELETE",
                                        "path": "/items/{itemId}",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getChargeRun",
                                        "method": "GET",
                                        "path": "/charge-runs/{chargeRunId}",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getQuote",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listChargeRuns",
                                        "method": "GET",
                                        "path": "/charge-runs",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "patchCheckoutAssignment",
                                        "method": "PATCH",
                                        "path": "/checkout/assignments/{locationId}",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "patchMetadata",
                                        "method": "PATCH",
                                        "path": "/metadata",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "priceQuote",
                                        "method": "POST",
                                        "path": "/price",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "putAttributionOverrides",
                                        "method": "PUT",
                                        "path": "/attribution-overrides",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "putCheckoutPlan",
                                        "method": "PUT",
                                        "path": "/checkout",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "putProcessingStatement",
                                        "method": "PUT",
                                        "path": "/processing-statement",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed",
                                            "statement-file-not-owned",
                                            "statement-file-missing",
                                            "statement-file-already-recorded",
                                            "quote-statement-already-attached",
                                            "statement-not-found",
                                            "statement-location-mismatch",
                                            "statement-file-unreadable"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "removeCoupon",
                                        "method": "DELETE",
                                        "path": "/coupons/{code}",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "removeFeeAdjustment",
                                        "method": "DELETE",
                                        "path": "/fee-adjustments/{feeKey}",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "sendCheckoutLink",
                                        "method": "POST",
                                        "path": "/checkout/send",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "startChargeRun",
                                        "method": "POST",
                                        "path": "/charge-runs",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateItem",
                                        "method": "PATCH",
                                        "path": "/items/{itemId}",
                                        "errors": [
                                            "feature-disabled",
                                            "quote-not-editable",
                                            "quote-not-priceable",
                                            "quote-processing-statement-required",
                                            "quote-requires-brand",
                                            "quote-scope-brand-mismatch",
                                            "quote-brand-not-found",
                                            "quote-brand-not-in-scope",
                                            "quote-location-brand-mismatch",
                                            "quote-primary-brand-not-in-scope",
                                            "unknown-quote-product",
                                            "unsupported-quote-product-sale-context",
                                            "unsupported-quote-product-fulfillment",
                                            "invalid-quote-product-scope",
                                            "invalid-quote-product-config",
                                            "invalid-quote-item-quantity",
                                            "quote-item-exceeds-location-limit",
                                            "quote-item-not-created",
                                            "quote-item-not-found",
                                            "unknown-quote-coupon",
                                            "quote-coupon-not-created",
                                            "invalid-quote-status-transition",
                                            "quote-version-quote-mismatch",
                                            "quote-version-not-pending-approval",
                                            "quote-not-pending-approval",
                                            "quote-approval-requester-required",
                                            "quote-not-approved",
                                            "quote-version-not-approved",
                                            "quote-version-not-current",
                                            "quote-version-snapshot-invalid",
                                            "quote-approval-request-not-found",
                                            "not-billing-admin",
                                            "quote-approval-review-invalid",
                                            "quote-currency-mismatch",
                                            "quote-modifier-currency-mismatch",
                                            "quote-region-not-enabled",
                                            "quote-location-region-unsupported",
                                            "quote-product-not-available-in-region",
                                            "quote-installments-disabled",
                                            "quote-product-not-offered",
                                            "quote-installments-not-supported",
                                            "standard-subscription-plan-required",
                                            "standard-subscription-plan-not-found",
                                            "quote-price-binding-not-found",
                                            "quote-requires-item",
                                            "quote-billing-location-required",
                                            "quote-coupon-not-applicable",
                                            "quote-fee-adjustment-not-created",
                                            "quote-fee-adjustment-location-invalid",
                                            "checkout-session-requires-version",
                                            "checkout-version-not-found",
                                            "checkout-quote-not-found",
                                            "multi-brand-checkout-not-supported",
                                            "checkout-quote-missing-brand",
                                            "checkout-session-expiration-invalid",
                                            "checkout-version-quote-mismatch",
                                            "checkout-version-not-ready",
                                            "checkout-version-not-loaded",
                                            "checkout-version-not-current",
                                            "checkout-quote-not-ready",
                                            "quote-not-found",
                                            "quote-checkout-plan-not-found",
                                            "quote-checkout-assignment-not-found",
                                            "quote-checkout-location-not-in-quote",
                                            "quote-checkout-payment-allocation-invalid",
                                            "quote-not-chargeable",
                                            "quote-not-checkoutable",
                                            "quote-charge-requires-charges",
                                            "quote-charge-location-not-payable",
                                            "quote-charge-location-already-fulfilled",
                                            "quote-charge-card-owner-mismatch",
                                            "quote-charge-run-in-progress",
                                            "quote-charge-run-not-found",
                                            "quote-charge-run-unavailable",
                                            "quote-checkout-recipient-required",
                                            "quote-checkout-send-failed"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "versions",
                                        "path": "/versions",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "version",
                                                "path": "/{quoteVersionId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "approveVersion",
                                                        "method": "POST",
                                                        "path": "/approve",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "quote-not-editable",
                                                            "quote-not-priceable",
                                                            "quote-processing-statement-required",
                                                            "quote-requires-brand",
                                                            "quote-scope-brand-mismatch",
                                                            "quote-brand-not-found",
                                                            "quote-brand-not-in-scope",
                                                            "quote-location-brand-mismatch",
                                                            "quote-primary-brand-not-in-scope",
                                                            "unknown-quote-product",
                                                            "unsupported-quote-product-sale-context",
                                                            "unsupported-quote-product-fulfillment",
                                                            "invalid-quote-product-scope",
                                                            "invalid-quote-product-config",
                                                            "invalid-quote-item-quantity",
                                                            "quote-item-exceeds-location-limit",
                                                            "quote-item-not-created",
                                                            "quote-item-not-found",
                                                            "unknown-quote-coupon",
                                                            "quote-coupon-not-created",
                                                            "invalid-quote-status-transition",
                                                            "quote-version-quote-mismatch",
                                                            "quote-version-not-pending-approval",
                                                            "quote-not-pending-approval",
                                                            "quote-approval-requester-required",
                                                            "quote-not-approved",
                                                            "quote-version-not-approved",
                                                            "quote-version-not-current",
                                                            "quote-version-snapshot-invalid",
                                                            "quote-approval-request-not-found",
                                                            "not-billing-admin",
                                                            "quote-approval-review-invalid",
                                                            "quote-currency-mismatch",
                                                            "quote-modifier-currency-mismatch",
                                                            "quote-region-not-enabled",
                                                            "quote-location-region-unsupported",
                                                            "quote-product-not-available-in-region",
                                                            "quote-installments-disabled",
                                                            "quote-product-not-offered",
                                                            "quote-installments-not-supported",
                                                            "standard-subscription-plan-required",
                                                            "standard-subscription-plan-not-found",
                                                            "quote-price-binding-not-found",
                                                            "quote-requires-item",
                                                            "quote-billing-location-required",
                                                            "quote-coupon-not-applicable",
                                                            "quote-fee-adjustment-not-created",
                                                            "quote-fee-adjustment-location-invalid",
                                                            "checkout-session-requires-version",
                                                            "checkout-version-not-found",
                                                            "checkout-quote-not-found",
                                                            "multi-brand-checkout-not-supported",
                                                            "checkout-quote-missing-brand",
                                                            "checkout-session-expiration-invalid",
                                                            "checkout-version-quote-mismatch",
                                                            "checkout-version-not-ready",
                                                            "checkout-version-not-loaded",
                                                            "checkout-version-not-current",
                                                            "checkout-quote-not-ready",
                                                            "quote-not-found",
                                                            "quote-checkout-plan-not-found",
                                                            "quote-checkout-assignment-not-found",
                                                            "quote-checkout-location-not-in-quote",
                                                            "quote-checkout-payment-allocation-invalid",
                                                            "quote-not-chargeable",
                                                            "quote-not-checkoutable",
                                                            "quote-charge-requires-charges",
                                                            "quote-charge-location-not-payable",
                                                            "quote-charge-location-already-fulfilled",
                                                            "quote-charge-card-owner-mismatch",
                                                            "quote-charge-run-in-progress",
                                                            "quote-charge-run-not-found",
                                                            "quote-charge-run-unavailable",
                                                            "quote-checkout-recipient-required",
                                                            "quote-checkout-send-failed"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "rejectVersion",
                                                        "method": "POST",
                                                        "path": "/reject",
                                                        "errors": [
                                                            "feature-disabled",
                                                            "quote-not-editable",
                                                            "quote-not-priceable",
                                                            "quote-processing-statement-required",
                                                            "quote-requires-brand",
                                                            "quote-scope-brand-mismatch",
                                                            "quote-brand-not-found",
                                                            "quote-brand-not-in-scope",
                                                            "quote-location-brand-mismatch",
                                                            "quote-primary-brand-not-in-scope",
                                                            "unknown-quote-product",
                                                            "unsupported-quote-product-sale-context",
                                                            "unsupported-quote-product-fulfillment",
                                                            "invalid-quote-product-scope",
                                                            "invalid-quote-product-config",
                                                            "invalid-quote-item-quantity",
                                                            "quote-item-exceeds-location-limit",
                                                            "quote-item-not-created",
                                                            "quote-item-not-found",
                                                            "unknown-quote-coupon",
                                                            "quote-coupon-not-created",
                                                            "invalid-quote-status-transition",
                                                            "quote-version-quote-mismatch",
                                                            "quote-version-not-pending-approval",
                                                            "quote-not-pending-approval",
                                                            "quote-approval-requester-required",
                                                            "quote-not-approved",
                                                            "quote-version-not-approved",
                                                            "quote-version-not-current",
                                                            "quote-version-snapshot-invalid",
                                                            "quote-approval-request-not-found",
                                                            "not-billing-admin",
                                                            "quote-approval-review-invalid",
                                                            "quote-currency-mismatch",
                                                            "quote-modifier-currency-mismatch",
                                                            "quote-region-not-enabled",
                                                            "quote-location-region-unsupported",
                                                            "quote-product-not-available-in-region",
                                                            "quote-installments-disabled",
                                                            "quote-product-not-offered",
                                                            "quote-installments-not-supported",
                                                            "standard-subscription-plan-required",
                                                            "standard-subscription-plan-not-found",
                                                            "quote-price-binding-not-found",
                                                            "quote-requires-item",
                                                            "quote-billing-location-required",
                                                            "quote-coupon-not-applicable",
                                                            "quote-fee-adjustment-not-created",
                                                            "quote-fee-adjustment-location-invalid",
                                                            "checkout-session-requires-version",
                                                            "checkout-version-not-found",
                                                            "checkout-quote-not-found",
                                                            "multi-brand-checkout-not-supported",
                                                            "checkout-quote-missing-brand",
                                                            "checkout-session-expiration-invalid",
                                                            "checkout-version-quote-mismatch",
                                                            "checkout-version-not-ready",
                                                            "checkout-version-not-loaded",
                                                            "checkout-version-not-current",
                                                            "checkout-quote-not-ready",
                                                            "quote-not-found",
                                                            "quote-checkout-plan-not-found",
                                                            "quote-checkout-assignment-not-found",
                                                            "quote-checkout-location-not-in-quote",
                                                            "quote-checkout-payment-allocation-invalid",
                                                            "quote-not-chargeable",
                                                            "quote-not-checkoutable",
                                                            "quote-charge-requires-charges",
                                                            "quote-charge-location-not-payable",
                                                            "quote-charge-location-already-fulfilled",
                                                            "quote-charge-card-owner-mismatch",
                                                            "quote-charge-run-in-progress",
                                                            "quote-charge-run-not-found",
                                                            "quote-charge-run-unavailable",
                                                            "quote-checkout-recipient-required",
                                                            "quote-checkout-send-failed"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setupPurchase",
                        "method": "POST",
                        "path": "/setup-purchase",
                        "errors": []
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "search",
        "path": "/search",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "search",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "universal-search-not-enabled"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "seo",
        "path": "/seo",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "blockArea",
                                        "method": "DELETE",
                                        "path": "/areas/{slug}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "checkLocationName",
                                        "method": "POST",
                                        "path": "/check-location-name",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "createGbpPostForCoupon",
                                        "method": "POST",
                                        "path": "/gbp-post-for-coupon",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "fetchKeywords",
                                        "method": "GET",
                                        "path": "/keywords",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "fetchKeywordsWithTypes",
                                        "method": "GET",
                                        "path": "/keywords-with-types",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getCuisineAnalysis",
                                        "method": "GET",
                                        "path": "/cuisine/analysis",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getKeywordsAppliedForBrand",
                                        "method": "GET",
                                        "path": "/applied-keywords",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "keywordOverrides",
                                        "path": "/keyword-overrides",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "deleteKeywordOverride",
                                                "method": "DELETE",
                                                "path": "/{keywordSlug}",
                                                "errors": [
                                                    "override-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listKeywordOverrides",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listKeywordOverridesByPage",
                                                "method": "GET",
                                                "path": "/by-page/{pageId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "unlinkPage",
                                                "method": "POST",
                                                "path": "/unlink-page/{pageId}",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "upsertKeywordOverride",
                                                "method": "PUT",
                                                "path": "/{keywordSlug}",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "keywordPreview",
                                        "method": "POST",
                                        "path": "/keyword-preview",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "locations",
                                        "path": "/locations",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "location",
                                                "path": "/{locationId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "confirmPowerListingEmailSent",
                                                        "method": "POST",
                                                        "path": "/power-listing-email-sent",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "router",
                                                        "name": "gbpVerification",
                                                        "path": "/gbp-verification",
                                                        "children": [
                                                            {
                                                                "type": "endpoint",
                                                                "name": "complete",
                                                                "method": "POST",
                                                                "path": "/complete",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "initiate",
                                                                "method": "POST",
                                                                "path": "/initiate",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "options",
                                                                "method": "GET",
                                                                "path": "/options",
                                                                "errors": []
                                                            },
                                                            {
                                                                "type": "endpoint",
                                                                "name": "refresh",
                                                                "method": "POST",
                                                                "path": "/refresh",
                                                                "errors": []
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getGbpPlaceActionLinks",
                                                        "method": "GET",
                                                        "path": "/gbp-place-action-links",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getGbpStoreCodeLookup",
                                                        "method": "GET",
                                                        "path": "/gbp-store-code-lookup",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getGbpVerificationWorkflowStatus",
                                                        "method": "GET",
                                                        "path": "/gbp-verification-workflow-status",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getListingSyncBlockers",
                                                        "method": "GET",
                                                        "path": "/listing-sync-blockers",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getListingSyncStatus",
                                                        "method": "GET",
                                                        "path": "/listing-sync-status",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getPlaceDetails",
                                                        "method": "GET",
                                                        "path": "/place-details",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "setYextSyncExempt",
                                                        "method": "POST",
                                                        "path": "/yext-sync-exempt",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "triggerGbpListingStatusScan",
                                                        "method": "POST",
                                                        "path": "/trigger-gbp-listing-status-scan",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "refreshKeywords",
                                        "method": "PUT",
                                        "path": "/keywords/refresh",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "unblockArea",
                                        "method": "POST",
                                        "path": "/areas/{slug}",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateManualH1Override",
                                        "method": "PUT",
                                        "path": "/manual-h1-override",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "cuisines",
                        "path": "/cuisines",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getAllCuisines",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getCuisineKeywords",
                                "method": "GET",
                                "path": "/{cuisine}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "searchKeywords",
                                "method": "POST",
                                "path": "/search",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "keywords",
                        "path": "/keywords",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "importKeywordsForCuisine",
                                "method": "POST",
                                "path": "/import-for-cuisine",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "overwritePrimaryKeywordForCuisine",
                                "method": "POST",
                                "path": "/overwrite-primary-keyword-for-cuisine",
                                "errors": [
                                    "primary-keyword-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "removeKeywordsByExactMatch",
                                "method": "POST",
                                "path": "/remove-by-exact-match",
                                "errors": [
                                    "no-keywords-provided",
                                    "too-many-keywords",
                                    "no-keywords-matched"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getPreLiveRankCheckStatus",
                                        "method": "GET",
                                        "path": "/pre-live-rank-check-status",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "triggerPreLiveRankCheck",
                                        "method": "POST",
                                        "path": "/trigger-pre-live-rank-check",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "cuisines",
                        "path": "/cuisines",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getCuisineKeywords",
                                "method": "GET",
                                "path": "/{cuisine}",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "sms",
        "path": "/sms",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "appstoreconnectOtp",
                        "path": "/appstoreconnect-otp",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getAppstoreconnectOtp",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getSmsMarketingSettings",
                                        "method": "GET",
                                        "path": "/marketing",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSmsMarketingSettings",
                                        "method": "PATCH",
                                        "path": "/marketing",
                                        "errors": [
                                            "sms-settings-not-found",
                                            "sms-settings-failed",
                                            "unable-to-setup",
                                            "marketing-sms-not-available",
                                            "registration-in-progress",
                                            "registration-failed"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getInactiveMessagingServices",
                        "method": "GET",
                        "path": "/inactive-messaging-services",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "mfaOtp",
                        "path": "/mfa-otp",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "deleteSeededTotp",
                                "method": "DELETE",
                                "path": "/seed-totp/{authId}",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getMfaOtp",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "seedTotp",
                                "method": "POST",
                                "path": "/seed-totp",
                                "errors": [
                                    "not-found"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "social",
        "path": "/social",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "channels",
                                        "path": "/channels",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "connection",
                                        "path": "/connection",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "start",
                                                "method": "POST",
                                                "path": "/start",
                                                "errors": [
                                                    "invalid-state",
                                                    "state-expired",
                                                    "state-consumed",
                                                    "invalid-auth-code",
                                                    "missing-scope",
                                                    "provider-error",
                                                    "not-configured",
                                                    "feature-disabled"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "media",
                                        "path": "/media",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "complete",
                                                "method": "POST",
                                                "path": "/{mediaId}/complete",
                                                "errors": [
                                                    "feature-disabled",
                                                    "not-found",
                                                    "invalid-upload"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "uploadUrl",
                                                "method": "POST",
                                                "path": "/upload-url",
                                                "errors": [
                                                    "feature-disabled"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "posts",
                                        "path": "/posts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "cancelSchedule",
                                                "method": "POST",
                                                "path": "/{postId}/cancel-schedule",
                                                "errors": [
                                                    "feature-disabled",
                                                    "not-found",
                                                    "invalid-status"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "create",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled",
                                                    "invalid-channels",
                                                    "blocked-channels",
                                                    "invalid-media",
                                                    "media-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "destroy",
                                                "method": "DELETE",
                                                "path": "/{postId}",
                                                "errors": [
                                                    "feature-disabled",
                                                    "not-found",
                                                    "not-a-draft"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/{postId}",
                                                "errors": [
                                                    "feature-disabled",
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "feature-disabled"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "publish",
                                                "method": "POST",
                                                "path": "/{postId}/publish",
                                                "errors": [
                                                    "feature-disabled",
                                                    "post-not-found",
                                                    "nothing-to-publish",
                                                    "channel-needs-reauth",
                                                    "blocked-gbp-channels",
                                                    "invalid-media",
                                                    "publish-unavailable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "schedule",
                                                "method": "POST",
                                                "path": "/{postId}/schedule",
                                                "errors": [
                                                    "feature-disabled",
                                                    "not-found",
                                                    "invalid-status",
                                                    "invalid-channels",
                                                    "blocked-gbp-channels",
                                                    "invalid-media",
                                                    "invalid-schedule-time"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "PATCH",
                                                "path": "/{postId}",
                                                "errors": [
                                                    "feature-disabled",
                                                    "not-found",
                                                    "not-a-draft",
                                                    "invalid-channels",
                                                    "invalid-media",
                                                    "media-not-found"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "media",
                        "path": "/media",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "get",
                                "method": "GET",
                                "path": "/",
                                "errors": [
                                    "media-not-found"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "oauth",
                        "path": "/oauth",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "callback",
                                "method": "GET",
                                "path": "/callback",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "stations",
        "path": "/stations",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "cloudprnt",
                        "path": "/cloudprnt",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "settings",
                                "method": "GET",
                                "path": "/{fileName}",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "createStation",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getStations",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "location",
                        "path": "/location/{locationId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "fogRouting",
                                "method": "PUT",
                                "path": "/fog-routing",
                                "errors": [
                                    "not-configured",
                                    "location-not-found",
                                    "pos-hub-error",
                                    "feature-disabled"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "printJobs",
                        "path": "/print-jobs",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getPrintJob",
                                "method": "GET",
                                "path": "/{printJobToken}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getPrintJobs",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "station",
                        "path": "/station/{stationId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "deleteStation",
                                "method": "DELETE",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "devices",
                                "path": "/devices",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "device",
                                        "path": "/{deviceId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "assign",
                                                "method": "POST",
                                                "path": "/assign",
                                                "errors": [
                                                    "device-not-found",
                                                    "device-type-exists-at-station",
                                                    "station-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "heartbeat",
                                                "method": "POST",
                                                "path": "/heartbeat",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "unassign",
                                                "method": "POST",
                                                "path": "/unassign",
                                                "errors": [
                                                    "device-not-found",
                                                    "device-type-exists-at-station",
                                                    "station-not-found"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "swap",
                                        "method": "POST",
                                        "path": "/swap",
                                        "errors": [
                                            "source-station-not-found",
                                            "target-station-not-found",
                                            "source-device-not-found",
                                            "target-device-not-found",
                                            "device-types-mismatch"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getStation",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "nodeBindingObservation",
                                "method": "POST",
                                "path": "/node-binding-observation",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "receiveMessages",
                                "method": "GET",
                                "path": "/receive-messages",
                                "errors": [],
                                "subGroup": "poll"
                            },
                            {
                                "type": "router",
                                "name": "routing",
                                "path": "/routing",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "getRules",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateConfig",
                                        "method": "PUT",
                                        "path": "/",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "sendMessage",
                                "method": "POST",
                                "path": "/send-message",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updateStation",
                                "method": "PUT",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "createStation",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "getStations",
                        "method": "GET",
                        "path": "/",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "station",
                        "path": "/station/{stationId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "claim",
                                "method": "POST",
                                "path": "/claim",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "forceClaim",
                                "method": "POST",
                                "path": "/force-claim",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getStation",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "release",
                                "method": "POST",
                                "path": "/release",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updateStation",
                                "method": "PUT",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "support",
        "path": "/support",
        "children": [
            {
                "type": "router",
                "name": "externalConversations",
                "path": "/external-conversations",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "close",
                        "method": "POST",
                        "path": "/{conversationId}/close",
                        "errors": [
                            "external-conversation-not-found",
                            "must-be-created-with-direct-chat-ref",
                            "conversation-does-not-belong-to-brand",
                            "could-not-assign-agent",
                            "could-not-send-message",
                            "could-not-send-note",
                            "could-not-close-conversation",
                            "could-not-escalate-conversation",
                            "could-not-request-human-in-the-loop",
                            "could-not-determine-spam-status",
                            "could-not-get-previous-conversations",
                            "brand-id-missing"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "escalate",
                        "method": "POST",
                        "path": "/{conversationId}/escalate",
                        "errors": [
                            "external-conversation-not-found",
                            "must-be-created-with-direct-chat-ref",
                            "conversation-does-not-belong-to-brand",
                            "could-not-assign-agent",
                            "could-not-send-message",
                            "could-not-send-note",
                            "could-not-close-conversation",
                            "could-not-escalate-conversation",
                            "could-not-request-human-in-the-loop",
                            "could-not-determine-spam-status",
                            "could-not-get-previous-conversations",
                            "brand-id-missing"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "get",
                        "method": "GET",
                        "path": "/{conversationId}",
                        "errors": [
                            "external-conversation-not-found",
                            "must-be-created-with-direct-chat-ref",
                            "brand-id-missing"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getAll",
                        "method": "GET",
                        "path": "/",
                        "errors": [
                            "external-conversation-not-found",
                            "must-be-created-with-direct-chat-ref",
                            "brand-id-missing"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getAllAcrossBrands",
                        "method": "GET",
                        "path": "/queues/across-brands",
                        "errors": [
                            "invalid-cursor"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getDetails",
                        "method": "GET",
                        "path": "/{conversationId}/details",
                        "errors": [
                            "external-conversation-not-found",
                            "must-be-created-with-direct-chat-ref",
                            "brand-id-missing"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "taxes",
        "path": "/taxes",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "taxes",
                                        "path": "/taxes",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createBrandTax",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "location-not-in-brand"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listBrandTaxes",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "tax",
                                                "path": "/{brandTaxId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteBrandTax",
                                                        "method": "DELETE",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getBrandTax",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateBrandTax",
                                                        "method": "PATCH",
                                                        "path": "/",
                                                        "errors": [
                                                            "location-not-in-brand",
                                                            "not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "test",
        "path": "/test",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "brandScopedUser",
                        "method": "POST",
                        "path": "/brand-scoped-user",
                        "errors": [
                            "testing-env-only"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "coverage",
                        "path": "/e2e-coverage",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "dumpCoverage",
                                "method": "GET",
                                "path": "/dump",
                                "errors": [
                                    "testing-env-only"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resetCoverage",
                                "method": "POST",
                                "path": "/reset",
                                "errors": [
                                    "testing-env-only"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "takeCoverage",
                                "method": "POST",
                                "path": "/take",
                                "errors": [
                                    "testing-env-only"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "ensureActiveStripeAccount",
                        "method": "POST",
                        "path": "/ensure-active-stripe-account",
                        "errors": [
                            "testing-env-only",
                            "location-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getGuestPhotoItemImage",
                        "method": "GET",
                        "path": "/guest-photo-item-image/{itemId}",
                        "errors": [
                            "testing-env-only"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "getMibTestState",
                        "method": "GET",
                        "path": "/mib-test-state",
                        "errors": [
                            "not-enabled"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "nacho",
                        "path": "/nacho",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "seedApplication",
                                "method": "POST",
                                "path": "/seed-application",
                                "errors": [
                                    "testing-env-only"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "phoneAiEvals",
                        "method": "POST",
                        "path": "/phone-ai-evals",
                        "errors": [
                            "staging-only"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "runMarketingJobs",
                        "method": "POST",
                        "path": "/run-marketing-jobs",
                        "errors": [
                            "testing-env-only"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "seed",
                        "method": "POST",
                        "path": "/seed",
                        "errors": [
                            "unsupported-entity",
                            "testing-env-only"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "seedBrand",
                        "method": "POST",
                        "path": "/seed-brand",
                        "errors": [
                            "testing-env-only"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "seedGuestPhotoSubmission",
                        "method": "POST",
                        "path": "/seed-guest-photo-submission",
                        "errors": [
                            "testing-env-only"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "seedLocation",
                        "method": "POST",
                        "path": "/seed-location",
                        "errors": [
                            "testing-env-only",
                            "location-country-mismatch",
                            "invalid-address",
                            "unsupported-region"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "setMibTestState",
                        "method": "POST",
                        "path": "/set-mib-test-state",
                        "errors": [
                            "not-enabled"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "simulateGoogleReview",
                        "method": "POST",
                        "path": "/simulate-google-review",
                        "errors": [
                            "not-allowed-in-prod"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "stripeMock",
                        "path": "/stripe-mock",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "disableStripeMock",
                                "method": "POST",
                                "path": "/disable",
                                "errors": [
                                    "testing-env-only"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "enableStripeMock",
                                "method": "POST",
                                "path": "/enable",
                                "errors": [
                                    "testing-env-only"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "resetStripeMock",
                                "method": "POST",
                                "path": "/reset",
                                "errors": [
                                    "testing-env-only",
                                    "mock-not-enabled"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "stripeProvision",
                        "method": "POST",
                        "path": "/stripe-provision",
                        "errors": [
                            "staging-only"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "stripeRewrite",
                        "method": "POST",
                        "path": "/stripe-rewrite",
                        "errors": [
                            "staging-only"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "uberGrader",
                        "path": "/uber-grader",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "completeSubmission",
                                "method": "POST",
                                "path": "/complete-submission",
                                "errors": [
                                    "testing-env-only",
                                    "submission-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "createSubmissionFromPipeline",
                                "method": "POST",
                                "path": "/create-submission-from-pipeline",
                                "errors": [
                                    "pipeline-not-eligible",
                                    "testing-env-only"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getReport",
                                "method": "GET",
                                "path": "/stores/{uberStoreId}/report",
                                "errors": [
                                    "report-not-found",
                                    "testing-env-only"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "seedApplication",
                                "method": "POST",
                                "path": "/seed-application",
                                "errors": [
                                    "testing-env-only"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "timeTracking",
        "path": "/time-tracking",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "reporting",
                                        "path": "/reporting",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "shifts",
                                                "path": "/shifts",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getShiftSummary",
                                                        "method": "GET",
                                                        "path": "/summary",
                                                        "errors": [
                                                            "duplicate-shift-start",
                                                            "event-not-allowed",
                                                            "no-active-shift",
                                                            "duplicate-break-start",
                                                            "no-active-break",
                                                            "shift-not-found",
                                                            "break-not-found",
                                                            "job-not-found",
                                                            "location-not-found",
                                                            "shift-required-after-validation",
                                                            "shift-not-created",
                                                            "invalid-event-type",
                                                            "concurrent-event-conflict",
                                                            "no-events-provided",
                                                            "no-breaks-provided",
                                                            "invalid-time-range",
                                                            "break-outside-shift-bounds",
                                                            "breaks-overlap",
                                                            "duration-exceeds-limit",
                                                            "shift-voided",
                                                            "break-voided",
                                                            "timestamp-in-future",
                                                            "break-missing-end-time",
                                                            "shift-overlaps-existing",
                                                            "unauthorized",
                                                            "brand-not-found",
                                                            "location-brand-mismatch",
                                                            "brand-no-locations"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "shifts",
                                        "path": "/shifts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getEmployeeShifts",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "totals",
                                                "path": "/totals",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getShiftsTotals",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "locations",
                        "path": "/locations",
                        "children": [
                            {
                                "type": "router",
                                "name": "location",
                                "path": "/{locationId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "breaks",
                                        "path": "/breaks",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "break",
                                                "path": "/{breakId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteBreak",
                                                        "method": "DELETE",
                                                        "path": "/",
                                                        "errors": [
                                                            "duplicate-shift-start",
                                                            "event-not-allowed",
                                                            "no-active-shift",
                                                            "duplicate-break-start",
                                                            "no-active-break",
                                                            "shift-not-found",
                                                            "break-not-found",
                                                            "job-not-found",
                                                            "location-not-found",
                                                            "shift-required-after-validation",
                                                            "shift-not-created",
                                                            "invalid-event-type",
                                                            "concurrent-event-conflict",
                                                            "no-events-provided",
                                                            "no-breaks-provided",
                                                            "invalid-time-range",
                                                            "break-outside-shift-bounds",
                                                            "breaks-overlap",
                                                            "duration-exceeds-limit",
                                                            "shift-voided",
                                                            "break-voided",
                                                            "timestamp-in-future",
                                                            "break-missing-end-time",
                                                            "shift-overlaps-existing",
                                                            "unauthorized",
                                                            "brand-not-found",
                                                            "location-brand-mismatch",
                                                            "brand-no-locations"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "shifts",
                                        "path": "/shifts",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createEmployeeShift",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "duplicate-shift-start",
                                                    "event-not-allowed",
                                                    "no-active-shift",
                                                    "duplicate-break-start",
                                                    "no-active-break",
                                                    "shift-not-found",
                                                    "break-not-found",
                                                    "job-not-found",
                                                    "location-not-found",
                                                    "shift-required-after-validation",
                                                    "shift-not-created",
                                                    "invalid-event-type",
                                                    "concurrent-event-conflict",
                                                    "no-events-provided",
                                                    "no-breaks-provided",
                                                    "invalid-time-range",
                                                    "break-outside-shift-bounds",
                                                    "breaks-overlap",
                                                    "duration-exceeds-limit",
                                                    "shift-voided",
                                                    "break-voided",
                                                    "timestamp-in-future",
                                                    "break-missing-end-time",
                                                    "shift-overlaps-existing",
                                                    "unauthorized",
                                                    "brand-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations"
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "shift",
                                                "path": "/{shiftId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "addBreaksToShift",
                                                        "method": "POST",
                                                        "path": "/",
                                                        "errors": [
                                                            "duplicate-shift-start",
                                                            "event-not-allowed",
                                                            "no-active-shift",
                                                            "duplicate-break-start",
                                                            "no-active-break",
                                                            "shift-not-found",
                                                            "break-not-found",
                                                            "job-not-found",
                                                            "location-not-found",
                                                            "shift-required-after-validation",
                                                            "shift-not-created",
                                                            "invalid-event-type",
                                                            "concurrent-event-conflict",
                                                            "no-events-provided",
                                                            "no-breaks-provided",
                                                            "invalid-time-range",
                                                            "break-outside-shift-bounds",
                                                            "breaks-overlap",
                                                            "duration-exceeds-limit",
                                                            "shift-voided",
                                                            "break-voided",
                                                            "timestamp-in-future",
                                                            "break-missing-end-time",
                                                            "shift-overlaps-existing",
                                                            "unauthorized",
                                                            "brand-not-found",
                                                            "location-brand-mismatch",
                                                            "brand-no-locations"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "deleteShift",
                                                        "method": "DELETE",
                                                        "path": "/",
                                                        "errors": [
                                                            "duplicate-shift-start",
                                                            "event-not-allowed",
                                                            "no-active-shift",
                                                            "duplicate-break-start",
                                                            "no-active-break",
                                                            "shift-not-found",
                                                            "break-not-found",
                                                            "job-not-found",
                                                            "location-not-found",
                                                            "shift-required-after-validation",
                                                            "shift-not-created",
                                                            "invalid-event-type",
                                                            "concurrent-event-conflict",
                                                            "no-events-provided",
                                                            "no-breaks-provided",
                                                            "invalid-time-range",
                                                            "break-outside-shift-bounds",
                                                            "breaks-overlap",
                                                            "duration-exceeds-limit",
                                                            "shift-voided",
                                                            "break-voided",
                                                            "timestamp-in-future",
                                                            "break-missing-end-time",
                                                            "shift-overlaps-existing",
                                                            "unauthorized",
                                                            "brand-not-found",
                                                            "location-brand-mismatch",
                                                            "brand-no-locations"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getEmployeeShift",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "overrideEmployeeShift",
                                                        "method": "PUT",
                                                        "path": "/",
                                                        "errors": [
                                                            "duplicate-shift-start",
                                                            "event-not-allowed",
                                                            "no-active-shift",
                                                            "duplicate-break-start",
                                                            "no-active-break",
                                                            "shift-not-found",
                                                            "break-not-found",
                                                            "job-not-found",
                                                            "location-not-found",
                                                            "shift-required-after-validation",
                                                            "shift-not-created",
                                                            "invalid-event-type",
                                                            "concurrent-event-conflict",
                                                            "no-events-provided",
                                                            "no-breaks-provided",
                                                            "invalid-time-range",
                                                            "break-outside-shift-bounds",
                                                            "breaks-overlap",
                                                            "duration-exceeds-limit",
                                                            "shift-voided",
                                                            "break-voided",
                                                            "timestamp-in-future",
                                                            "break-missing-end-time",
                                                            "shift-overlaps-existing",
                                                            "unauthorized",
                                                            "brand-not-found",
                                                            "location-brand-mismatch",
                                                            "brand-no-locations"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateEmployeeShift",
                                                        "method": "PATCH",
                                                        "path": "/",
                                                        "errors": [
                                                            "duplicate-shift-start",
                                                            "event-not-allowed",
                                                            "no-active-shift",
                                                            "duplicate-break-start",
                                                            "no-active-break",
                                                            "shift-not-found",
                                                            "break-not-found",
                                                            "job-not-found",
                                                            "location-not-found",
                                                            "shift-required-after-validation",
                                                            "shift-not-created",
                                                            "invalid-event-type",
                                                            "concurrent-event-conflict",
                                                            "no-events-provided",
                                                            "no-breaks-provided",
                                                            "invalid-time-range",
                                                            "break-outside-shift-bounds",
                                                            "breaks-overlap",
                                                            "duration-exceeds-limit",
                                                            "shift-voided",
                                                            "break-voided",
                                                            "timestamp-in-future",
                                                            "break-missing-end-time",
                                                            "shift-overlaps-existing",
                                                            "unauthorized",
                                                            "brand-not-found",
                                                            "location-brand-mismatch",
                                                            "brand-no-locations"
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "submitClockEvent",
                                                "method": "POST",
                                                "path": "/events",
                                                "errors": [
                                                    "duplicate-shift-start",
                                                    "event-not-allowed",
                                                    "no-active-shift",
                                                    "duplicate-break-start",
                                                    "no-active-break",
                                                    "shift-not-found",
                                                    "break-not-found",
                                                    "job-not-found",
                                                    "location-not-found",
                                                    "shift-required-after-validation",
                                                    "shift-not-created",
                                                    "invalid-event-type",
                                                    "concurrent-event-conflict",
                                                    "no-events-provided",
                                                    "no-breaks-provided",
                                                    "invalid-time-range",
                                                    "break-outside-shift-bounds",
                                                    "breaks-overlap",
                                                    "duration-exceeds-limit",
                                                    "shift-voided",
                                                    "break-voided",
                                                    "timestamp-in-future",
                                                    "break-missing-end-time",
                                                    "shift-overlaps-existing",
                                                    "unauthorized",
                                                    "brand-not-found",
                                                    "location-brand-mismatch",
                                                    "brand-no-locations"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "users",
                                        "path": "/users",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "shifts",
                                                "path": "/shifts",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getActiveShift",
                                                        "method": "GET",
                                                        "path": "/active",
                                                        "errors": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "tools",
        "path": "/tools",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands/{brandId}",
                        "children": [
                            {
                                "type": "router",
                                "name": "campaignGeneration",
                                "path": "/campaign-generation",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "bootstraps",
                                        "path": "/bootstraps",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "create",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "not-enabled"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/{bootstrapId}",
                                                "errors": [
                                                    "not-enabled"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "generations",
                                        "path": "/generations",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "create",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "not-enabled"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/{generationId}",
                                                "errors": [
                                                    "not-enabled"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "newMenuItem",
                                        "method": "POST",
                                        "path": "/new-menu-item",
                                        "errors": [
                                            "not-enabled",
                                            "item-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "newMenuItemGeneration",
                                        "method": "GET",
                                        "path": "/new-menu-item/generations/{pipelineExecutionId}",
                                        "errors": [
                                            "not-enabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "newMenuItemGenerations",
                                        "method": "GET",
                                        "path": "/new-menu-item/generations",
                                        "errors": [
                                            "not-enabled"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "previewComparison",
                                        "method": "GET",
                                        "path": "/campaigns/{campaignSlug}/templates/{templatePosition}/preview-comparison",
                                        "errors": [
                                            "not-enabled"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "funnelMigration",
                                "path": "/funnel-migration",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "attempts",
                                        "path": "/attempts/{attemptId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "abortAttempt",
                                                "method": "POST",
                                                "path": "/abort",
                                                "errors": [
                                                    "attempt-not-found",
                                                    "attempt-not-abortable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "approveAttempt",
                                                "method": "POST",
                                                "path": "/approve",
                                                "errors": [
                                                    "attempt-not-found",
                                                    "attempt-not-approvable",
                                                    "attempt-workflow-not-running"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "cutoverAttempt",
                                                "method": "POST",
                                                "path": "/cutover",
                                                "errors": [
                                                    "attempt-not-found",
                                                    "attempt-not-cutoverable",
                                                    "migration-workflow-busy"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getAttempt",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "attempt-not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "rollbackAttempt",
                                                "method": "POST",
                                                "path": "/rollback",
                                                "errors": [
                                                    "attempt-not-found",
                                                    "attempt-not-rollbackable",
                                                    "migration-workflow-busy"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "dryRun",
                                        "method": "POST",
                                        "path": "/dry-run",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listAttempts",
                                        "method": "GET",
                                        "path": "/attempts",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "startAttempt",
                                        "method": "POST",
                                        "path": "/attempts",
                                        "errors": []
                                    }
                                ]
                            },
                            {
                                "type": "router",
                                "name": "scout",
                                "path": "/scout",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "generate",
                                        "method": "POST",
                                        "path": "/generate",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getScoutEmbedUrl",
                                        "method": "GET",
                                        "path": "/embed-url",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "jobs",
                                        "path": "/jobs/{jobId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getArtifacts",
                                                "method": "GET",
                                                "path": "/artifacts",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getJob",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSpec",
                                                "method": "GET",
                                                "path": "/spec",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "importMenu",
                                                "method": "POST",
                                                "path": "/import-menu",
                                                "errors": [
                                                    "location-not-in-brand"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "importSpec",
                                                "method": "POST",
                                                "path": "/import",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "killJob",
                                                "method": "POST",
                                                "path": "/kill",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "restartJob",
                                                "method": "POST",
                                                "path": "/restart",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listJobs",
                                        "method": "GET",
                                        "path": "/jobs",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "locationPlaceIds",
                                        "method": "GET",
                                        "path": "/location-place-ids",
                                        "errors": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "menuDiff",
                        "path": "/menu-diff",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "pipelineApplied",
                                "method": "POST",
                                "path": "/pipeline-applied",
                                "errors": [
                                    "menu-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "pipelineAppliedRunKey",
                                "method": "GET",
                                "path": "/pipeline-applied/run-key",
                                "errors": [
                                    "menu-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "pipelineAppliedStatus",
                                "method": "GET",
                                "path": "/pipeline-applied/status",
                                "errors": [
                                    "job-not-found"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "scoutMenu",
                                "method": "GET",
                                "path": "/scout-menu",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "endpoint",
        "name": "uberOAuthAuthorize",
        "method": "GET",
        "path": "/oauth/uber/authorize",
        "errors": [
            "uber-oauth-unavailable"
        ],
        "subGroup": "*"
    },
    {
        "type": "endpoint",
        "name": "uberOAuthCallback",
        "method": "GET",
        "path": "/oauth/uber/callback",
        "errors": [],
        "subGroup": "*"
    },
    {
        "type": "endpoint",
        "name": "uberOAuthComplete",
        "method": "POST",
        "path": "/oauth/uber/complete",
        "errors": [
            "invalid-handoff",
            "unauthenticated",
            "invalid-link",
            "guest-mismatch",
            "phone_mismatch",
            "no_uber_phone",
            "no_session_phone",
            "session_missing",
            "token_persist_failed",
            "linked_tokens_missing",
            "subject_linked_elsewhere",
            "account_already_linked"
        ],
        "subGroup": "*"
    },
    {
        "type": "endpoint",
        "name": "uberOAuthKickoff",
        "method": "POST",
        "path": "/oauth/uber/kickoff",
        "errors": [
            "uber-oauth-unavailable",
            "no-lineage"
        ],
        "subGroup": "*"
    },
    {
        "type": "endpoint",
        "name": "uploadImage",
        "method": "POST",
        "path": "/upload-image",
        "errors": []
    },
    {
        "type": "router",
        "name": "userNotifications",
        "path": "/user-notifications",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "notificationPreferences",
                        "path": "/notification-preferences",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getNotificationPreferences",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "updateNotificationPreferences",
                                "method": "PATCH",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "pushDevices",
                        "path": "/push-devices",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "register",
                                "method": "POST",
                                "path": "/register",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "unregister",
                                "method": "DELETE",
                                "path": "/unregister",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "users",
        "path": "/users",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "admins",
                                        "path": "/admins",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "upsertBrandAdmin",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "existing-brand-relationship",
                                                    "insufficient-location-access",
                                                    "invalid-email"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "staff",
                                        "path": "/staff",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createStaffMember",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "email-in-use",
                                                    "phone-in-use",
                                                    "missing-identifiers",
                                                    "invalid-email",
                                                    "user-access-provision-failed",
                                                    "job-not-found",
                                                    "insufficient-location-access"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "paginateStaffMembers",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resolveHistoricalStaffMembers",
                                                "method": "POST",
                                                "path": "/historical/batch",
                                                "errors": []
                                            },
                                            {
                                                "type": "router",
                                                "name": "staffMember",
                                                "path": "/{userId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getPin",
                                                        "method": "GET",
                                                        "path": "/pin",
                                                        "errors": [
                                                            "not-authorized",
                                                            "not-found",
                                                            "super-user-no-pin"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "resetPin",
                                                        "method": "POST",
                                                        "path": "/reset-pin",
                                                        "errors": [
                                                            "user-not-found",
                                                            "reset-pin-failed"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "setPin",
                                                        "method": "POST",
                                                        "path": "/pin",
                                                        "errors": [
                                                            "invalid-pin",
                                                            "user-not-found",
                                                            "set-pin-failed"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateStaffMember",
                                                        "method": "PUT",
                                                        "path": "/",
                                                        "errors": [
                                                            "email-in-use",
                                                            "phone-in-use",
                                                            "missing-identifiers",
                                                            "invalid-email",
                                                            "user-not-found",
                                                            "brand-relationship-not-found",
                                                            "job-not-found",
                                                            "user-access-update-failed",
                                                            "insufficient-location-access"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "requiredActions",
                        "method": "GET",
                        "path": "/required-actions",
                        "errors": [
                            "service-error"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "users",
                        "path": "/users",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createUser",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "email-in-use",
                                    "phone-in-use",
                                    "missing-identifiers"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "paginateUsers",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "user",
                                "path": "/{userId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "addPhoneNumber",
                                        "method": "POST",
                                        "path": "/add-phone-number",
                                        "errors": [
                                            "invalid-phone-number"
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "brands",
                                        "path": "/brands",
                                        "children": [
                                            {
                                                "type": "router",
                                                "name": "brand",
                                                "path": "/{brandId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "attachToBrand",
                                                        "method": "PUT",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getNotificationSettings",
                                                        "method": "GET",
                                                        "path": "/notifications",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "removeBrandAccess",
                                                        "method": "DELETE",
                                                        "path": "/",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateNotificationSettings",
                                                        "method": "PATCH",
                                                        "path": "/notifications",
                                                        "errors": []
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "updateRelationship",
                                                        "method": "PATCH",
                                                        "path": "/",
                                                        "errors": []
                                                    }
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "paginateBrands",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "no-user-session",
                                                    "user-id-mismatch"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "deleteUser",
                                        "method": "DELETE",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getBrandRelationships",
                                        "method": "GET",
                                        "path": "/brands-relationship",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getUser",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": [
                                            "user-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "mergeUsers",
                                        "method": "POST",
                                        "path": "/merge",
                                        "errors": [
                                            "invalid-otp",
                                            "merge-not-allowed"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "startMerge",
                                        "method": "POST",
                                        "path": "/start-merge",
                                        "errors": [
                                            "user-not-found",
                                            "same-user"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateSmsMarketingConsent",
                                        "method": "POST",
                                        "path": "/sms-marketing-consent",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateUser",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "email-in-use",
                                            "phone-in-use",
                                            "validation-error"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "verifyPhoneNumberOtp",
                                        "method": "POST",
                                        "path": "/verify-phone-number-otp",
                                        "errors": [
                                            "invalid-otp",
                                            "invalid-phone-number",
                                            "invalid-payload"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands",
                        "children": [
                            {
                                "type": "router",
                                "name": "brand",
                                "path": "/{brandId}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "admins",
                                        "path": "/admins",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "upsertBrandAdmin",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": [
                                                    "existing-brand-relationship",
                                                    "insufficient-location-access",
                                                    "invalid-email"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "voice",
        "path": "/voice",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "calls",
                        "path": "/calls",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "createVoiceCall",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "product-forbidden"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "voiceCall",
                                "path": "/{callId}",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "ingestVoiceCallCostUsage",
                                        "method": "POST",
                                        "path": "/cost-usage",
                                        "errors": [
                                            "not-found",
                                            "product-forbidden"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "ingestVoiceCallEvents",
                                        "method": "POST",
                                        "path": "/events",
                                        "errors": [
                                            "call-id-mismatch",
                                            "not-found",
                                            "product-forbidden"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "storeVoiceCallSessionReport",
                                        "method": "POST",
                                        "path": "/session-report",
                                        "errors": [
                                            "not-found",
                                            "product-forbidden"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "updateVoiceCall",
                                        "method": "PATCH",
                                        "path": "/",
                                        "errors": [
                                            "not-found",
                                            "product-forbidden"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "exportGuestForVoice",
                        "method": "GET",
                        "path": "/guest",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "exportLocationForVoice",
                        "method": "GET",
                        "path": "/location",
                        "errors": [
                            "not-found"
                        ]
                    },
                    {
                        "type": "router",
                        "name": "phoneOrdering",
                        "path": "/phone-ordering",
                        "children": [
                            {
                                "type": "router",
                                "name": "calls",
                                "path": "/calls",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "createPhoneOrderingCall",
                                        "method": "POST",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listPhoneOrderingCalls",
                                        "method": "GET",
                                        "path": "/",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "phoneOrderingCall",
                                        "path": "/{callId}",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getPhoneOrderingCall",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "ingestPhoneOrderingEvents",
                                                "method": "POST",
                                                "path": "/events",
                                                "errors": [
                                                    "call-id-mismatch",
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "reviewPhoneOrderingCall",
                                                "method": "PATCH",
                                                "path": "/review",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "storePhoneOrderingSessionReport",
                                                "method": "POST",
                                                "path": "/session-report",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updatePhoneOrderingCall",
                                                "method": "PATCH",
                                                "path": "/",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "getPhoneOrderingLanguageNotes",
                                "method": "GET",
                                "path": "/brand-language-notes/{brandId}",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getPhoneOrderingLatencyDiagnostics",
                                "method": "GET",
                                "path": "/latency-diagnostics",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getPhoneOrderingPerformanceMetrics",
                                "method": "GET",
                                "path": "/performance-metrics",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "resolvePhoneOrderingTransferTarget",
                                "method": "GET",
                                "path": "/transfer-target",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "searchPhoneOrderingTranscripts",
                                "method": "GET",
                                "path": "/transcript-search",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "products",
                        "path": "/products",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listProducts",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "product",
                                "path": "/{product}",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "calls",
                                        "path": "/calls",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "listProductCalls",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "not-found"
                                                ]
                                            },
                                            {
                                                "type": "router",
                                                "name": "productCall",
                                                "path": "/{callId}",
                                                "children": [
                                                    {
                                                        "type": "endpoint",
                                                        "name": "createProductLiveKitToken",
                                                        "method": "POST",
                                                        "path": "/livekit-token",
                                                        "errors": [
                                                            "not-found",
                                                            "unavailable"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "getProductCall",
                                                        "method": "GET",
                                                        "path": "/",
                                                        "errors": [
                                                            "not-found"
                                                        ]
                                                    },
                                                    {
                                                        "type": "endpoint",
                                                        "name": "reviewProductCall",
                                                        "method": "PATCH",
                                                        "path": "/review",
                                                        "errors": [
                                                            "not-found"
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPhoneAiWaitlistAnalytics",
                                        "method": "GET",
                                        "path": "/phone-ai-waitlist",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPhoneRoutingBusinessMetrics",
                                        "method": "GET",
                                        "path": "/business-metrics",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPhoneRoutingLocationMetrics",
                                        "method": "GET",
                                        "path": "/location-metrics",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getPhoneRoutingLocationPerformance",
                                        "method": "GET",
                                        "path": "/locations/{locationId}/performance",
                                        "errors": [
                                            "location-not-found",
                                            "product-not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getProductEconomicsMetrics",
                                        "method": "GET",
                                        "path": "/economics-metrics",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getProductLatencyDiagnostics",
                                        "method": "GET",
                                        "path": "/latency-diagnostics",
                                        "errors": [
                                            "not-supported"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "getProductPerformanceMetrics",
                                        "method": "GET",
                                        "path": "/performance-metrics",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "listPhoneRoutingEnrollments",
                                        "method": "GET",
                                        "path": "/enrollments",
                                        "errors": [
                                            "not-found"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "searchProductTranscripts",
                                        "method": "GET",
                                        "path": "/transcript-search",
                                        "errors": [
                                            "not-found"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "warehouseFulfillment",
        "path": "/warehouse-fulfillment",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "exception",
                        "method": "POST",
                        "path": "/exception",
                        "errors": [
                            "order-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "fulfillment",
                        "method": "POST",
                        "path": "/fulfillment",
                        "errors": [
                            "order-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "returnReceipt",
                        "method": "POST",
                        "path": "/return-receipt",
                        "errors": [
                            "order-not-found"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "salesforceOrderLink",
                        "method": "POST",
                        "path": "/salesforce-order-link",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "sfdcOrderStatus",
                        "method": "POST",
                        "path": "/sfdc-order-status",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "status",
                        "method": "POST",
                        "path": "/status",
                        "errors": [
                            "order-not-found"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "webhooks",
        "path": "/webhooks",
        "children": [
            {
                "type": "router",
                "name": "calcom",
                "path": "/calcom",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "calcomWebhook",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "calendly",
                "path": "/calendly",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "calendlyWebhook",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "cloudconvert",
                "path": "/cloudconvert",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "cloudconvertWebhook",
                        "method": "POST",
                        "path": "/cloudconvert",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "clover",
                "path": "/clover",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "authorize",
                        "method": "GET",
                        "path": "/authorize",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "webhook",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "invalid-auth-token"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "customerio",
                "path": "/customerio",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "unsubscribe",
                        "method": "POST",
                        "path": "/unsubscribe",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "dnsimple",
                "path": "/dnsimple",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "dnsimple",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "doorDash",
                "path": "/doordash",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "deliveryStatus",
                        "method": "POST",
                        "path": "/delivery-status",
                        "errors": [
                            "delivery-status-update",
                            "unauthorized",
                            "order-not-found"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "growthService",
                "path": "/growth-service",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "growthServiceWebhook",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "website-import-in-progress",
                            "website-import-failed"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "intercom",
                "path": "/intercom",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "notification",
                        "method": "POST",
                        "path": "/notification",
                        "errors": [
                            "invalid-signature"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "livekit",
                "path": "/livekit",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "phoneOrderingEgress",
                        "method": "POST",
                        "path": "/phone-ordering-egress",
                        "errors": [
                            "invalid-webhook",
                            "missing-request-body",
                            "webhook-not-configured"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "voiceEgress",
                        "method": "POST",
                        "path": "/voice-egress",
                        "errors": [
                            "invalid-webhook",
                            "missing-request-body",
                            "webhook-not-configured"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "loyalty",
                "path": "/loyalty",
                "children": [
                    {
                        "type": "router",
                        "name": "hang",
                        "path": "/hang",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "hangWebhook",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "mailgun",
                "path": "/mailgun",
                "children": [
                    {
                        "type": "router",
                        "name": "message",
                        "path": "/message",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "status",
                                "method": "POST",
                                "path": "/status",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "marketplace",
                "path": "/marketplace",
                "children": [
                    {
                        "type": "router",
                        "name": "doordash",
                        "path": "/doordash",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "cancelWebhook",
                                "method": "POST",
                                "path": "/orders/cancel",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "dasherStatusWebhook",
                                "method": "POST",
                                "path": "/dasher-status",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "menuRequestWebhook",
                                "method": "GET",
                                "path": "/menu-request/:id",
                                "errors": [
                                    "feature-disabled",
                                    "unauthorized",
                                    "marketplace-not-enabled",
                                    "no-synced-menus",
                                    "all-menus-fetch-failed",
                                    "menu-request-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "menuStatusWebhook",
                                "method": "POST",
                                "path": "/menu-status",
                                "errors": [
                                    "menu-status-update-failed",
                                    "unauthorized",
                                    "store-not-found",
                                    "feature-disabled"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "onboardingStatusWebhook",
                                "method": "POST",
                                "path": "/onboarding-status",
                                "errors": [
                                    "feature-disabled",
                                    "unauthorized",
                                    "webhook-processing-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "orderWebhook",
                                "method": "POST",
                                "path": "/orders",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "storeDeactivationWebhook",
                                "method": "POST",
                                "path": "/store-deactivation",
                                "errors": [
                                    "feature-disabled",
                                    "unauthorized"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "grubhub",
                        "path": "/grubhub",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "activationStatus",
                                "method": "POST",
                                "path": "/activation-status",
                                "errors": [
                                    "unauthorized"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "deliveryUpdatesWebhook",
                                "method": "POST",
                                "path": "/delivery-status",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "menuIngestionStatusWebhook",
                                "method": "POST",
                                "path": "/menu-ingestion-status",
                                "errors": [
                                    "unauthorized",
                                    "webhook-processing-failed"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "merchantAvailability",
                                "method": "POST",
                                "path": "/merchant-availability",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "merchantPosConfigUpdate",
                                "method": "POST",
                                "path": "/merchant-pos-config-update",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "orderValidationWebhook",
                                "method": "POST",
                                "path": "/order-validation",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "orderWebhook",
                                "method": "POST",
                                "path": "/orders",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "ubereats",
                        "path": "/ubereats",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "orderWebhook",
                                "method": "POST",
                                "path": "/orders",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "storeLifecycle",
                                "method": "POST",
                                "path": "/store-lifecycle",
                                "errors": [
                                    "unauthorized",
                                    "feature-disabled",
                                    "webhook-processing-failed"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "type": "endpoint",
                "name": "otter",
                "method": "POST",
                "path": "/otter",
                "errors": [
                    "location-not-found",
                    "order-not-found",
                    "validation-error"
                ]
            },
            {
                "type": "endpoint",
                "name": "parallel",
                "method": "POST",
                "path": "/parallel",
                "errors": [
                    "invalid-webhook-signature",
                    "invalid-webhook-payload",
                    "issue-processing-webhook"
                ]
            },
            {
                "type": "router",
                "name": "physicalMedia",
                "path": "/physical-media",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "cardExpress",
                        "method": "POST",
                        "path": "/card-express",
                        "errors": [
                            "unauthorized"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "posintegration",
                "path": "/posintegration",
                "children": [
                    {
                        "type": "router",
                        "name": "uber",
                        "path": "/uber",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "webhook",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "posthog",
                "path": "/posthog",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "seoAlert",
                        "method": "POST",
                        "path": "/seo-alert",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "postmark",
                "path": "/postmark",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "postmarkBounceWebhook",
                        "method": "POST",
                        "path": "/bounce",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "postmarkDeliveryWebhook",
                        "method": "POST",
                        "path": "/delivery",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "postmarkInboundWebhook",
                        "method": "POST",
                        "path": "/inbound",
                        "errors": [
                            "unauthorized"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "postmates",
                "path": "/postmates",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "deliveryStatus",
                        "method": "POST",
                        "path": "/delivery-status",
                        "errors": [
                            "delivery-status-update",
                            "order-not-found",
                            "signature-verification"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "privacy",
                "path": "/privacy",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "privacyWebhook",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "invalid-webhook-signature",
                            "invalid-webhook-payload",
                            "missing-webhook-signature"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "push",
                "path": "/push",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "status",
                        "method": "POST",
                        "path": "/status",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "quo",
                "path": "/quo",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "incoming",
                        "method": "POST",
                        "path": "/incoming",
                        "errors": [
                            "unauthorized",
                            "payloadTooLarge"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "scaleserp",
                "path": "/scaleserp",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "batchComplete",
                        "method": "POST",
                        "path": "/batch-complete",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "scout",
                "path": "/scout",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "scoutWebhook",
                        "method": "POST",
                        "path": "/",
                        "errors": [
                            "website-import-failed"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "slack",
                "path": "/slack",
                "children": [
                    {
                        "type": "router",
                        "name": "casey",
                        "path": "/casey",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "slackEventsWebhook",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "klausWynn",
                        "path": "/klaus-wynn",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "listAdminsSlashCommand",
                                "method": "POST",
                                "path": "/list-admins",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "newAdminSlashCommand",
                                "method": "POST",
                                "path": "/new-admin",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "removeAdminSlashCommand",
                                "method": "POST",
                                "path": "/remove-admin",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "slackEventsWebhook",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "tickets",
                        "path": "/tickets",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "slackEventsWebhook",
                                "method": "POST",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "square",
                "path": "/square",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "authorize",
                        "method": "GET",
                        "path": "/authorize",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "stripe",
                "path": "/stripe",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "connect",
                        "method": "POST",
                        "path": "/connect",
                        "errors": [
                            "missing-request-body",
                            "signature-verification-error"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "connectCustom",
                        "method": "POST",
                        "path": "/connect-custom",
                        "errors": [
                            "missing-request-body",
                            "signature-verification-error"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "subscription",
                        "method": "POST",
                        "path": "/subscription",
                        "errors": [
                            "missing-request-body",
                            "signature-verification-error"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "toast",
                "path": "/toast",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "webhook",
                        "method": "POST",
                        "path": "/",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "twilio",
                "path": "/twilio",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "a2pStatus",
                        "method": "POST",
                        "path": "/a2p-status",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "call",
                        "method": "POST",
                        "path": "/call",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "debuggingEvents",
                        "method": "POST",
                        "path": "/debugging-events",
                        "errors": []
                    },
                    {
                        "type": "router",
                        "name": "message",
                        "path": "/message",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "incoming",
                                "method": "POST",
                                "path": "/",
                                "errors": [
                                    "unauthorized"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "status",
                                "method": "POST",
                                "path": "/status",
                                "errors": [
                                    "unauthorized"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "router",
                        "name": "phoneTree",
                        "path": "/phone-tree",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "callStatus",
                                "method": "POST",
                                "path": "/call-status",
                                "errors": [
                                    "unauthorized"
                                ]
                            },
                            {
                                "type": "router",
                                "name": "demo",
                                "path": "/demo",
                                "children": [
                                    {
                                        "type": "endpoint",
                                        "name": "callStatus",
                                        "method": "POST",
                                        "path": "/call-status",
                                        "errors": [
                                            "invalid-destination",
                                            "unauthorized"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "handleDialpadInput",
                                        "method": "POST",
                                        "path": "/handle-dialpad-input",
                                        "errors": [
                                            "invalid-destination",
                                            "unauthorized"
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "incomingCall",
                                        "method": "POST",
                                        "path": "/incoming-call",
                                        "errors": [
                                            "invalid-destination",
                                            "unauthorized"
                                        ]
                                    }
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "handleDialpadInput",
                                "method": "POST",
                                "path": "/handle-dialpad-input",
                                "errors": [
                                    "unauthorized"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "incomingCall",
                                "method": "POST",
                                "path": "/incoming-call",
                                "errors": [
                                    "unauthorized"
                                ]
                            },
                            {
                                "type": "endpoint",
                                "name": "transferCallStatus",
                                "method": "POST",
                                "path": "/transfer-call-status",
                                "errors": [
                                    "unauthorized"
                                ]
                            }
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "recordingStatus",
                        "method": "POST",
                        "path": "/recording-status",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "tfvStatus",
                        "method": "POST",
                        "path": "/tfv-status",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "transcriptStatus",
                        "method": "POST",
                        "path": "/transcript-status",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "transferAmd",
                        "method": "POST",
                        "path": "/transfer-amd",
                        "errors": [
                            "unauthorized"
                        ]
                    },
                    {
                        "type": "endpoint",
                        "name": "transferStatus",
                        "method": "POST",
                        "path": "/transfer-status",
                        "errors": [
                            "unauthorized"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "uberEats",
                "path": "/uber-eats",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "deliveryStatus",
                        "method": "POST",
                        "path": "/delivery-status",
                        "errors": [
                            "delivery-status-update",
                            "order-not-found",
                            "signature-verification"
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "woflow",
                "path": "/woflow",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "syncMenu",
                        "method": "POST",
                        "path": "/sync-menu",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "yext",
                "path": "/yext",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "addRequestUpdate",
                        "method": "POST",
                        "path": "/add-request-update",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "entityUpdate",
                        "method": "POST",
                        "path": "/entity-update",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "listingsUpdate",
                        "method": "POST",
                        "path": "/listing-update",
                        "errors": []
                    },
                    {
                        "type": "endpoint",
                        "name": "processYextReviewEvent",
                        "method": "POST",
                        "path": "/review",
                        "errors": []
                    }
                ]
            },
            {
                "type": "router",
                "name": "zapier",
                "path": "/zapier",
                "children": [
                    {
                        "type": "endpoint",
                        "name": "iosApprovalStatus",
                        "method": "POST",
                        "path": "/ios-approval-status",
                        "errors": [
                            "invalid-signature",
                            "invalid-message-format",
                            "app-not-found"
                        ]
                    }
                ]
            }
        ]
    },
    {
        "type": "router",
        "name": "website",
        "path": "/website",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "brands",
                        "path": "/brands/{brandId}",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "exportWebsite",
                                "method": "GET",
                                "path": "/export-website",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getDraftPublishDate",
                                "method": "GET",
                                "path": "/publish-date",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getEditHistory",
                                "method": "GET",
                                "path": "/edit-history",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "getScoutPreviewStatus",
                                "method": "GET",
                                "path": "/scout-preview-status",
                                "errors": []
                            },
                            {
                                "type": "endpoint",
                                "name": "importWebsite",
                                "method": "POST",
                                "path": "/import-website",
                                "errors": []
                            },
                            {
                                "type": "router",
                                "name": "modules",
                                "path": "/modules",
                                "children": [
                                    {
                                        "type": "router",
                                        "name": "branding",
                                        "path": "/branding",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getHeadlineOverrideStatus",
                                                "method": "GET",
                                                "path": "/headline-override-status",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "careers",
                                        "path": "/careers",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "catering",
                                        "path": "/catering",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "contact",
                                        "path": "/contact",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "customPages",
                                        "path": "/custom-pages",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createPage",
                                                "method": "POST",
                                                "path": "/create",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "deletePage",
                                                "method": "POST",
                                                "path": "/delete",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listPages",
                                                "method": "GET",
                                                "path": "/list",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "downgrade",
                                        "path": "/downgrade",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "downgradeWebsites",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getPublishedWebsites",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "events",
                                        "path": "/events",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "featuredItems",
                                        "path": "/featured-items",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "giftCards",
                                        "path": "/gift-cards",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "heroPreview",
                                        "method": "GET",
                                        "path": "/hero-preview/get",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "home",
                                        "path": "/home",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "legal",
                                        "path": "/legal",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "locations",
                                        "path": "/locations",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "locationsIndex",
                                        "method": "GET",
                                        "path": "/locations-index/eligibility",
                                        "errors": []
                                    },
                                    {
                                        "type": "endpoint",
                                        "name": "metadata",
                                        "method": "GET",
                                        "path": "/metadata",
                                        "errors": []
                                    },
                                    {
                                        "type": "router",
                                        "name": "navigation",
                                        "path": "/navigation",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "onlineOrdering",
                                        "path": "/onlineOrdering",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "pdfMenus",
                                        "path": "/pdf-menus",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "popups",
                                        "path": "/popups",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "generateCopy",
                                                "method": "POST",
                                                "path": "/generate-copy",
                                                "errors": [
                                                    "coupon-not-found",
                                                    "coupon-not-web-redeemable"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "publish",
                                        "path": "/publish",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "getPublishStatus",
                                                "method": "GET",
                                                "path": "/status",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "postPublish",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "reservations",
                                        "path": "/reservations",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "reviews",
                                        "path": "/reviews",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "rewards",
                                        "path": "/rewards",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "sections",
                                        "path": "/sections",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "createSection",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "listSections",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": []
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSection",
                                                "method": "PATCH",
                                                "path": "/section",
                                                "errors": [
                                                    "section-not-found",
                                                    "section-does-not-belong-to-brand"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "seo",
                                        "path": "/seo",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "socialLinks",
                                        "path": "/social-links",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "story",
                                        "path": "/story",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "get",
                                                "method": "GET",
                                                "path": "/get",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "getSlots",
                                                "method": "GET",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "resetLatestDraft",
                                                "method": "POST",
                                                "path": "/reset-latest-draft",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "update",
                                                "method": "POST",
                                                "path": "/update",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "updateSlot",
                                                "method": "POST",
                                                "path": "/slots",
                                                "errors": [
                                                    "unexpected-error",
                                                    "publishing-rollback-incomplete",
                                                    "brand-not-found",
                                                    "state-record-not-found",
                                                    "state-record-conflict",
                                                    "invalid-state"
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "upgrade",
                                        "path": "/upgrade",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "upgradeWebsite",
                                                "method": "POST",
                                                "path": "/",
                                                "errors": []
                                            }
                                        ]
                                    },
                                    {
                                        "type": "router",
                                        "name": "versionHistory",
                                        "path": "/version-history",
                                        "children": [
                                            {
                                                "type": "endpoint",
                                                "name": "list",
                                                "method": "GET",
                                                "path": "/",
                                                "errors": [
                                                    "not-internal"
                                                ]
                                            },
                                            {
                                                "type": "endpoint",
                                                "name": "restore",
                                                "method": "POST",
                                                "path": "/{stateRecordId}/restore",
                                                "errors": [
                                                    "not-internal",
                                                    "preview-rebuild-failed",
                                                    "version-not-found"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "subGroup": "website-bff"
    },
    {
        "type": "router",
        "name": "yext",
        "path": "/yext",
        "children": [
            {
                "type": "router",
                "name": "v1",
                "path": "/v1",
                "children": [
                    {
                        "type": "router",
                        "name": "entities",
                        "path": "/",
                        "children": []
                    },
                    {
                        "type": "router",
                        "name": "reviews",
                        "path": "/reviews",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getYextReviews",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            },
            {
                "type": "router",
                "name": "v2",
                "path": "/v2",
                "children": [
                    {
                        "type": "router",
                        "name": "reviews",
                        "path": "/reviews",
                        "children": [
                            {
                                "type": "endpoint",
                                "name": "getYextReviews",
                                "method": "GET",
                                "path": "/",
                                "errors": []
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
//# sourceMappingURL=metadata.js.map